/* eslint-disable */
/* @ts-ignore */
/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */
 
declare const module: {
  hot?: {
    accept: () => void;
    status: () => string;
  };
};

// @ts-ignore
const isHotReloadEnabled = typeof module !== 'undefined' && module.hot;

if (isHotReloadEnabled) {
  // @ts-ignore
  module.hot.accept();
}
import * as Types from '@/shared/types/types.generated';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { baseAssetsApi } from '../../base-api';
export type DeviceSyncStatusFragment = { __typename: 'DeviceSyncStatusResponseType', previousSyncStatus?: Types.DeviceSyncStatusEnum, syncErrorMessage?: string, syncTimestamp?: any, syncType: Types.DeviceSyncTypeEnum, targetSyncStatus?: Types.DeviceSyncStatusEnum, syncJobId?: string };

export type DeviceFragment = { __typename: 'DeviceResponseType', deviceId: string, deviceType: Types.DeviceTypeEnum, vendorId: string, ideConfigId: string, groupId?: string, name: string, secretId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, description?: string, metaData?: any, ftpConfiguration?: { __typename: 'FtpConfigurationType', secretId?: string, ipAddress: string, port: number, rootDirectory?: string, protocol?: Types.FtpProtocolEnum }, smbConfiguration?: { __typename: 'SmbConfigurationType', secretId?: string, ipAddress: string, port: number, protocol?: Types.SmbProtocolEnum, rootDirectory?: string }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, linkedProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename: 'ProjectResponseType', projectType: Types.ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, linkMetaData?:
        | { __typename: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string }
        | { __typename: 'ProjectToProjectLinkMetaDataType' }
      , creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename: 'DeviceInformationType', name: string, deviceType: Types.DeviceTypeEnum, ethernetCommunication: Array<{ __typename: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceType: Types.DeviceTypeEnum }> }, linkedSubProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number } }> }, connectionConfiguration: { __typename: 'ConnectionConfigurationType', gatewayIpAddress?: string, ipAddress: string, port: number, subnetMask?: string }, linkedGateways: { __typename: 'PaginatedGatewayResponseType', itemCount: number, items: Array<{ __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, linkMetaData?: { __typename: 'DeviceToGatewayLinkMetaDataType', primary?: boolean }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: Types.OperatingSystemEnum }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: Types.ArchEnum, operatingSystem: Types.OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
          | { __typename: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
          | { __typename: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
         }, publicIp?: { __typename: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename: 'GatewayStateResponseType', reportedAt: any, state: Types.GatewayStateEnum }, location?: { __typename: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number } }> }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number } };

export type LinkedProjectFromDeviceFragment = { __typename: 'ProjectResponseType', projectType: Types.ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, linkMetaData?:
    | { __typename: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string }
    | { __typename: 'ProjectToProjectLinkMetaDataType' }
  , creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename: 'DeviceInformationType', name: string, deviceType: Types.DeviceTypeEnum, ethernetCommunication: Array<{ __typename: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceType: Types.DeviceTypeEnum }> }, linkedSubProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number } };

export type ProjectToDeviceLinkMetaDataFragment = { __typename: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string };

export type DeviceConnectivityStatusFragment = { __typename: 'DeviceConnectivityStatusReportType', gatewayId: string, reportedAt: any, deviceStatus: Types.DeviceInterfaceStatusEnum, devicePingStatus?: Types.PingStatusEnum, deviceNetcatStatus?: Types.NetcatStatusEnum, ftpStatus?: Types.DeviceInterfaceStatusEnum, ftpPingStatus?: Types.PingStatusEnum, ftpNetcatStatus?: Types.NetcatStatusEnum, smbStatus?: Types.DeviceInterfaceStatusEnum, smbPingStatus?: Types.PingStatusEnum, smbNetcatStatus?: Types.NetcatStatusEnum };

export type AccumulatedDeviceSyncStatusFragment = { __typename: 'AccumulatedDeviceSyncStatusResponseType', syncTimestamp?: any, targetSyncStatus: Types.DeviceSyncStatusEnum, previousSyncStatus: Types.DeviceSyncStatusEnum, details: Array<{ __typename: 'DeviceSyncStatusResponseType', previousSyncStatus?: Types.DeviceSyncStatusEnum, syncErrorMessage?: string, syncTimestamp?: any, syncType: Types.DeviceSyncTypeEnum, targetSyncStatus?: Types.DeviceSyncStatusEnum, syncJobId?: string }> };

export type DeviceFirmwareInformationDetailFragment = { __typename: 'DeviceFirmwareInformationDataType', deviceName: string, deviceType: string, articleNumber: string, firmwareVersion: string, slot?: string, configuration?: string, serialNumber?: string, hardwareVersion?: string };

export type DeviceFirmwareInformationFragment = { __typename: 'DeviceFirmwareInformationResponseType', readTimestamp?: any, details: Array<{ __typename: 'DeviceFirmwareInformationDataType', deviceName: string, deviceType: string, articleNumber: string, firmwareVersion: string, slot?: string, configuration?: string, serialNumber?: string, hardwareVersion?: string }> };

export type CreateDeviceMutationVariables = Types.Exact<{
  device: Types.CreateDeviceInput;
}>;


export type CreateDeviceMutation = { __typename: 'Mutation', createDevice: { __typename: 'DeviceResponseType', deviceId: string, groupId?: string } };

export type UpdateDeviceMutationVariables = Types.Exact<{
  deviceId: Types.Scalars['String']['input'];
  device: Types.UpdateDeviceInput;
}>;


export type UpdateDeviceMutation = { __typename: 'Mutation', updateDevice: { __typename: 'DeviceResponseType', groupId?: string, deviceId: string } };

export type DeleteDeviceMutationVariables = Types.Exact<{
  deviceId: Types.Scalars['String']['input'];
}>;


export type DeleteDeviceMutation = { __typename: 'Mutation', deleteDevice: { __typename: 'DeviceResponseType', groupId?: string, deviceId: string } };

export type ReadAllDevicesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.DeviceFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllDevicesQuery = { __typename: 'Query', readAllDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'DeviceResponseType', deviceId: string, deviceType: Types.DeviceTypeEnum, vendorId: string, ideConfigId: string, groupId?: string, name: string, secretId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, description?: string, metaData?: any, ftpConfiguration?: { __typename: 'FtpConfigurationType', secretId?: string, ipAddress: string, port: number, rootDirectory?: string, protocol?: Types.FtpProtocolEnum }, smbConfiguration?: { __typename: 'SmbConfigurationType', secretId?: string, ipAddress: string, port: number, protocol?: Types.SmbProtocolEnum, rootDirectory?: string }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, linkedProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename: 'ProjectResponseType', projectType: Types.ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, linkMetaData?:
            | { __typename: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string }
            | { __typename: 'ProjectToProjectLinkMetaDataType' }
          , creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename: 'DeviceInformationType', name: string, deviceType: Types.DeviceTypeEnum, ethernetCommunication: Array<{ __typename: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceType: Types.DeviceTypeEnum }> }, linkedSubProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number } }> }, connectionConfiguration: { __typename: 'ConnectionConfigurationType', gatewayIpAddress?: string, ipAddress: string, port: number, subnetMask?: string }, linkedGateways: { __typename: 'PaginatedGatewayResponseType', itemCount: number, items: Array<{ __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, linkMetaData?: { __typename: 'DeviceToGatewayLinkMetaDataType', primary?: boolean }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: Types.OperatingSystemEnum }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: Types.ArchEnum, operatingSystem: Types.OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
              | { __typename: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
              | { __typename: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
             }, publicIp?: { __typename: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename: 'GatewayStateResponseType', reportedAt: any, state: Types.GatewayStateEnum }, location?: { __typename: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number } }> }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number } }> } };

export type ReadDevicesByIdsQueryVariables = Types.Exact<{
  deviceIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type ReadDevicesByIdsQuery = { __typename: 'Query', readDevicesByIds: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceId: string, deviceType: Types.DeviceTypeEnum, vendorId: string, ideConfigId: string, groupId?: string, name: string, secretId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, description?: string, metaData?: any, ftpConfiguration?: { __typename: 'FtpConfigurationType', secretId?: string, ipAddress: string, port: number, rootDirectory?: string, protocol?: Types.FtpProtocolEnum }, smbConfiguration?: { __typename: 'SmbConfigurationType', secretId?: string, ipAddress: string, port: number, protocol?: Types.SmbProtocolEnum, rootDirectory?: string }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, linkedProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename: 'ProjectResponseType', projectType: Types.ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, linkMetaData?:
            | { __typename: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string }
            | { __typename: 'ProjectToProjectLinkMetaDataType' }
          , creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename: 'DeviceInformationType', name: string, deviceType: Types.DeviceTypeEnum, ethernetCommunication: Array<{ __typename: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceType: Types.DeviceTypeEnum }> }, linkedSubProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number } }> }, connectionConfiguration: { __typename: 'ConnectionConfigurationType', gatewayIpAddress?: string, ipAddress: string, port: number, subnetMask?: string }, linkedGateways: { __typename: 'PaginatedGatewayResponseType', itemCount: number, items: Array<{ __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, linkMetaData?: { __typename: 'DeviceToGatewayLinkMetaDataType', primary?: boolean }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: Types.OperatingSystemEnum }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: Types.ArchEnum, operatingSystem: Types.OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
              | { __typename: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
              | { __typename: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
             }, publicIp?: { __typename: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename: 'GatewayStateResponseType', reportedAt: any, state: Types.GatewayStateEnum }, location?: { __typename: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number } }> }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number } }> } };

export type ReadDeviceQueryVariables = Types.Exact<{
  deviceId: Types.Scalars['String']['input'];
}>;


export type ReadDeviceQuery = { __typename: 'Query', readDevice: { __typename: 'DeviceResponseType', deviceId: string, deviceType: Types.DeviceTypeEnum, vendorId: string, ideConfigId: string, groupId?: string, name: string, secretId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, description?: string, metaData?: any, ftpConfiguration?: { __typename: 'FtpConfigurationType', secretId?: string, ipAddress: string, port: number, rootDirectory?: string, protocol?: Types.FtpProtocolEnum }, smbConfiguration?: { __typename: 'SmbConfigurationType', secretId?: string, ipAddress: string, port: number, protocol?: Types.SmbProtocolEnum, rootDirectory?: string }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, linkedProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename: 'ProjectResponseType', projectType: Types.ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, linkMetaData?:
          | { __typename: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string }
          | { __typename: 'ProjectToProjectLinkMetaDataType' }
        , creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename: 'DeviceInformationType', name: string, deviceType: Types.DeviceTypeEnum, ethernetCommunication: Array<{ __typename: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceType: Types.DeviceTypeEnum }> }, linkedSubProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number } }> }, connectionConfiguration: { __typename: 'ConnectionConfigurationType', gatewayIpAddress?: string, ipAddress: string, port: number, subnetMask?: string }, linkedGateways: { __typename: 'PaginatedGatewayResponseType', itemCount: number, items: Array<{ __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, linkMetaData?: { __typename: 'DeviceToGatewayLinkMetaDataType', primary?: boolean }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: Types.OperatingSystemEnum }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: Types.ArchEnum, operatingSystem: Types.OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
            | { __typename: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
            | { __typename: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
           }, publicIp?: { __typename: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename: 'GatewayStateResponseType', reportedAt: any, state: Types.GatewayStateEnum }, location?: { __typename: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number } }> }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number } } };

export type ReadLinkedProjectsForDeviceQueryVariables = Types.Exact<{
  deviceId: Types.Scalars['String']['input'];
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadLinkedProjectsForDeviceQuery = { __typename: 'Query', readLinkedProjectsForDevice: { __typename: 'PaginatedProjectResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'ProjectResponseType', projectType: Types.ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, linkMetaData?:
        | { __typename: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string }
        | { __typename: 'ProjectToProjectLinkMetaDataType' }
      , creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename: 'DeviceInformationType', name: string, deviceType: Types.DeviceTypeEnum, ethernetCommunication: Array<{ __typename: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceType: Types.DeviceTypeEnum }> }, linkedSubProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number } }> } };

export type ReadDeviceSyncStatusQueryVariables = Types.Exact<{
  deviceId: Types.Scalars['String']['input'];
}>;


export type ReadDeviceSyncStatusQuery = { __typename: 'Query', readDevice: { __typename: 'DeviceResponseType', accumulatedSyncStatus: { __typename: 'AccumulatedDeviceSyncStatusResponseType', syncTimestamp?: any, targetSyncStatus: Types.DeviceSyncStatusEnum, previousSyncStatus: Types.DeviceSyncStatusEnum, details: Array<{ __typename: 'DeviceSyncStatusResponseType', previousSyncStatus?: Types.DeviceSyncStatusEnum, syncErrorMessage?: string, syncTimestamp?: any, syncType: Types.DeviceSyncTypeEnum, targetSyncStatus?: Types.DeviceSyncStatusEnum, syncJobId?: string }> } } };

export type ReadDeviceNamesForRoleRowQueryVariables = Types.Exact<{
  deviceIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type ReadDeviceNamesForRoleRowQuery = { __typename: 'Query', readDevicesByIds: { __typename: 'PaginatedDeviceResponseType', items: Array<{ __typename: 'DeviceResponseType', name: string, deviceId: string }> } };

export type ReadDeviceConnectivityStatusQueryVariables = Types.Exact<{
  deviceId: Types.Scalars['String']['input'];
}>;


export type ReadDeviceConnectivityStatusQuery = { __typename: 'Query', readDeviceConnectivityStatus: { __typename: 'DeviceConnectivityStatusType', deviceId: string, primaryGateway?: { __typename: 'DeviceConnectivityStatusReportType', gatewayId: string, reportedAt: any, deviceStatus: Types.DeviceInterfaceStatusEnum, devicePingStatus?: Types.PingStatusEnum, deviceNetcatStatus?: Types.NetcatStatusEnum, ftpStatus?: Types.DeviceInterfaceStatusEnum, ftpPingStatus?: Types.PingStatusEnum, ftpNetcatStatus?: Types.NetcatStatusEnum, smbStatus?: Types.DeviceInterfaceStatusEnum, smbPingStatus?: Types.PingStatusEnum, smbNetcatStatus?: Types.NetcatStatusEnum }, allGateways: Array<{ __typename: 'DeviceConnectivityStatusReportType', gatewayId: string, reportedAt: any, deviceStatus: Types.DeviceInterfaceStatusEnum, devicePingStatus?: Types.PingStatusEnum, deviceNetcatStatus?: Types.NetcatStatusEnum, ftpStatus?: Types.DeviceInterfaceStatusEnum, ftpPingStatus?: Types.PingStatusEnum, ftpNetcatStatus?: Types.NetcatStatusEnum, smbStatus?: Types.DeviceInterfaceStatusEnum, smbPingStatus?: Types.PingStatusEnum, smbNetcatStatus?: Types.NetcatStatusEnum }> } };

export type ReadDeviceFirmwareInformationQueryVariables = Types.Exact<{
  deviceId: Types.Scalars['String']['input'];
}>;


export type ReadDeviceFirmwareInformationQuery = { __typename: 'Query', readDevice: { __typename: 'DeviceResponseType', firmwareInformation?: { __typename: 'DeviceFirmwareInformationResponseType', readTimestamp?: any, details: Array<{ __typename: 'DeviceFirmwareInformationDataType', deviceName: string, deviceType: string, articleNumber: string, firmwareVersion: string, slot?: string, configuration?: string, serialNumber?: string, hardwareVersion?: string }> } } };

export type DocumentFragment = { __typename: 'DocumentResponseType', documentId: string, name: string, groupId?: string, documentType: Types.DocumentTypeEnum, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedDocumentVersionResponseType', itemCount: number, items: Array<{ __typename: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } }> } };

export type DocumentVersionFragment = { __typename: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } };

export type DocumentLinkedToAssetResponseFragment = { __typename: 'DocumentResponseType', documentId: string, name: string, groupId?: string, documentType: Types.DocumentTypeEnum, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, linkMetaData?: { __typename: 'DocumentToAssetLinkMetaDataType', assetVersionId?: string }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedDocumentVersionResponseType', itemCount: number, items: Array<{ __typename: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } }> } };

export type LinkedAssetFromDocumentFragment = { __typename: 'AssetLinkResponseType', destinationId: string, destinationType: Types.AssetTypeEnum, metaData:
    | { __typename: 'DeviceToDeviceLinkMetaDataType' }
    | { __typename: 'DeviceToGatewayLinkMetaDataType' }
    | { __typename: 'DocumentToAssetLinkMetaDataType', assetVersionId?: string }
    | { __typename: 'ProjectToDeviceLinkMetaDataType' }
    | { __typename: 'ProjectToProjectLinkMetaDataType' }
    | { __typename: 'TagToAssetLinkMetaDataType' }
   };

export type CompleteDocumentMultipartUploadMutationVariables = Types.Exact<{
  documentId: Types.Scalars['String']['input'];
  uploadId: Types.Scalars['String']['input'];
  completeUploadInput: Types.CompleteMultipartUploadInput;
  versionId: Types.Scalars['String']['input'];
}>;


export type CompleteDocumentMultipartUploadMutation = { __typename: 'Mutation', completeDocumentVersionMultipartUpload?: any };

export type CreateDocumentMutationVariables = Types.Exact<{
  document: Types.CreateDocumentInput;
}>;


export type CreateDocumentMutation = { __typename: 'Mutation', createDocument: { __typename: 'CreateDocumentResponseType', documentId: string, versionId: string, uploadId: string, uploadUrls: Array<{ __typename: 'S3MultipartUploadUrlType', partNumber: number, uploadUrl: string }> } };

export type CreateDocumentVersionMutationVariables = Types.Exact<{
  documentId: Types.Scalars['String']['input'];
  documentVersion: Types.CreateDocumentVersionInput;
}>;


export type CreateDocumentVersionMutation = { __typename: 'Mutation', createDocumentVersion: { __typename: 'DocumentVersionUploadURLResponseType', documentId: string, versionId: string, uploadId: string, uploadUrls: Array<{ __typename: 'S3MultipartUploadUrlType', partNumber: number, uploadUrl: string }> } };

export type DeleteDocumentMutationVariables = Types.Exact<{
  documentId: Types.Scalars['String']['input'];
}>;


export type DeleteDocumentMutation = { __typename: 'Mutation', deleteDocument: { __typename: 'DocumentResponseType', documentId: string } };

export type UpdateDocumentMutationVariables = Types.Exact<{
  documentId: Types.Scalars['String']['input'];
  document: Types.UpdateDocumentInput;
}>;


export type UpdateDocumentMutation = { __typename: 'Mutation', updateDocument: { __typename: 'DocumentResponseType', documentId: string, name: string, groupId?: string, documentType: Types.DocumentTypeEnum, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedDocumentVersionResponseType', itemCount: number, items: Array<{ __typename: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } }> } } };

export type UpdateDocumentVersionMutationVariables = Types.Exact<{
  documentId: Types.Scalars['String']['input'];
  versionId: Types.Scalars['String']['input'];
  documentVersion: Types.UpdateDocumentVersionInput;
}>;


export type UpdateDocumentVersionMutation = { __typename: 'Mutation', updateDocumentVersion: { __typename: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } } };

export type DownloadDocumentVersionQueryVariables = Types.Exact<{
  documentId: Types.Scalars['String']['input'];
  versionId: Types.Scalars['String']['input'];
}>;


export type DownloadDocumentVersionQuery = { __typename: 'Query', downloadDocumentVersion: { __typename: 'DocumentVersionDownloadURLResponseType', downloadUrl: string } };

export type ReadDocumentsByIdsQueryVariables = Types.Exact<{
  documentIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type ReadDocumentsByIdsQuery = { __typename: 'Query', readDocumentsByIds: { __typename: 'PaginatedDocumentResponseType', itemCount: number, items: Array<{ __typename: 'DocumentResponseType', documentId: string, name: string, groupId?: string, documentType: Types.DocumentTypeEnum, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedDocumentVersionResponseType', itemCount: number, items: Array<{ __typename: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } }> } }> } };

export type ReadDocumentQueryVariables = Types.Exact<{
  documentId: Types.Scalars['String']['input'];
}>;


export type ReadDocumentQuery = { __typename: 'Query', readDocument: { __typename: 'DocumentResponseType', documentId: string, name: string, groupId?: string, documentType: Types.DocumentTypeEnum, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedDocumentVersionResponseType', itemCount: number, items: Array<{ __typename: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } }> } } };

export type ReadAllDocumentsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.DocumentFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllDocumentsQuery = { __typename: 'Query', readAllDocuments: { __typename: 'PaginatedDocumentResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'DocumentResponseType', documentId: string, name: string, groupId?: string, documentType: Types.DocumentTypeEnum, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedDocumentVersionResponseType', itemCount: number, items: Array<{ __typename: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } }> } }> } };

export type ReadLinkedDocumentsForAssetQueryVariables = Types.Exact<{
  assetId: Types.Scalars['String']['input'];
  assetType: Types.AssetTypeEnum;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadLinkedDocumentsForAssetQuery = { __typename: 'Query', readLinkedDocumentsForAsset: { __typename: 'PaginatedDocumentResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'DocumentResponseType', documentId: string, name: string, groupId?: string, documentType: Types.DocumentTypeEnum, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, linkMetaData?: { __typename: 'DocumentToAssetLinkMetaDataType', assetVersionId?: string }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedDocumentVersionResponseType', itemCount: number, items: Array<{ __typename: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } }> } }> } };

export type ReadLinkedAssetsFromDocumentQueryVariables = Types.Exact<{
  documentId: Types.Scalars['String']['input'];
  pagination?: Types.InputMaybe<Types.PaginationInput>;
  filter?: Types.InputMaybe<Types.AssetLinkFilterInput>;
}>;


export type ReadLinkedAssetsFromDocumentQuery = { __typename: 'Query', readAllAssetLinksFromAsset: { __typename: 'PaginatedAssetLinkResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'AssetLinkResponseType', destinationId: string, destinationType: Types.AssetTypeEnum, metaData:
        | { __typename: 'DeviceToDeviceLinkMetaDataType' }
        | { __typename: 'DeviceToGatewayLinkMetaDataType' }
        | { __typename: 'DocumentToAssetLinkMetaDataType', assetVersionId?: string }
        | { __typename: 'ProjectToDeviceLinkMetaDataType' }
        | { __typename: 'ProjectToProjectLinkMetaDataType' }
        | { __typename: 'TagToAssetLinkMetaDataType' }
       }> } };

export type ReadVersionsForDocumentQueryVariables = Types.Exact<{
  documentId: Types.Scalars['String']['input'];
  filter?: Types.InputMaybe<Types.DocumentVersionFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadVersionsForDocumentQuery = { __typename: 'Query', readDocumentVersionsForDocument: { __typename: 'PaginatedDocumentVersionResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } }> } };

export type ReadDocumentNamesForRoleRowQueryVariables = Types.Exact<{
  documentIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type ReadDocumentNamesForRoleRowQuery = { __typename: 'Query', readDocumentsByIds: { __typename: 'PaginatedDocumentResponseType', items: Array<{ __typename: 'DocumentResponseType', name: string, documentId: string }> } };

export type AssetUserInfoFragment = { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean };

export type GatewayFragment = { __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: Types.OperatingSystemEnum }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: Types.ArchEnum, operatingSystem: Types.OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
      | { __typename: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
      | { __typename: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
     }, publicIp?: { __typename: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename: 'GatewayStateResponseType', reportedAt: any, state: Types.GatewayStateEnum }, location?: { __typename: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number } };

export type GatewaySetupTypeFragment = { __typename: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: Types.OperatingSystemEnum };

export type GatewaySetupCommandFragment = { __typename: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: Types.OperatingSystemEnum }> };

export type GatewayMetadataFragment = { __typename: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: Types.ArchEnum, operatingSystem: Types.OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
    | { __typename: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
    | { __typename: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
   };

export type GatewayPublicIpFragment = { __typename: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string };

export type GatewayLinkedToDeviceFragment = { __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, linkMetaData?: { __typename: 'DeviceToGatewayLinkMetaDataType', primary?: boolean }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: Types.OperatingSystemEnum }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: Types.ArchEnum, operatingSystem: Types.OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
      | { __typename: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
      | { __typename: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
     }, publicIp?: { __typename: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename: 'GatewayStateResponseType', reportedAt: any, state: Types.GatewayStateEnum }, location?: { __typename: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number } };

export type GatewayConfigFragment = { __typename: 'GatewayConfigResponseType', objectVersion?: number, reportedAt?: any, requestedAt?: any, values: { __typename: 'GlueConfigType', metaVersion: number, sslTunnel?: boolean, sslTunnelInsecure?: boolean, updateAuto?: boolean, updateUnstable?: boolean, webuiBase?: string, webuiEnabled?: boolean, webuiPort?: number } };

export type SyncedDeviceFragment = { __typename: 'DeviceResponseType', deviceId: string, deviceType: Types.DeviceTypeEnum, name: string, vendorId: string, accumulatedSyncStatus: { __typename: 'AccumulatedDeviceSyncStatusResponseType', syncTimestamp?: any, targetSyncStatus: Types.DeviceSyncStatusEnum, previousSyncStatus: Types.DeviceSyncStatusEnum, details: Array<{ __typename: 'DeviceSyncStatusResponseType', previousSyncStatus?: Types.DeviceSyncStatusEnum, syncErrorMessage?: string, syncTimestamp?: any, syncType: Types.DeviceSyncTypeEnum, targetSyncStatus?: Types.DeviceSyncStatusEnum, syncJobId?: string }> } };

export type DeleteGatewayMutationVariables = Types.Exact<{
  gatewayId: Types.Scalars['String']['input'];
}>;


export type DeleteGatewayMutation = { __typename: 'Mutation', deleteGateway: { __typename: 'GatewayResponseType', groupId?: string, gatewayId: string } };

export type CreateGatewayMutationVariables = Types.Exact<{
  gateway: Types.CreateGatewayInput;
}>;


export type CreateGatewayMutation = { __typename: 'Mutation', createGateway: { __typename: 'GatewayResponseType', groupId?: string, gatewayId: string } };

export type UpdateGatewayMutationVariables = Types.Exact<{
  gatewayId: Types.Scalars['String']['input'];
  gateway: Types.UpdateGatewayInput;
}>;


export type UpdateGatewayMutation = { __typename: 'Mutation', updateGateway: { __typename: 'GatewayResponseType', gatewayId: string, groupId?: string } };

export type UpdateGatewayConfigMutationVariables = Types.Exact<{
  gatewayId: Types.Scalars['String']['input'];
  config: Types.GatewayConfigUpdateInput;
}>;


export type UpdateGatewayConfigMutation = { __typename: 'Mutation', updateGatewayConfig: { __typename: 'GatewayConfigResponseType', objectVersion?: number } };

export type RequestGatewayUpdateMutationVariables = Types.Exact<{
  gatewayId: Types.Scalars['String']['input'];
}>;


export type RequestGatewayUpdateMutation = { __typename: 'Mutation', requestGatewayUpdate: { __typename: 'GatewayUpdateRequestType', requestedAt: any, version: string } };

export type ReadAllGatewaysQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.GatewayFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllGatewaysQuery = { __typename: 'Query', readAllGateways: { __typename: 'PaginatedGatewayResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: Types.OperatingSystemEnum }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: Types.ArchEnum, operatingSystem: Types.OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
          | { __typename: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
          | { __typename: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
         }, publicIp?: { __typename: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename: 'GatewayStateResponseType', reportedAt: any, state: Types.GatewayStateEnum }, location?: { __typename: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number } }> } };

export type ReadLinkedDevicesForGatewayQueryVariables = Types.Exact<{
  gatewayId: Types.Scalars['String']['input'];
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadLinkedDevicesForGatewayQuery = { __typename: 'Query', readLinkedDevicesForGateway: { __typename: 'PaginatedDeviceResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceId: string, deviceType: Types.DeviceTypeEnum, vendorId: string, ideConfigId: string, groupId?: string, name: string, secretId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, description?: string, metaData?: any, ftpConfiguration?: { __typename: 'FtpConfigurationType', secretId?: string, ipAddress: string, port: number, rootDirectory?: string, protocol?: Types.FtpProtocolEnum }, smbConfiguration?: { __typename: 'SmbConfigurationType', secretId?: string, ipAddress: string, port: number, protocol?: Types.SmbProtocolEnum, rootDirectory?: string }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, linkedProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename: 'ProjectResponseType', projectType: Types.ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, linkMetaData?:
            | { __typename: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string }
            | { __typename: 'ProjectToProjectLinkMetaDataType' }
          , creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename: 'DeviceInformationType', name: string, deviceType: Types.DeviceTypeEnum, ethernetCommunication: Array<{ __typename: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceType: Types.DeviceTypeEnum }> }, linkedSubProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number } }> }, connectionConfiguration: { __typename: 'ConnectionConfigurationType', gatewayIpAddress?: string, ipAddress: string, port: number, subnetMask?: string }, linkedGateways: { __typename: 'PaginatedGatewayResponseType', itemCount: number, items: Array<{ __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, linkMetaData?: { __typename: 'DeviceToGatewayLinkMetaDataType', primary?: boolean }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: Types.OperatingSystemEnum }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: Types.ArchEnum, operatingSystem: Types.OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
              | { __typename: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
              | { __typename: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
             }, publicIp?: { __typename: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename: 'GatewayStateResponseType', reportedAt: any, state: Types.GatewayStateEnum }, location?: { __typename: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number } }> }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number } }> } };

export type ReadGatewaysByIdsQueryVariables = Types.Exact<{
  gatewayIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type ReadGatewaysByIdsQuery = { __typename: 'Query', readGatewaysByIds: { __typename: 'PaginatedGatewayResponseType', itemCount: number, items: Array<{ __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: Types.OperatingSystemEnum }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: Types.ArchEnum, operatingSystem: Types.OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
          | { __typename: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
          | { __typename: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
         }, publicIp?: { __typename: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename: 'GatewayStateResponseType', reportedAt: any, state: Types.GatewayStateEnum }, location?: { __typename: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number } }> } };

export type ReadGatewayQueryVariables = Types.Exact<{
  gatewayId: Types.Scalars['String']['input'];
}>;


export type ReadGatewayQuery = { __typename: 'Query', readGateway: { __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: Types.OperatingSystemEnum }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: Types.ArchEnum, operatingSystem: Types.OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
        | { __typename: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
        | { __typename: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
       }, publicIp?: { __typename: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename: 'GatewayStateResponseType', reportedAt: any, state: Types.GatewayStateEnum }, location?: { __typename: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number } } };

export type ReadGatewayHealthStatusQueryVariables = Types.Exact<{
  gatewayId: Types.Scalars['String']['input'];
}>;


export type ReadGatewayHealthStatusQuery = { __typename: 'Query', readGatewayState?: { __typename: 'GatewayStateResponseType', reportedAt: any, state: Types.GatewayStateEnum } };

export type ReadGatewaysHealthStatusQueryVariables = Types.Exact<{
  gatewayIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type ReadGatewaysHealthStatusQuery = { __typename: 'Query', readGatewaysByIds: { __typename: 'PaginatedGatewayResponseType', items: Array<{ __typename: 'GatewayResponseType', gatewayId: string, state?: { __typename: 'GatewayStateResponseType', reportedAt: any, state: Types.GatewayStateEnum } }> } };

export type ReadGatewayNamesForRoleRowQueryVariables = Types.Exact<{
  gatewayIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type ReadGatewayNamesForRoleRowQuery = { __typename: 'Query', readGatewaysByIds: { __typename: 'PaginatedGatewayResponseType', items: Array<{ __typename: 'GatewayResponseType', name: string, gatewayId: string }> } };

export type ReadGatewayConfigQueryVariables = Types.Exact<{
  gatewayId: Types.Scalars['String']['input'];
}>;


export type ReadGatewayConfigQuery = { __typename: 'Query', readGatewayConfigReported?: { __typename: 'GatewayConfigResponseType', objectVersion?: number, reportedAt?: any, requestedAt?: any, values: { __typename: 'GlueConfigType', metaVersion: number, sslTunnel?: boolean, sslTunnelInsecure?: boolean, updateAuto?: boolean, updateUnstable?: boolean, webuiBase?: string, webuiEnabled?: boolean, webuiPort?: number } }, readGatewayConfigDesired?: { __typename: 'GatewayConfigResponseType', objectVersion?: number, reportedAt?: any, requestedAt?: any, values: { __typename: 'GlueConfigType', metaVersion: number, sslTunnel?: boolean, sslTunnelInsecure?: boolean, updateAuto?: boolean, updateUnstable?: boolean, webuiBase?: string, webuiEnabled?: boolean, webuiPort?: number } } };

export type ReadGatewayUpdateStatusQueryVariables = Types.Exact<{
  gatewayId: Types.Scalars['String']['input'];
}>;


export type ReadGatewayUpdateStatusQuery = { __typename: 'Query', readGateway: { __typename: 'GatewayResponseType', metadata?: { __typename: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, isOutdated?: boolean }, updateRequest?: { __typename: 'GatewayUpdateRequestType', requestedAt: any, version: string } } };

export type ReadGatewaySetupQueryVariables = Types.Exact<{
  gatewayId: Types.Scalars['String']['input'];
}>;


export type ReadGatewaySetupQuery = { __typename: 'Query', readGatewaySetup?: { __typename: 'GatewaySetupResponseType', expiresAt: any, byMajor: Array<{ __typename: 'GatewaySetupByMajorType', major: string, osCommands: Array<{ __typename: 'GatewaySetupType', osType: Types.OperatingSystemEnum, osName: string, installationCommand: string, configurationCommand: string }> }> } };

export type ReadDevicesSyncStatusByGatewayQueryVariables = Types.Exact<{
  gatewayId: Types.Scalars['String']['input'];
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadDevicesSyncStatusByGatewayQuery = { __typename: 'Query', readLinkedDevicesForGateway: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceId: string, deviceType: Types.DeviceTypeEnum, name: string, vendorId: string, accumulatedSyncStatus: { __typename: 'AccumulatedDeviceSyncStatusResponseType', syncTimestamp?: any, targetSyncStatus: Types.DeviceSyncStatusEnum, previousSyncStatus: Types.DeviceSyncStatusEnum, details: Array<{ __typename: 'DeviceSyncStatusResponseType', previousSyncStatus?: Types.DeviceSyncStatusEnum, syncErrorMessage?: string, syncTimestamp?: any, syncType: Types.DeviceSyncTypeEnum, targetSyncStatus?: Types.DeviceSyncStatusEnum, syncJobId?: string }> } }> } };

export type ResourceSubGroupFragment = { __typename: 'ResourceGroupResponseType', groupId: string, objectVersion?: number, name: string };

export type GroupTreeItemFragment = { __typename: 'ResourceGroupResponseType', groupId: string, name: string, parentGroupId?: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, groupDevicesSyncStatus: { __typename: 'ResourceGroupDevicesSyncStatusType', groupSyncStatus: Types.DeviceSyncStatusEnum, devicesSyncStatus: Array<{ __typename: 'GroupDeviceSyncStatusType', deviceName: string, deviceId: string, syncStatus: Types.DeviceSyncStatusEnum, syncStatusTimestamp?: any, groupId?: string }> } };

export type SubGroupFragment = { __typename: 'ResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any };

export type ResourceGroupFragment = { __typename: 'ResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, fullPaths: Array<string>, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, subGroups: { __typename: 'PaginatedResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'ResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any }> }, groupDevicesSyncStatus: { __typename: 'ResourceGroupDevicesSyncStatusType', groupSyncStatus: Types.DeviceSyncStatusEnum, devicesSyncStatus: Array<{ __typename: 'GroupDeviceSyncStatusType', deviceName: string, deviceId: string, syncStatus: Types.DeviceSyncStatusEnum, syncStatusTimestamp?: any, groupId?: string }> } };

export type ResourceGroupParentChildPairFragment = { __typename: 'ResourceGroupForPermissionResponseType', groupId: string, parentGroupId?: string };

export type DeleteResourceGroupMutationVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
}>;


export type DeleteResourceGroupMutation = { __typename: 'Mutation', deleteResourceGroup: { __typename: 'ResourceGroupResponseType', groupId: string, parentGroupId?: string } };

export type CreateResourceGroupMutationVariables = Types.Exact<{
  resourceGroup: Types.CreateResourceGroupInput;
}>;


export type CreateResourceGroupMutation = { __typename: 'Mutation', createResourceGroup: { __typename: 'ResourceGroupResponseType', groupId: string, parentGroupId?: string } };

export type UpdateResourceGroupMutationVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
  resourceGroup: Types.UpdateResourceGroupInput;
}>;


export type UpdateResourceGroupMutation = { __typename: 'Mutation', updateResourceGroup: { __typename: 'ResourceGroupResponseType', groupId: string, parentGroupId?: string } };

export type ReadResourceGroupByIdQueryVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
}>;


export type ReadResourceGroupByIdQuery = { __typename: 'Query', readResourceGroup: { __typename: 'ResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, fullPaths: Array<string>, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, subGroups: { __typename: 'PaginatedResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'ResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any }> }, groupDevicesSyncStatus: { __typename: 'ResourceGroupDevicesSyncStatusType', groupSyncStatus: Types.DeviceSyncStatusEnum, devicesSyncStatus: Array<{ __typename: 'GroupDeviceSyncStatusType', deviceName: string, deviceId: string, syncStatus: Types.DeviceSyncStatusEnum, syncStatusTimestamp?: any, groupId?: string }> } }, readSubGroupsForResourceGroup: { __typename: 'PaginatedResourceGroupResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'ResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, fullPaths: Array<string>, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, subGroups: { __typename: 'PaginatedResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'ResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any }> }, groupDevicesSyncStatus: { __typename: 'ResourceGroupDevicesSyncStatusType', groupSyncStatus: Types.DeviceSyncStatusEnum, devicesSyncStatus: Array<{ __typename: 'GroupDeviceSyncStatusType', deviceName: string, deviceId: string, syncStatus: Types.DeviceSyncStatusEnum, syncStatusTimestamp?: any, groupId?: string }> } }> } };

export type ReadResourceGroupsToBuildTreeQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ResourceGroupFilterInput>;
}>;


export type ReadResourceGroupsToBuildTreeQuery = { __typename: 'Query', readAllResourceGroups: { __typename: 'PaginatedResourceGroupResponseType', itemCount: number, items: Array<{ __typename: 'ResourceGroupResponseType', groupId: string, name: string, parentGroupId?: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, groupDevicesSyncStatus: { __typename: 'ResourceGroupDevicesSyncStatusType', groupSyncStatus: Types.DeviceSyncStatusEnum, devicesSyncStatus: Array<{ __typename: 'GroupDeviceSyncStatusType', deviceName: string, deviceId: string, syncStatus: Types.DeviceSyncStatusEnum, syncStatusTimestamp?: any, groupId?: string }> } }> } };

export type ReadAllResourceGroupsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ResourceGroupFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
  isRoot?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ReadAllResourceGroupsQuery = { __typename: 'Query', readAllResourceGroups: { __typename: 'PaginatedResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'ResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, fullPaths: Array<string>, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, subGroups: { __typename: 'PaginatedResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'ResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any }> }, groupDevicesSyncStatus: { __typename: 'ResourceGroupDevicesSyncStatusType', groupSyncStatus: Types.DeviceSyncStatusEnum, devicesSyncStatus: Array<{ __typename: 'GroupDeviceSyncStatusType', deviceName: string, deviceId: string, syncStatus: Types.DeviceSyncStatusEnum, syncStatusTimestamp?: any, groupId?: string }> } }> } };

export type ReadSubGroupsForResourceGroupQueryVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadSubGroupsForResourceGroupQuery = { __typename: 'Query', readSubGroupsForResourceGroup: { __typename: 'PaginatedResourceGroupResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'ResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, fullPaths: Array<string>, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, subGroups: { __typename: 'PaginatedResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'ResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any }> }, groupDevicesSyncStatus: { __typename: 'ResourceGroupDevicesSyncStatusType', groupSyncStatus: Types.DeviceSyncStatusEnum, devicesSyncStatus: Array<{ __typename: 'GroupDeviceSyncStatusType', deviceName: string, deviceId: string, syncStatus: Types.DeviceSyncStatusEnum, syncStatusTimestamp?: any, groupId?: string }> } }> } };

export type ReadResourceGroupNamesForRoleRowQueryVariables = Types.Exact<{
  groupIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type ReadResourceGroupNamesForRoleRowQuery = { __typename: 'Query', readResourceGroupsByIds: { __typename: 'PaginatedResourceGroupResponseType', items: Array<{ __typename: 'ResourceGroupResponseType', name: string, groupId: string }> } };

export type ReadResourceGroupNameByIdQueryVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
}>;


export type ReadResourceGroupNameByIdQuery = { __typename: 'Query', readResourceGroup: { __typename: 'ResourceGroupResponseType', name: string, parentGroupId?: string, fullPaths: Array<string> } };

export type ReadAllResourceGroupsWithoutPermissionChecksQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadAllResourceGroupsWithoutPermissionChecksQuery = { __typename: 'Query', readAllResourceGroupsForPermissions: Array<{ __typename: 'ResourceGroupForPermissionResponseType', groupId: string, parentGroupId?: string }> };

export type ReadGroupedAssetsCountQueryVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
}>;


export type ReadGroupedAssetsCountQuery = { __typename: 'Query', readAllDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number }, readAllProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, readAllGateways: { __typename: 'PaginatedGatewayResponseType', itemCount: number }, readAllDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number }, readAllVaults: { __typename: 'PaginatedVaultResponseType', itemCount: number }, readAllLicenses: { __typename: 'PaginatedLicenseResponseType', itemCount: number }, readSubGroupsForResourceGroup: { __typename: 'PaginatedResourceGroupResponseType', itemCount: number } };

export type ReadUngroupedAssetsCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadUngroupedAssetsCountQuery = { __typename: 'Query', readAllDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number }, readAllProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, readAllGateways: { __typename: 'PaginatedGatewayResponseType', itemCount: number }, readAllDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number }, readAllVaults: { __typename: 'PaginatedVaultResponseType', itemCount: number }, readAllLicenses: { __typename: 'PaginatedLicenseResponseType', itemCount: number } };

export type LicenseFragment = { __typename: 'LicenseResponseType', name?: string, groupId?: string, licenseId: string, objectVersion?: number, product: string, productKey?: string, quantity: number, serialId: string, status: Types.LicenseStatusEnum, type: Types.LicenseTypeEnum, ideConfigId?: string, updateTimestamp?: any, creationTimestamp?: any, family?: string, vendorId: string, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } };

export type CreateLicenseMutationVariables = Types.Exact<{
  license: Types.CreateLicenseInput;
}>;


export type CreateLicenseMutation = { __typename: 'Mutation', createLicense: { __typename: 'CreateLicenseResponseType', uploadId: string, licenseId: string, uploadUrls: Array<{ __typename: 'S3MultipartUploadUrlType', partNumber: number, uploadUrl: string }> } };

export type CompleteLicenseMultipartUploadMutationVariables = Types.Exact<{
  licenseId: Types.Scalars['String']['input'];
  uploadId: Types.Scalars['String']['input'];
  completeUploadInput: Types.CompleteMultipartUploadInput;
}>;


export type CompleteLicenseMultipartUploadMutation = { __typename: 'Mutation', completeLicenseMultipartUpload?: any };

export type DeleteLicenseMutationVariables = Types.Exact<{
  licenseId: Types.Scalars['String']['input'];
}>;


export type DeleteLicenseMutation = { __typename: 'Mutation', deleteLicense: { __typename: 'LicenseResponseType', licenseId: string, groupId?: string } };

export type UpdateLicenseMutationVariables = Types.Exact<{
  licenseId: Types.Scalars['String']['input'];
  license: Types.UpdateLicenseInput;
}>;


export type UpdateLicenseMutation = { __typename: 'Mutation', updateLicense: { __typename: 'LicenseResponseType', licenseId: string } };

export type ReadAllLicensesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.LicenseFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllLicensesQuery = { __typename: 'Query', readAllLicenses: { __typename: 'PaginatedLicenseResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'LicenseResponseType', name?: string, groupId?: string, licenseId: string, objectVersion?: number, product: string, productKey?: string, quantity: number, serialId: string, status: Types.LicenseStatusEnum, type: Types.LicenseTypeEnum, ideConfigId?: string, updateTimestamp?: any, creationTimestamp?: any, family?: string, vendorId: string, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }> } };

export type DownloadLicenseQueryVariables = Types.Exact<{
  licenseId: Types.Scalars['String']['input'];
}>;


export type DownloadLicenseQuery = { __typename: 'Query', downloadLicense: { __typename: 'LicenseDownloadURLResponseType', downloadUrl?: string } };

export type ReadLicenseNamesForRoleRowQueryVariables = Types.Exact<{
  licenseIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type ReadLicenseNamesForRoleRowQuery = { __typename: 'Query', readLicensesByIds: { __typename: 'PaginatedLicenseResponseType', items: Array<{ __typename: 'LicenseResponseType', name?: string, licenseId: string }> } };

export type DeleteAssetLinkMutationVariables = Types.Exact<{
  sourceId: Types.Scalars['String']['input'];
  sourceType: Types.AssetTypeEnum;
  destinationId: Types.Scalars['String']['input'];
  destinationType: Types.AssetTypeEnum;
}>;


export type DeleteAssetLinkMutation = { __typename: 'Mutation', deleteAssetLink: { __typename: 'AssetLinkResponseType', destinationId: string, destinationType: Types.AssetTypeEnum, sourceId: string, sourceType: Types.AssetTypeEnum } };

export type LinkDocumentToAssetMutationVariables = Types.Exact<{
  documentId: Types.Scalars['String']['input'];
  assetType: Types.AssetTypeEnum;
  assetId: Types.Scalars['String']['input'];
  assetVersionId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type LinkDocumentToAssetMutation = { __typename: 'Mutation', createAssetLink: { __typename: 'AssetLinkResponseType', sourceId: string, destinationId: string, metaData:
      | { __typename: 'DeviceToDeviceLinkMetaDataType' }
      | { __typename: 'DeviceToGatewayLinkMetaDataType' }
      | { __typename: 'DocumentToAssetLinkMetaDataType', assetVersionId?: string }
      | { __typename: 'ProjectToDeviceLinkMetaDataType' }
      | { __typename: 'ProjectToProjectLinkMetaDataType' }
      | { __typename: 'TagToAssetLinkMetaDataType' }
     } };

export type LinkLibraryToProjectMutationVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
  libraryId: Types.Scalars['String']['input'];
}>;


export type LinkLibraryToProjectMutation = { __typename: 'Mutation', createAssetLink: { __typename: 'AssetLinkResponseType', sourceId: string, destinationId: string } };

export type LinkDeviceToProjectMutationVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
  deviceId: Types.Scalars['String']['input'];
  metaData?: Types.InputMaybe<Types.AssetMetaDataCombinedInput>;
}>;


export type LinkDeviceToProjectMutation = { __typename: 'Mutation', createAssetLink: { __typename: 'AssetLinkResponseType', sourceId: string, destinationId: string, metaData:
      | { __typename: 'DeviceToDeviceLinkMetaDataType' }
      | { __typename: 'DeviceToGatewayLinkMetaDataType' }
      | { __typename: 'DocumentToAssetLinkMetaDataType' }
      | { __typename: 'ProjectToDeviceLinkMetaDataType', deviceIpAddress?: string, deviceName?: string, deviceSubnet?: string, deviceType?: string, targetProjectVersionId?: string }
      | { __typename: 'ProjectToProjectLinkMetaDataType' }
      | { __typename: 'TagToAssetLinkMetaDataType' }
     } };

export type UpdateDeviceToProjectLinkMutationVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
  deviceId: Types.Scalars['String']['input'];
  input: Types.UpdateAssetLinkInput;
}>;


export type UpdateDeviceToProjectLinkMutation = { __typename: 'Mutation', updateAssetLink: { __typename: 'AssetLinkResponseType', sourceId: string, destinationId: string, metaData:
      | { __typename: 'DeviceToDeviceLinkMetaDataType' }
      | { __typename: 'DeviceToGatewayLinkMetaDataType' }
      | { __typename: 'DocumentToAssetLinkMetaDataType' }
      | { __typename: 'ProjectToDeviceLinkMetaDataType', deviceIpAddress?: string, deviceName?: string, deviceSubnet?: string, deviceType?: string, targetProjectVersionId?: string }
      | { __typename: 'ProjectToProjectLinkMetaDataType' }
      | { __typename: 'TagToAssetLinkMetaDataType' }
     } };

export type LinkDeviceToGatewayMutationVariables = Types.Exact<{
  gatewayId: Types.Scalars['String']['input'];
  deviceId: Types.Scalars['String']['input'];
  primary?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type LinkDeviceToGatewayMutation = { __typename: 'Mutation', createAssetLink: { __typename: 'AssetLinkResponseType', sourceId: string, destinationId: string, metaData:
      | { __typename: 'DeviceToDeviceLinkMetaDataType' }
      | { __typename: 'DeviceToGatewayLinkMetaDataType', primary?: boolean }
      | { __typename: 'DocumentToAssetLinkMetaDataType' }
      | { __typename: 'ProjectToDeviceLinkMetaDataType' }
      | { __typename: 'ProjectToProjectLinkMetaDataType' }
      | { __typename: 'TagToAssetLinkMetaDataType' }
     } };

export type DefineGatewayLinksToDeviceMutationVariables = Types.Exact<{
  deviceId: Types.Scalars['String']['input'];
  input: Array<Types.DefineAssetLinkFromAssetInput> | Types.DefineAssetLinkFromAssetInput;
}>;


export type DefineGatewayLinksToDeviceMutation = { __typename: 'Mutation', defineAssetLinksFromAsset: { __typename: 'PaginatedAssetLinkResponseType', itemCount: number, items: Array<{ __typename: 'AssetLinkResponseType', sourceId: string, destinationId: string, metaData:
        | { __typename: 'DeviceToDeviceLinkMetaDataType' }
        | { __typename: 'DeviceToGatewayLinkMetaDataType', primary?: boolean }
        | { __typename: 'DocumentToAssetLinkMetaDataType' }
        | { __typename: 'ProjectToDeviceLinkMetaDataType' }
        | { __typename: 'ProjectToProjectLinkMetaDataType' }
        | { __typename: 'TagToAssetLinkMetaDataType' }
       }> } };

export type ReadAssetLinkQueryVariables = Types.Exact<{
  destinationId: Types.Scalars['String']['input'];
  destinationType: Types.AssetTypeEnum;
  sourceId: Types.Scalars['String']['input'];
  sourceType: Types.AssetTypeEnum;
}>;


export type ReadAssetLinkQuery = { __typename: 'Query', readAssetLink: { __typename: 'AssetLinkResponseType', objectVersion?: number } };

export type LockFragment = { __typename: 'LockResponseType', service: string, creationTimestamp?: any, message?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } };

export type CreateLockMutationVariables = Types.Exact<{
  lock: Types.CreateLockInput;
}>;


export type CreateLockMutation = { __typename: 'Mutation', createLock: { __typename: 'LockResponseType', resourceId: string, resourceType: string } };

export type DeleteLockMutationVariables = Types.Exact<{
  assetId: Types.Scalars['String']['input'];
  assetType: Types.Scalars['String']['input'];
}>;


export type DeleteLockMutation = { __typename: 'Mutation', deleteLock: { __typename: 'LockResponseType', resourceId: string, resourceType: string } };

export type ReadLockQueryVariables = Types.Exact<{
  assetId: Types.Scalars['String']['input'];
  assetType: Types.Scalars['String']['input'];
}>;


export type ReadLockQuery = { __typename: 'Query', readLock?: { __typename: 'LockResponseType', service: string, creationTimestamp?: any, message?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } } };

export type ProjectFragment = { __typename: 'ProjectResponseType', projectType: Types.ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename: 'DeviceInformationType', name: string, deviceType: Types.DeviceTypeEnum, ethernetCommunication: Array<{ __typename: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceType: Types.DeviceTypeEnum }> }, linkedSubProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number } };

export type LinkedLibraryFragment = { __typename: 'ProjectResponseType', updateTimestamp?: any, objectVersion?: number, projectType: Types.ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, secretId?: string, linkMetaData?:
    | { __typename: 'ProjectToDeviceLinkMetaDataType' }
    | { __typename: 'ProjectToProjectLinkMetaDataType', destinationVersionId?: string, sourceVersionId?: string }
  , linkedSubProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename: 'DeviceInformationType', name: string, deviceType: Types.DeviceTypeEnum, ethernetCommunication: Array<{ __typename: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceType: Types.DeviceTypeEnum }> } };

export type DeviceInformationFragment = { __typename: 'DeviceInformationType', name: string, deviceType: Types.DeviceTypeEnum, ethernetCommunication: Array<{ __typename: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> };

export type ProjectVersionFragment = { __typename: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename: 'DeviceInformationType', name: string, deviceType: Types.DeviceTypeEnum, ethernetCommunication: Array<{ __typename: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> };

export type CreateProjectMutationVariables = Types.Exact<{
  project: Types.CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename: 'Mutation', createProject: { __typename: 'CreateProjectResponseType', projectId: string, versionId: string, uploadId: string, groupId?: string, uploadUrls: Array<{ __typename: 'S3MultipartUploadUrlType', partNumber: number, uploadUrl: string }> } };

export type CompleteProjectMultipartUploadMutationVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
  versionId: Types.Scalars['String']['input'];
  uploadId: Types.Scalars['String']['input'];
  completeUploadInput: Types.CompleteMultipartUploadInput;
}>;


export type CompleteProjectMultipartUploadMutation = { __typename: 'Mutation', completeProjectVersionMultipartUpload?: any };

export type DeleteProjectMutationVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
}>;


export type DeleteProjectMutation = { __typename: 'Mutation', deleteProject: { __typename: 'ProjectResponseType', projectId: string, groupId?: string } };

export type DeleteProjectVersionMutationVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
  versionId: Types.Scalars['String']['input'];
}>;


export type DeleteProjectVersionMutation = { __typename: 'Mutation', deleteProjectVersion: { __typename: 'ProjectVersionResponseType', projectId: string, versionId: string, groupId?: string } };

export type UpdateProjectMutationVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
  project: Types.UpdateProjectInput;
}>;


export type UpdateProjectMutation = { __typename: 'Mutation', updateProject: { __typename: 'ProjectResponseType', projectId: string, groupId?: string } };

export type CreateProjectVersionMutationVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
  projectVersion: Types.CreateProjectVersionInput;
}>;


export type CreateProjectVersionMutation = { __typename: 'Mutation', createProjectVersion: { __typename: 'ProjectVersionUploadURLResponseType', projectId: string, versionId: string, uploadId: string, uploadUrls: Array<{ __typename: 'S3MultipartUploadUrlType', partNumber: number, uploadUrl: string }> } };

export type UpdateProjectVersionMutationVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
  versionId: Types.Scalars['String']['input'];
  projectVersion: Types.UpdateProjectVersionInput;
}>;


export type UpdateProjectVersionMutation = { __typename: 'Mutation', updateProjectVersion: { __typename: 'ProjectVersionResponseType', projectId: string, versionId: string } };

export type ReadAllProjectsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ProjectFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllProjectsQuery = { __typename: 'Query', readAllProjects: { __typename: 'PaginatedProjectResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'ProjectResponseType', projectType: Types.ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename: 'DeviceInformationType', name: string, deviceType: Types.DeviceTypeEnum, ethernetCommunication: Array<{ __typename: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceType: Types.DeviceTypeEnum }> }, linkedSubProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number } }> } };

export type DownloadProjectVersionQueryVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
  versionId: Types.Scalars['String']['input'];
}>;


export type DownloadProjectVersionQuery = { __typename: 'Query', downloadProjectVersion: { __typename: 'ProjectVersionDownloadURLResponseType', downloadUrl: string } };

export type ReadProjectQueryVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
}>;


export type ReadProjectQuery = { __typename: 'Query', readProject: { __typename: 'ProjectResponseType', projectType: Types.ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename: 'DeviceInformationType', name: string, deviceType: Types.DeviceTypeEnum, ethernetCommunication: Array<{ __typename: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceType: Types.DeviceTypeEnum }> }, linkedSubProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number } } };

export type ReadVersionsForProjectQueryVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
  filter?: Types.InputMaybe<Types.ProjectVersionFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadVersionsForProjectQuery = { __typename: 'Query', readProjectVersionsForProject: { __typename: 'PaginatedProjectVersionResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename: 'DeviceInformationType', name: string, deviceType: Types.DeviceTypeEnum, ethernetCommunication: Array<{ __typename: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> } };

export type ReadLinkedLibrariesForProjectQueryVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadLinkedLibrariesForProjectQuery = { __typename: 'Query', readLinkedSubProjectsForProject: { __typename: 'PaginatedProjectResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'ProjectResponseType', updateTimestamp?: any, objectVersion?: number, projectType: Types.ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, secretId?: string, linkMetaData?:
        | { __typename: 'ProjectToDeviceLinkMetaDataType' }
        | { __typename: 'ProjectToProjectLinkMetaDataType', destinationVersionId?: string, sourceVersionId?: string }
      , linkedSubProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename: 'DeviceInformationType', name: string, deviceType: Types.DeviceTypeEnum, ethernetCommunication: Array<{ __typename: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceType: Types.DeviceTypeEnum }> } }> } };

export type ReadLinkedDevicesForProjectQueryVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadLinkedDevicesForProjectQuery = { __typename: 'Query', readLinkedDevicesForProject: { __typename: 'PaginatedDeviceResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceId: string, deviceType: Types.DeviceTypeEnum, vendorId: string, ideConfigId: string, groupId?: string, name: string, secretId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, description?: string, metaData?: any, linkMetaData?:
        | { __typename: 'DeviceToDeviceLinkMetaDataType' }
        | { __typename: 'DeviceToGatewayLinkMetaDataType' }
        | { __typename: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string }
      , ftpConfiguration?: { __typename: 'FtpConfigurationType', secretId?: string, ipAddress: string, port: number, rootDirectory?: string, protocol?: Types.FtpProtocolEnum }, smbConfiguration?: { __typename: 'SmbConfigurationType', secretId?: string, ipAddress: string, port: number, protocol?: Types.SmbProtocolEnum, rootDirectory?: string }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, linkedProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename: 'ProjectResponseType', projectType: Types.ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, linkMetaData?:
            | { __typename: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string }
            | { __typename: 'ProjectToProjectLinkMetaDataType' }
          , creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename: 'DeviceInformationType', name: string, deviceType: Types.DeviceTypeEnum, ethernetCommunication: Array<{ __typename: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceType: Types.DeviceTypeEnum }> }, linkedSubProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number } }> }, connectionConfiguration: { __typename: 'ConnectionConfigurationType', gatewayIpAddress?: string, ipAddress: string, port: number, subnetMask?: string }, linkedGateways: { __typename: 'PaginatedGatewayResponseType', itemCount: number, items: Array<{ __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, linkMetaData?: { __typename: 'DeviceToGatewayLinkMetaDataType', primary?: boolean }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: Types.OperatingSystemEnum }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: Types.ArchEnum, operatingSystem: Types.OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
              | { __typename: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
              | { __typename: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
             }, publicIp?: { __typename: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename: 'GatewayStateResponseType', reportedAt: any, state: Types.GatewayStateEnum }, location?: { __typename: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number } }> }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number } }> } };

export type ReadProjectViewerProjectQueryVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
  filter?: Types.InputMaybe<Types.ProjectVersionFilterInput>;
}>;


export type ReadProjectViewerProjectQuery = { __typename: 'Query', readProject: { __typename: 'ProjectResponseType', name: string, projectId: string, vendorId: string, ideConfigId: string, projectType: Types.ProjectTypeEnum, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedProjectVersionResponseType', items: Array<{ __typename: 'ProjectVersionResponseType', versionId: string, creationTimestamp?: any, updateTimestamp?: any, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }> } } };

export type ReadProjectsByIdsQueryVariables = Types.Exact<{
  projectIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type ReadProjectsByIdsQuery = { __typename: 'Query', readProjectsByIds: { __typename: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename: 'ProjectResponseType', projectType: Types.ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, versions: { __typename: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename: 'DeviceInformationType', name: string, deviceType: Types.DeviceTypeEnum, ethernetCommunication: Array<{ __typename: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceType: Types.DeviceTypeEnum }> }, linkedSubProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename: 'PaginatedDocumentResponseType', itemCount: number } }> } };

export type ReadProjectNamesForRoleRowQueryVariables = Types.Exact<{
  projectIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type ReadProjectNamesForRoleRowQuery = { __typename: 'Query', readProjectsByIds: { __typename: 'PaginatedProjectResponseType', items: Array<{ __typename: 'ProjectResponseType', name: string, projectId: string }> } };

export type ReadLatestActiveVersionQueryVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
}>;


export type ReadLatestActiveVersionQuery = { __typename: 'Query', readProjectVersionsForProject: { __typename: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename: 'DeviceInformationType', name: string, deviceType: Types.DeviceTypeEnum, ethernetCommunication: Array<{ __typename: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> } };

export type ReadLatestVersionQueryVariables = Types.Exact<{
  projectId: Types.Scalars['String']['input'];
}>;


export type ReadLatestVersionQuery = { __typename: 'Query', readProjectVersionsForProject: { __typename: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: Types.ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename: 'DeviceInformationType', name: string, deviceType: Types.DeviceTypeEnum, ethernetCommunication: Array<{ __typename: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> } };

export type TagFragment = { __typename: 'TagResponseType', name: string };

export type FullTagFragment = { __typename: 'TagResponseType', creationTimestamp?: any, name: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, devices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', name: string, deviceId: string }> }, projects: { __typename: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename: 'ProjectResponseType', name: string, projectId: string }> }, documents: { __typename: 'PaginatedDocumentResponseType', itemCount: number, items: Array<{ __typename: 'DocumentResponseType', name: string, documentId: string }> }, gateways: { __typename: 'PaginatedGatewayResponseType', itemCount: number, items: Array<{ __typename: 'GatewayResponseType', name: string, gatewayId: string }> } };

export type CreateTagMutationVariables = Types.Exact<{
  tag: Types.CreateTagInput;
}>;


export type CreateTagMutation = { __typename: 'Mutation', createTag: { __typename: 'TagResponseType', name: string } };

export type DefineAssetTagsMutationVariables = Types.Exact<{
  assetId: Types.Scalars['String']['input'];
  assetType: Types.AssetTypeEnum;
  input: Array<Types.DefineAssetLinkToAssetInput> | Types.DefineAssetLinkToAssetInput;
}>;


export type DefineAssetTagsMutation = { __typename: 'Mutation', defineAssetLinksToAsset: { __typename: 'PaginatedAssetLinkResponseType', itemCount: number, items: Array<{ __typename: 'AssetLinkResponseType', sourceType: Types.AssetTypeEnum, sourceId: string, destinationType: Types.AssetTypeEnum, destinationId: string }> } };

export type DeleteTagMutationVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
}>;


export type DeleteTagMutation = { __typename: 'Mutation', deleteTag: { __typename: 'TagResponseType', name: string } };

export type ReadAllTagsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TagFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllTagsQuery = { __typename: 'Query', readAllTags: { __typename: 'PaginatedTagResponseType', pages: number, items: Array<{ __typename: 'TagResponseType', name: string }> } };

export type ReadAllFullTagsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.TagFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllFullTagsQuery = { __typename: 'Query', readAllTags: { __typename: 'PaginatedTagResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'TagResponseType', creationTimestamp?: any, name: string, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, devices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', name: string, deviceId: string }> }, projects: { __typename: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename: 'ProjectResponseType', name: string, projectId: string }> }, documents: { __typename: 'PaginatedDocumentResponseType', itemCount: number, items: Array<{ __typename: 'DocumentResponseType', name: string, documentId: string }> }, gateways: { __typename: 'PaginatedGatewayResponseType', itemCount: number, items: Array<{ __typename: 'GatewayResponseType', name: string, gatewayId: string }> } }> } };

export type ReadLinkedTagsForAssetQueryVariables = Types.Exact<{
  assetId: Types.Scalars['String']['input'];
  assetType: Types.AssetTypeEnum;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadLinkedTagsForAssetQuery = { __typename: 'Query', readLinkedTagsForAsset: { __typename: 'PaginatedTagResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'TagResponseType', name: string }> } };

export type VaultFragment = { __typename: 'VaultResponseType', vaultId: string, groupId?: string, name: string, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, description?: string, secrets: { __typename: 'PaginatedSecretResponseType', itemCount: number, items: Array<{ __typename: 'SecretResponseType', secretId: string, secretType: Types.SecretTypeEnum, weakSecret: boolean, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number }, linkedProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number } }> }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } };

export type SecretFragment = { __typename: 'SecretResponseType', secretId: string, secretType: Types.SecretTypeEnum, weakSecret: boolean, name: string, username?: string, secretValue: string, objectVersion?: number, vault: { __typename: 'VaultResponseType', name: string, vaultId: string }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', name: string, deviceId: string }> }, linkedProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename: 'ProjectResponseType', name: string, projectId: string }> } };

export type SecretUnceiledFragment = { __typename: 'SecretUnceiledResponseType', secretId: string, secretValue: string };

export type WeakSecretsFragment = { __typename: 'VaultResponseType', vaultId: string, secrets: { __typename: 'PaginatedSecretResponseType', itemCount: number, items: Array<{ __typename: 'SecretResponseType', secretId: string, weakSecret: boolean }> } };

export type CreateVaultMutationVariables = Types.Exact<{
  vault: Types.CreateVaultInput;
}>;


export type CreateVaultMutation = { __typename: 'Mutation', createVault: { __typename: 'VaultResponseType', vaultId: string, name: string, description?: string } };

export type DeleteVaultMutationVariables = Types.Exact<{
  vaultId: Types.Scalars['String']['input'];
}>;


export type DeleteVaultMutation = { __typename: 'Mutation', deleteVault: { __typename: 'VaultResponseType', vaultId: string } };

export type CreateSecretMutationVariables = Types.Exact<{
  secret: Types.CreateSecretInput;
}>;


export type CreateSecretMutation = { __typename: 'Mutation', createSecret: { __typename: 'SecretResponseType', secretId: string, secretType: Types.SecretTypeEnum, name: string, vaultId: string } };

export type DeleteSecretMutationVariables = Types.Exact<{
  secretId: Types.Scalars['String']['input'];
}>;


export type DeleteSecretMutation = { __typename: 'Mutation', deleteSecret: { __typename: 'SecretResponseType', secretId: string, vaultId: string } };

export type UpdateVaultMutationVariables = Types.Exact<{
  vaultId: Types.Scalars['String']['input'];
  vault: Types.UpdateVaultInput;
}>;


export type UpdateVaultMutation = { __typename: 'Mutation', updateVault: { __typename: 'VaultResponseType', vaultId: string } };

export type UpdateSecretMutationVariables = Types.Exact<{
  secretId: Types.Scalars['String']['input'];
  secret: Types.UpdateSecretInput;
}>;


export type UpdateSecretMutation = { __typename: 'Mutation', updateSecret: { __typename: 'SecretResponseType', secretId: string, vaultId: string } };

export type SyncWeakSecretFlagsMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SyncWeakSecretFlagsMutation = { __typename: 'Mutation', syncWeakSecretFlags: { __typename: 'SyncWeakSecretFlagsResponseType', allSecretsSecure: boolean } };

export type ReadAllVaultsQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.PaginationInput>;
  filter?: Types.InputMaybe<Types.VaultFilterInput>;
}>;


export type ReadAllVaultsQuery = { __typename: 'Query', readAllVaults: { __typename: 'PaginatedVaultResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'VaultResponseType', vaultId: string, groupId?: string, name: string, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, description?: string, secrets: { __typename: 'PaginatedSecretResponseType', itemCount: number, items: Array<{ __typename: 'SecretResponseType', secretId: string, secretType: Types.SecretTypeEnum, weakSecret: boolean, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number }, linkedProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number } }> }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }> } };

export type ReadVaultQueryVariables = Types.Exact<{
  vaultId: Types.Scalars['String']['input'];
}>;


export type ReadVaultQuery = { __typename: 'Query', readVault: { __typename: 'VaultResponseType', vaultId: string, groupId?: string, name: string, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, description?: string, secrets: { __typename: 'PaginatedSecretResponseType', itemCount: number, items: Array<{ __typename: 'SecretResponseType', secretId: string, secretType: Types.SecretTypeEnum, weakSecret: boolean, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number }, linkedProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number } }> }, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } } };

export type ReadSecretsForVaultQueryVariables = Types.Exact<{
  vaultId: Types.Scalars['String']['input'];
  pagination?: Types.InputMaybe<Types.PaginationInput>;
  filter?: Types.InputMaybe<Types.SecretFilterInput>;
}>;


export type ReadSecretsForVaultQuery = { __typename: 'Query', readSecretsForVault: { __typename: 'PaginatedSecretResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'SecretResponseType', secretId: string, secretType: Types.SecretTypeEnum, weakSecret: boolean, name: string, username?: string, secretValue: string, objectVersion?: number, vault: { __typename: 'VaultResponseType', name: string, vaultId: string }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', name: string, deviceId: string }> }, linkedProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename: 'ProjectResponseType', name: string, projectId: string }> } }> } };

export type ReadSecretQueryVariables = Types.Exact<{
  secretId: Types.Scalars['String']['input'];
}>;


export type ReadSecretQuery = { __typename: 'Query', readSecret: { __typename: 'SecretResponseType', secretId: string, secretType: Types.SecretTypeEnum, weakSecret: boolean, name: string, username?: string, secretValue: string, objectVersion?: number, vault: { __typename: 'VaultResponseType', name: string, vaultId: string }, linkedDevices: { __typename: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', name: string, deviceId: string }> }, linkedProjects: { __typename: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename: 'ProjectResponseType', name: string, projectId: string }> } } };

export type ReadSecretUnceiledQueryVariables = Types.Exact<{
  secretId: Types.Scalars['String']['input'];
}>;


export type ReadSecretUnceiledQuery = { __typename: 'Query', readSecretUnceiled: { __typename: 'SecretUnceiledResponseType', secretId: string, secretValue: string } };

export type ReadAllVaultNamesForPolicyRowQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.PaginationInput>;
  filter?: Types.InputMaybe<Types.VaultFilterInput>;
}>;


export type ReadAllVaultNamesForPolicyRowQuery = { __typename: 'Query', readAllVaults: { __typename: 'PaginatedVaultResponseType', items: Array<{ __typename: 'VaultResponseType', name: string, vaultId: string }> } };

export type ReadWeakSecretsSummaryQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadWeakSecretsSummaryQuery = { __typename: 'Query', readAllVaults: { __typename: 'PaginatedVaultResponseType', itemCount: number, items: Array<{ __typename: 'VaultResponseType', vaultId: string, secrets: { __typename: 'PaginatedSecretResponseType', itemCount: number, items: Array<{ __typename: 'SecretResponseType', secretId: string, weakSecret: boolean }> } }> } };

export type DeviceVulnerabilityFragment = { __typename: 'DeviceOtCveResponseType', deviceId: string, deviceName: string, deviceType?: string, vendor?: string, deviceVersion: string, firmwareDeviceName?: string, cveNumber?: string, nvdSeverity?: string, affectedVersion?: string, fixedVersion?: string, constraint?: string, productArticleNumber?: string, isVulnerable?: boolean, publishedDate?: string, cvssScore?: any };

export type OtCveRecordFieldsFragment = { __typename: 'OtCveRecordType', cveNumber?: string, cveTitle?: string, description?: string, nvdDescription?: string, cvssScore?: any, publishDate?: string, productArticleNumber: string, productName?: string, affectedVersions?: string, fixedVersions?: string, advisoryLink?: string, nvdSeverity?: string, nvdUrl?: string };

export type ReadAllDeviceVulnerabilitiesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.DeviceVulnerabilityFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllDeviceVulnerabilitiesQuery = { __typename: 'Query', readAllDeviceVulnerabilities: { __typename: 'PaginatedDeviceOtCveResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'DeviceOtCveResponseType', deviceId: string, deviceName: string, deviceType?: string, vendor?: string, deviceVersion: string, firmwareDeviceName?: string, cveNumber?: string, nvdSeverity?: string, affectedVersion?: string, fixedVersion?: string, constraint?: string, productArticleNumber?: string, isVulnerable?: boolean, publishedDate?: string, cvssScore?: any }> } };

export type ReadOtCveQueryVariables = Types.Exact<{
  cveNumber: Types.Scalars['String']['input'];
  productArticleNumber: Types.Scalars['String']['input'];
}>;


export type ReadOtCveQuery = { __typename: 'Query', readOtCve: { __typename: 'OtCveResponseType', otCveId: string, vendor?: string, record: { __typename: 'OtCveRecordType', cveNumber?: string, cveTitle?: string, description?: string, nvdDescription?: string, cvssScore?: any, publishDate?: string, productArticleNumber: string, productName?: string, affectedVersions?: string, fixedVersions?: string, advisoryLink?: string, nvdSeverity?: string, nvdUrl?: string } } };

export type ReadDeviceVulnerabilitySummaryQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadDeviceVulnerabilitySummaryQuery = { __typename: 'Query', readAllDeviceVulnerabilities: { __typename: 'PaginatedDeviceOtCveResponseType', itemCount: number, items: Array<{ __typename: 'DeviceOtCveResponseType', deviceId: string }> } };

export type WorkstationPublicIpFragment = { __typename: 'WorkstationPublicIpResponseType', publicIp: string, reportedAt: any, publicIpLocation?: { __typename: 'LocationType', city?: string, country?: string, state?: string } };

export type WorkstationMetadataFragment = { __typename: 'WorkstationMetadataResponseType', architecture: Types.ArchEnum, isOutdated?: boolean, isOutdatedForMajor?: boolean, latestVersion?: string, latestVersionForMajor?: string, numCpu?: number, operatingSystem: Types.OperatingSystemEnum, reportedAt: any, version: string };

export type WorkstationSetupCommandFragment = { __typename: 'WorkstationSetupResponseType', expiresAt: any, osCommands: Array<{ __typename: 'WorkstationSetupType', configurationCommand: string, installationCommand: string, osName: string, osType: Types.OperatingSystemEnum }> };

export type WorkstationFragment = { __typename: 'WorkstationResponseType', name: string, description?: string, workstationId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename: 'WorkstationSetupResponseType', expiresAt: any, osCommands: Array<{ __typename: 'WorkstationSetupType', configurationCommand: string, installationCommand: string, osName: string, osType: Types.OperatingSystemEnum }> }, metadata?: { __typename: 'WorkstationMetadataResponseType', architecture: Types.ArchEnum, isOutdated?: boolean, isOutdatedForMajor?: boolean, latestVersion?: string, latestVersionForMajor?: string, numCpu?: number, operatingSystem: Types.OperatingSystemEnum, reportedAt: any, version: string }, publicIp?: { __typename: 'WorkstationPublicIpResponseType', publicIp: string, reportedAt: any, publicIpLocation?: { __typename: 'LocationType', city?: string, country?: string, state?: string } }, state?: { __typename: 'WorkstationStateResponseType', reportedAt: any, state: Types.WorkstationStateEnum } };

export type WorkstationDeviceConnectionFragment = { __typename: 'WorkstationDeviceConnectionV2Type', connectionId: string, connectionState?: Types.ConnectionV2State, deviceId: string, gatewayId?: string, workstationId: string };

export type CreateWorkstationMutationVariables = Types.Exact<{
  workstation: Types.CreateWorkstationInput;
}>;


export type CreateWorkstationMutation = { __typename: 'Mutation', createWorkstation: { __typename: 'WorkstationResponseType', groupId?: string, workstationId: string } };

export type UpdateWorkstationMutationVariables = Types.Exact<{
  workstationId: Types.Scalars['String']['input'];
  workstation: Types.UpdateWorkstationInput;
}>;


export type UpdateWorkstationMutation = { __typename: 'Mutation', updateWorkstation: { __typename: 'WorkstationResponseType', groupId?: string, workstationId: string } };

export type DeleteWorkstationMutationVariables = Types.Exact<{
  workstationId: Types.Scalars['String']['input'];
}>;


export type DeleteWorkstationMutation = { __typename: 'Mutation', deleteWorkstation: { __typename: 'WorkstationResponseType', groupId?: string, workstationId: string } };

export type CreateWorkstationConnectionMutationVariables = Types.Exact<{
  deviceId: Types.Scalars['String']['input'];
  workstationId: Types.Scalars['String']['input'];
}>;


export type CreateWorkstationConnectionMutation = { __typename: 'Mutation', createWorkstationDeviceConnectionV2: { __typename: 'WorkstationDeviceConnectionV2Type', connectionId: string, connectionState?: Types.ConnectionV2State, deviceId: string, gatewayId?: string, workstationId: string } };

export type DeleteWorkstationConnectionMutationVariables = Types.Exact<{
  deviceId: Types.Scalars['String']['input'];
  workstationId: Types.Scalars['String']['input'];
}>;


export type DeleteWorkstationConnectionMutation = { __typename: 'Mutation', deleteWorkstationDeviceConnectionV2: { __typename: 'WorkstationDeviceConnectionV2Type', workstationId: string } };

export type ReadAllWorkstationsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.WorkstationFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllWorkstationsQuery = { __typename: 'Query', readAllWorkstationsForUser: { __typename: 'PaginatedWorkstationResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'WorkstationResponseType', name: string, description?: string, workstationId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename: 'WorkstationSetupResponseType', expiresAt: any, osCommands: Array<{ __typename: 'WorkstationSetupType', configurationCommand: string, installationCommand: string, osName: string, osType: Types.OperatingSystemEnum }> }, metadata?: { __typename: 'WorkstationMetadataResponseType', architecture: Types.ArchEnum, isOutdated?: boolean, isOutdatedForMajor?: boolean, latestVersion?: string, latestVersionForMajor?: string, numCpu?: number, operatingSystem: Types.OperatingSystemEnum, reportedAt: any, version: string }, publicIp?: { __typename: 'WorkstationPublicIpResponseType', publicIp: string, reportedAt: any, publicIpLocation?: { __typename: 'LocationType', city?: string, country?: string, state?: string } }, state?: { __typename: 'WorkstationStateResponseType', reportedAt: any, state: Types.WorkstationStateEnum } }> } };

export type ReadWorkstationHealthStatusQueryVariables = Types.Exact<{
  workstationId: Types.Scalars['String']['input'];
}>;


export type ReadWorkstationHealthStatusQuery = { __typename: 'Query', readWorkstationState?: { __typename: 'WorkstationStateResponseType', reportedAt: any, state: Types.WorkstationStateEnum } };

export type ReadWorkstationQueryVariables = Types.Exact<{
  workstationId: Types.Scalars['String']['input'];
}>;


export type ReadWorkstationQuery = { __typename: 'Query', readWorkstation: { __typename: 'WorkstationResponseType', name: string, description?: string, workstationId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename: 'WorkstationSetupResponseType', expiresAt: any, osCommands: Array<{ __typename: 'WorkstationSetupType', configurationCommand: string, installationCommand: string, osName: string, osType: Types.OperatingSystemEnum }> }, metadata?: { __typename: 'WorkstationMetadataResponseType', architecture: Types.ArchEnum, isOutdated?: boolean, isOutdatedForMajor?: boolean, latestVersion?: string, latestVersionForMajor?: string, numCpu?: number, operatingSystem: Types.OperatingSystemEnum, reportedAt: any, version: string }, publicIp?: { __typename: 'WorkstationPublicIpResponseType', publicIp: string, reportedAt: any, publicIpLocation?: { __typename: 'LocationType', city?: string, country?: string, state?: string } }, state?: { __typename: 'WorkstationStateResponseType', reportedAt: any, state: Types.WorkstationStateEnum } } };

export type ReadWorkstationConnectionsQueryVariables = Types.Exact<{
  workstationId: Types.Scalars['String']['input'];
}>;


export type ReadWorkstationConnectionsQuery = { __typename: 'Query', readWorkstationDeviceConnectionsV2: { __typename: 'PaginatedWorkstationDeviceConnectionV2StatusResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'WorkstationDeviceConnectionV2Type', connectionId: string, connectionState?: Types.ConnectionV2State, deviceId: string, gatewayId?: string, workstationId: string }> } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const AssetUserInfoFragmentDoc = new TypedDocumentString(`
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
    `, {"fragmentName":"AssetUserInfo"});
export const DeviceInformationFragmentDoc = new TypedDocumentString(`
    fragment DeviceInformation on DeviceInformationType {
  __typename
  name
  deviceType
  ethernetCommunication {
    __typename
    ipAddress
    subnetMask
  }
}
    `, {"fragmentName":"DeviceInformation"});
export const ProjectVersionFragmentDoc = new TypedDocumentString(`
    fragment ProjectVersion on ProjectVersionResponseType {
  __typename
  versionNumber
  projectId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  projectFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  source
  commitMessage
  deviceInformation {
    __typename
    ...DeviceInformation
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment DeviceInformation on DeviceInformationType {
  __typename
  name
  deviceType
  ethernetCommunication {
    __typename
    ipAddress
    subnetMask
  }
}`, {"fragmentName":"ProjectVersion"});
export const ProjectFragmentDoc = new TypedDocumentString(`
    fragment Project on ProjectResponseType {
  __typename
  projectType
  vendorId
  name
  metaData
  attachedLicenses
  projectId
  groupId
  description
  ideConfigId
  creationTimestamp
  objectVersion
  updateTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  versions(
    filter: {source: {ne: "PROJECT_BACKUP"}}
    pagination: {page: 1, pageSize: 1}
  ) {
    __typename
    items {
      __typename
      ...ProjectVersion
    }
    itemCount
  }
  linkedDevices {
    __typename
    itemCount
    items {
      __typename
      deviceType
    }
  }
  secretId
  linkedSubProjects {
    __typename
    itemCount
  }
  linkedParentProjects {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment DeviceInformation on DeviceInformationType {
  __typename
  name
  deviceType
  ethernetCommunication {
    __typename
    ipAddress
    subnetMask
  }
}
fragment ProjectVersion on ProjectVersionResponseType {
  __typename
  versionNumber
  projectId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  projectFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  source
  commitMessage
  deviceInformation {
    __typename
    ...DeviceInformation
  }
}`, {"fragmentName":"Project"});
export const ProjectToDeviceLinkMetaDataFragmentDoc = new TypedDocumentString(`
    fragment ProjectToDeviceLinkMetaData on ProjectToDeviceLinkMetaDataType {
  __typename
  targetProjectVersionId
  deviceName
  deviceIpAddress
  deviceSubnet
  deviceType
}
    `, {"fragmentName":"ProjectToDeviceLinkMetaData"});
export const LinkedProjectFromDeviceFragmentDoc = new TypedDocumentString(`
    fragment LinkedProjectFromDevice on ProjectResponseType {
  __typename
  ...Project
  linkMetaData {
    __typename
    ... on ProjectToDeviceLinkMetaDataType {
      __typename
      ...ProjectToDeviceLinkMetaData
    }
  }
}
    fragment ProjectToDeviceLinkMetaData on ProjectToDeviceLinkMetaDataType {
  __typename
  targetProjectVersionId
  deviceName
  deviceIpAddress
  deviceSubnet
  deviceType
}
fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Project on ProjectResponseType {
  __typename
  projectType
  vendorId
  name
  metaData
  attachedLicenses
  projectId
  groupId
  description
  ideConfigId
  creationTimestamp
  objectVersion
  updateTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  versions(
    filter: {source: {ne: "PROJECT_BACKUP"}}
    pagination: {page: 1, pageSize: 1}
  ) {
    __typename
    items {
      __typename
      ...ProjectVersion
    }
    itemCount
  }
  linkedDevices {
    __typename
    itemCount
    items {
      __typename
      deviceType
    }
  }
  secretId
  linkedSubProjects {
    __typename
    itemCount
  }
  linkedParentProjects {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
}
fragment DeviceInformation on DeviceInformationType {
  __typename
  name
  deviceType
  ethernetCommunication {
    __typename
    ipAddress
    subnetMask
  }
}
fragment ProjectVersion on ProjectVersionResponseType {
  __typename
  versionNumber
  projectId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  projectFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  source
  commitMessage
  deviceInformation {
    __typename
    ...DeviceInformation
  }
}`, {"fragmentName":"LinkedProjectFromDevice"});
export const GatewaySetupTypeFragmentDoc = new TypedDocumentString(`
    fragment GatewaySetupType on GatewaySetupType {
  __typename
  configurationCommand
  installationCommand
  osName
  osType
}
    `, {"fragmentName":"GatewaySetupType"});
export const GatewaySetupCommandFragmentDoc = new TypedDocumentString(`
    fragment GatewaySetupCommand on GatewaySetupResponseType {
  __typename
  expiresAt
  osCommands {
    __typename
    ...GatewaySetupType
  }
}
    fragment GatewaySetupType on GatewaySetupType {
  __typename
  configurationCommand
  installationCommand
  osName
  osType
}`, {"fragmentName":"GatewaySetupCommand"});
export const GatewayMetadataFragmentDoc = new TypedDocumentString(`
    fragment GatewayMetadata on GatewayMetadataResponseType {
  __typename
  reportedAt
  version
  latestVersion
  latestVersionForMajor
  architecture
  operatingSystem
  operatingSystemAttrs {
    __typename
    ... on WindowsAttrsType {
      __typename
      productId
      productName
      compositionEditionId
      currentBuild
      currentVersion
      displayVersion
      editionId
      installationType
      registeredOrganization
      registeredOwner
      winreVersion
    }
    ... on LinuxAttrsType {
      __typename
      distro
      version
      kernel
      procVersion
    }
  }
  numCpu
  isOutdated
  isOutdatedForMajor
}
    `, {"fragmentName":"GatewayMetadata"});
export const GatewayPublicIpFragmentDoc = new TypedDocumentString(`
    fragment GatewayPublicIp on GatewayPublicIpResponseType {
  __typename
  reportedAt
  publicIp
}
    `, {"fragmentName":"GatewayPublicIp"});
export const GatewayFragmentDoc = new TypedDocumentString(`
    fragment Gateway on GatewayResponseType {
  __typename
  name
  description
  gatewayId
  groupId
  updateTimestamp
  creationTimestamp
  objectVersion
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  setupCommands {
    __typename
    ...GatewaySetupCommand
  }
  linkedDevices {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
  metadata {
    __typename
    ...GatewayMetadata
  }
  publicIp {
    __typename
    ...GatewayPublicIp
  }
  state {
    __typename
    reportedAt
    state
  }
  location {
    __typename
    latitudeE6
    longitudeE6
    country
    state
    city
    horizontalAccuracy
    horizontalConfidenceLevelPercentage
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment GatewaySetupType on GatewaySetupType {
  __typename
  configurationCommand
  installationCommand
  osName
  osType
}
fragment GatewaySetupCommand on GatewaySetupResponseType {
  __typename
  expiresAt
  osCommands {
    __typename
    ...GatewaySetupType
  }
}
fragment GatewayMetadata on GatewayMetadataResponseType {
  __typename
  reportedAt
  version
  latestVersion
  latestVersionForMajor
  architecture
  operatingSystem
  operatingSystemAttrs {
    __typename
    ... on WindowsAttrsType {
      __typename
      productId
      productName
      compositionEditionId
      currentBuild
      currentVersion
      displayVersion
      editionId
      installationType
      registeredOrganization
      registeredOwner
      winreVersion
    }
    ... on LinuxAttrsType {
      __typename
      distro
      version
      kernel
      procVersion
    }
  }
  numCpu
  isOutdated
  isOutdatedForMajor
}
fragment GatewayPublicIp on GatewayPublicIpResponseType {
  __typename
  reportedAt
  publicIp
}`, {"fragmentName":"Gateway"});
export const GatewayLinkedToDeviceFragmentDoc = new TypedDocumentString(`
    fragment GatewayLinkedToDevice on GatewayResponseType {
  __typename
  ...Gateway
  linkMetaData {
    __typename
    ... on DeviceToGatewayLinkMetaDataType {
      __typename
      primary
    }
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Gateway on GatewayResponseType {
  __typename
  name
  description
  gatewayId
  groupId
  updateTimestamp
  creationTimestamp
  objectVersion
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  setupCommands {
    __typename
    ...GatewaySetupCommand
  }
  linkedDevices {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
  metadata {
    __typename
    ...GatewayMetadata
  }
  publicIp {
    __typename
    ...GatewayPublicIp
  }
  state {
    __typename
    reportedAt
    state
  }
  location {
    __typename
    latitudeE6
    longitudeE6
    country
    state
    city
    horizontalAccuracy
    horizontalConfidenceLevelPercentage
  }
}
fragment GatewaySetupType on GatewaySetupType {
  __typename
  configurationCommand
  installationCommand
  osName
  osType
}
fragment GatewaySetupCommand on GatewaySetupResponseType {
  __typename
  expiresAt
  osCommands {
    __typename
    ...GatewaySetupType
  }
}
fragment GatewayMetadata on GatewayMetadataResponseType {
  __typename
  reportedAt
  version
  latestVersion
  latestVersionForMajor
  architecture
  operatingSystem
  operatingSystemAttrs {
    __typename
    ... on WindowsAttrsType {
      __typename
      productId
      productName
      compositionEditionId
      currentBuild
      currentVersion
      displayVersion
      editionId
      installationType
      registeredOrganization
      registeredOwner
      winreVersion
    }
    ... on LinuxAttrsType {
      __typename
      distro
      version
      kernel
      procVersion
    }
  }
  numCpu
  isOutdated
  isOutdatedForMajor
}
fragment GatewayPublicIp on GatewayPublicIpResponseType {
  __typename
  reportedAt
  publicIp
}`, {"fragmentName":"GatewayLinkedToDevice"});
export const DeviceFragmentDoc = new TypedDocumentString(`
    fragment Device on DeviceResponseType {
  __typename
  deviceId
  deviceType
  vendorId
  ideConfigId
  groupId
  name
  secretId
  ftpConfiguration {
    __typename
    secretId
    ipAddress
    port
    rootDirectory
    protocol
  }
  smbConfiguration {
    __typename
    secretId
    ipAddress
    port
    protocol
    rootDirectory
  }
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  creationTimestamp
  linkedProjects {
    __typename
    itemCount
    items {
      __typename
      ...LinkedProjectFromDevice
    }
  }
  connectionConfiguration {
    __typename
    gatewayIpAddress
    ipAddress
    port
    subnetMask
  }
  objectVersion
  description
  linkedGateways {
    __typename
    itemCount
    items {
      __typename
      ...GatewayLinkedToDevice
    }
  }
  linkedDocuments {
    __typename
    itemCount
  }
  metaData
}
    fragment LinkedProjectFromDevice on ProjectResponseType {
  __typename
  ...Project
  linkMetaData {
    __typename
    ... on ProjectToDeviceLinkMetaDataType {
      __typename
      ...ProjectToDeviceLinkMetaData
    }
  }
}
fragment ProjectToDeviceLinkMetaData on ProjectToDeviceLinkMetaDataType {
  __typename
  targetProjectVersionId
  deviceName
  deviceIpAddress
  deviceSubnet
  deviceType
}
fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Gateway on GatewayResponseType {
  __typename
  name
  description
  gatewayId
  groupId
  updateTimestamp
  creationTimestamp
  objectVersion
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  setupCommands {
    __typename
    ...GatewaySetupCommand
  }
  linkedDevices {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
  metadata {
    __typename
    ...GatewayMetadata
  }
  publicIp {
    __typename
    ...GatewayPublicIp
  }
  state {
    __typename
    reportedAt
    state
  }
  location {
    __typename
    latitudeE6
    longitudeE6
    country
    state
    city
    horizontalAccuracy
    horizontalConfidenceLevelPercentage
  }
}
fragment GatewaySetupType on GatewaySetupType {
  __typename
  configurationCommand
  installationCommand
  osName
  osType
}
fragment GatewaySetupCommand on GatewaySetupResponseType {
  __typename
  expiresAt
  osCommands {
    __typename
    ...GatewaySetupType
  }
}
fragment GatewayMetadata on GatewayMetadataResponseType {
  __typename
  reportedAt
  version
  latestVersion
  latestVersionForMajor
  architecture
  operatingSystem
  operatingSystemAttrs {
    __typename
    ... on WindowsAttrsType {
      __typename
      productId
      productName
      compositionEditionId
      currentBuild
      currentVersion
      displayVersion
      editionId
      installationType
      registeredOrganization
      registeredOwner
      winreVersion
    }
    ... on LinuxAttrsType {
      __typename
      distro
      version
      kernel
      procVersion
    }
  }
  numCpu
  isOutdated
  isOutdatedForMajor
}
fragment GatewayPublicIp on GatewayPublicIpResponseType {
  __typename
  reportedAt
  publicIp
}
fragment GatewayLinkedToDevice on GatewayResponseType {
  __typename
  ...Gateway
  linkMetaData {
    __typename
    ... on DeviceToGatewayLinkMetaDataType {
      __typename
      primary
    }
  }
}
fragment Project on ProjectResponseType {
  __typename
  projectType
  vendorId
  name
  metaData
  attachedLicenses
  projectId
  groupId
  description
  ideConfigId
  creationTimestamp
  objectVersion
  updateTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  versions(
    filter: {source: {ne: "PROJECT_BACKUP"}}
    pagination: {page: 1, pageSize: 1}
  ) {
    __typename
    items {
      __typename
      ...ProjectVersion
    }
    itemCount
  }
  linkedDevices {
    __typename
    itemCount
    items {
      __typename
      deviceType
    }
  }
  secretId
  linkedSubProjects {
    __typename
    itemCount
  }
  linkedParentProjects {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
}
fragment DeviceInformation on DeviceInformationType {
  __typename
  name
  deviceType
  ethernetCommunication {
    __typename
    ipAddress
    subnetMask
  }
}
fragment ProjectVersion on ProjectVersionResponseType {
  __typename
  versionNumber
  projectId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  projectFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  source
  commitMessage
  deviceInformation {
    __typename
    ...DeviceInformation
  }
}`, {"fragmentName":"Device"});
export const DeviceConnectivityStatusFragmentDoc = new TypedDocumentString(`
    fragment DeviceConnectivityStatus on DeviceConnectivityStatusReportType {
  __typename
  gatewayId
  reportedAt
  deviceStatus
  devicePingStatus
  deviceNetcatStatus
  ftpStatus
  ftpPingStatus
  ftpNetcatStatus
  smbStatus
  smbPingStatus
  smbNetcatStatus
}
    `, {"fragmentName":"DeviceConnectivityStatus"});
export const DeviceFirmwareInformationDetailFragmentDoc = new TypedDocumentString(`
    fragment DeviceFirmwareInformationDetail on DeviceFirmwareInformationDataType {
  __typename
  deviceName
  deviceType
  articleNumber
  firmwareVersion
  slot
  configuration
  serialNumber
  hardwareVersion
}
    `, {"fragmentName":"DeviceFirmwareInformationDetail"});
export const DeviceFirmwareInformationFragmentDoc = new TypedDocumentString(`
    fragment DeviceFirmwareInformation on DeviceFirmwareInformationResponseType {
  __typename
  readTimestamp
  details {
    __typename
    ...DeviceFirmwareInformationDetail
  }
}
    fragment DeviceFirmwareInformationDetail on DeviceFirmwareInformationDataType {
  __typename
  deviceName
  deviceType
  articleNumber
  firmwareVersion
  slot
  configuration
  serialNumber
  hardwareVersion
}`, {"fragmentName":"DeviceFirmwareInformation"});
export const DocumentVersionFragmentDoc = new TypedDocumentString(`
    fragment DocumentVersion on DocumentVersionResponseType {
  __typename
  versionNumber
  documentId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  documentFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  commitMessage
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`, {"fragmentName":"DocumentVersion"});
export const DocumentFragmentDoc = new TypedDocumentString(`
    fragment Document on DocumentResponseType {
  __typename
  documentId
  name
  groupId
  documentType
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  creationTimestamp
  versions(pagination: {page: 1, pageSize: 1}) {
    __typename
    items {
      __typename
      ...DocumentVersion
    }
    itemCount
  }
  objectVersion
}
    fragment DocumentVersion on DocumentVersionResponseType {
  __typename
  versionNumber
  documentId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  documentFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  commitMessage
}
fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`, {"fragmentName":"Document"});
export const DocumentLinkedToAssetResponseFragmentDoc = new TypedDocumentString(`
    fragment DocumentLinkedToAssetResponse on DocumentResponseType {
  __typename
  ...Document
  linkMetaData {
    __typename
    ... on DocumentToAssetLinkMetaDataType {
      __typename
      assetVersionId
    }
  }
}
    fragment Document on DocumentResponseType {
  __typename
  documentId
  name
  groupId
  documentType
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  creationTimestamp
  versions(pagination: {page: 1, pageSize: 1}) {
    __typename
    items {
      __typename
      ...DocumentVersion
    }
    itemCount
  }
  objectVersion
}
fragment DocumentVersion on DocumentVersionResponseType {
  __typename
  versionNumber
  documentId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  documentFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  commitMessage
}
fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`, {"fragmentName":"DocumentLinkedToAssetResponse"});
export const LinkedAssetFromDocumentFragmentDoc = new TypedDocumentString(`
    fragment LinkedAssetFromDocument on AssetLinkResponseType {
  __typename
  destinationId
  destinationType
  metaData {
    __typename
    ... on DocumentToAssetLinkMetaDataType {
      __typename
      assetVersionId
    }
  }
}
    `, {"fragmentName":"LinkedAssetFromDocument"});
export const GatewayConfigFragmentDoc = new TypedDocumentString(`
    fragment GatewayConfig on GatewayConfigResponseType {
  __typename
  objectVersion
  reportedAt
  requestedAt
  values {
    __typename
    metaVersion
    sslTunnel
    sslTunnelInsecure
    updateAuto
    updateUnstable
    webuiBase
    webuiEnabled
    webuiPort
  }
}
    `, {"fragmentName":"GatewayConfig"});
export const DeviceSyncStatusFragmentDoc = new TypedDocumentString(`
    fragment DeviceSyncStatus on DeviceSyncStatusResponseType {
  __typename
  previousSyncStatus
  syncErrorMessage
  syncTimestamp
  syncType
  targetSyncStatus
  syncJobId
}
    `, {"fragmentName":"DeviceSyncStatus"});
export const AccumulatedDeviceSyncStatusFragmentDoc = new TypedDocumentString(`
    fragment AccumulatedDeviceSyncStatus on AccumulatedDeviceSyncStatusResponseType {
  __typename
  syncTimestamp
  targetSyncStatus
  previousSyncStatus
  details {
    __typename
    ...DeviceSyncStatus
  }
}
    fragment DeviceSyncStatus on DeviceSyncStatusResponseType {
  __typename
  previousSyncStatus
  syncErrorMessage
  syncTimestamp
  syncType
  targetSyncStatus
  syncJobId
}`, {"fragmentName":"AccumulatedDeviceSyncStatus"});
export const SyncedDeviceFragmentDoc = new TypedDocumentString(`
    fragment SyncedDevice on DeviceResponseType {
  __typename
  deviceId
  deviceType
  name
  vendorId
  accumulatedSyncStatus {
    __typename
    ...AccumulatedDeviceSyncStatus
  }
}
    fragment DeviceSyncStatus on DeviceSyncStatusResponseType {
  __typename
  previousSyncStatus
  syncErrorMessage
  syncTimestamp
  syncType
  targetSyncStatus
  syncJobId
}
fragment AccumulatedDeviceSyncStatus on AccumulatedDeviceSyncStatusResponseType {
  __typename
  syncTimestamp
  targetSyncStatus
  previousSyncStatus
  details {
    __typename
    ...DeviceSyncStatus
  }
}`, {"fragmentName":"SyncedDevice"});
export const ResourceSubGroupFragmentDoc = new TypedDocumentString(`
    fragment ResourceSubGroup on ResourceGroupResponseType {
  __typename
  groupId
  objectVersion
  name
}
    `, {"fragmentName":"ResourceSubGroup"});
export const GroupTreeItemFragmentDoc = new TypedDocumentString(`
    fragment GroupTreeItem on ResourceGroupResponseType {
  __typename
  groupId
  name
  parentGroupId
  creationTimestamp
  updateTimestamp
  objectVersion
  groupDevicesSyncStatus(
    filter: {deviceSyncStatus: {in_: ["ERROR", "NOT_SYNCED"]}}
  ) {
    __typename
    groupSyncStatus
    devicesSyncStatus {
      __typename
      deviceName
      deviceId
      syncStatus
      syncStatusTimestamp
      groupId
    }
  }
}
    `, {"fragmentName":"GroupTreeItem"});
export const SubGroupFragmentDoc = new TypedDocumentString(`
    fragment SubGroup on ResourceGroupResponseType {
  __typename
  name
  groupId
  creationTimestamp
  updateTimestamp
}
    `, {"fragmentName":"SubGroup"});
export const ResourceGroupFragmentDoc = new TypedDocumentString(`
    fragment ResourceGroup on ResourceGroupResponseType {
  __typename
  updateUser {
    __typename
    ...AssetUserInfo
  }
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  creationTimestamp
  name
  parentGroupId
  groupId
  objectVersion
  subGroups {
    __typename
    itemCount
    items {
      __typename
      ...SubGroup
    }
    pages
  }
  groupDevicesSyncStatus(
    filter: {deviceSyncStatus: {in_: ["ERROR", "NOT_SYNCED"]}}
  ) {
    __typename
    groupSyncStatus
    devicesSyncStatus {
      __typename
      deviceName
      deviceId
      syncStatus
      syncStatusTimestamp
      groupId
    }
  }
  fullPaths
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment SubGroup on ResourceGroupResponseType {
  __typename
  name
  groupId
  creationTimestamp
  updateTimestamp
}`, {"fragmentName":"ResourceGroup"});
export const ResourceGroupParentChildPairFragmentDoc = new TypedDocumentString(`
    fragment ResourceGroupParentChildPair on ResourceGroupForPermissionResponseType {
  __typename
  groupId
  parentGroupId
}
    `, {"fragmentName":"ResourceGroupParentChildPair"});
export const LicenseFragmentDoc = new TypedDocumentString(`
    fragment License on LicenseResponseType {
  __typename
  name
  groupId
  licenseId
  objectVersion
  product
  productKey
  quantity
  serialId
  status
  type
  ideConfigId
  updateTimestamp
  updateUser {
    __typename
    ...AssetUserInfo
  }
  creationUser {
    __typename
    ...AssetUserInfo
  }
  creationTimestamp
  family
  vendorId
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`, {"fragmentName":"License"});
export const LockFragmentDoc = new TypedDocumentString(`
    fragment Lock on LockResponseType {
  __typename
  creationUser {
    __typename
    ...AssetUserInfo
  }
  service
  creationTimestamp
  message
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`, {"fragmentName":"Lock"});
export const LinkedLibraryFragmentDoc = new TypedDocumentString(`
    fragment LinkedLibrary on ProjectResponseType {
  __typename
  ...Project
  linkMetaData {
    __typename
    ... on ProjectToProjectLinkMetaDataType {
      __typename
      destinationVersionId
      sourceVersionId
    }
  }
  updateTimestamp
  objectVersion
  linkedSubProjects {
    __typename
    itemCount
  }
  linkedParentProjects {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Project on ProjectResponseType {
  __typename
  projectType
  vendorId
  name
  metaData
  attachedLicenses
  projectId
  groupId
  description
  ideConfigId
  creationTimestamp
  objectVersion
  updateTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  versions(
    filter: {source: {ne: "PROJECT_BACKUP"}}
    pagination: {page: 1, pageSize: 1}
  ) {
    __typename
    items {
      __typename
      ...ProjectVersion
    }
    itemCount
  }
  linkedDevices {
    __typename
    itemCount
    items {
      __typename
      deviceType
    }
  }
  secretId
  linkedSubProjects {
    __typename
    itemCount
  }
  linkedParentProjects {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
}
fragment DeviceInformation on DeviceInformationType {
  __typename
  name
  deviceType
  ethernetCommunication {
    __typename
    ipAddress
    subnetMask
  }
}
fragment ProjectVersion on ProjectVersionResponseType {
  __typename
  versionNumber
  projectId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  projectFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  source
  commitMessage
  deviceInformation {
    __typename
    ...DeviceInformation
  }
}`, {"fragmentName":"LinkedLibrary"});
export const TagFragmentDoc = new TypedDocumentString(`
    fragment Tag on TagResponseType {
  __typename
  name
}
    `, {"fragmentName":"Tag"});
export const FullTagFragmentDoc = new TypedDocumentString(`
    fragment FullTag on TagResponseType {
  __typename
  ...Tag
  creationUser {
    __typename
    ...AssetUserInfo
  }
  creationTimestamp
  devices {
    __typename
    items {
      __typename
      name
      deviceId
    }
    itemCount
  }
  projects {
    __typename
    items {
      __typename
      name
      projectId
    }
    itemCount
  }
  documents {
    __typename
    items {
      __typename
      name
      documentId
    }
    itemCount
  }
  gateways {
    __typename
    items {
      __typename
      name
      gatewayId
    }
    itemCount
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Tag on TagResponseType {
  __typename
  name
}`, {"fragmentName":"FullTag"});
export const VaultFragmentDoc = new TypedDocumentString(`
    fragment Vault on VaultResponseType {
  __typename
  vaultId
  groupId
  name
  objectVersion
  creationTimestamp
  updateTimestamp
  secrets {
    __typename
    items {
      __typename
      secretId
      secretType
      weakSecret
      linkedDevices {
        __typename
        itemCount
      }
      linkedProjects {
        __typename
        itemCount
      }
    }
    itemCount
  }
  creationUser {
    __typename
    ...AssetUserInfo
  }
  description
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`, {"fragmentName":"Vault"});
export const SecretFragmentDoc = new TypedDocumentString(`
    fragment Secret on SecretResponseType {
  __typename
  secretId
  vault {
    __typename
    name
    vaultId
  }
  secretType
  weakSecret
  name
  username
  secretValue
  objectVersion
  linkedDevices {
    __typename
    itemCount
    items {
      __typename
      name
      deviceId
    }
  }
  linkedProjects {
    __typename
    itemCount
    items {
      __typename
      name
      projectId
    }
  }
}
    `, {"fragmentName":"Secret"});
export const SecretUnceiledFragmentDoc = new TypedDocumentString(`
    fragment SecretUnceiled on SecretUnceiledResponseType {
  __typename
  secretId
  secretValue
}
    `, {"fragmentName":"SecretUnceiled"});
export const WeakSecretsFragmentDoc = new TypedDocumentString(`
    fragment WeakSecrets on VaultResponseType {
  __typename
  vaultId
  secrets {
    __typename
    itemCount
    items {
      __typename
      secretId
      weakSecret
    }
  }
}
    `, {"fragmentName":"WeakSecrets"});
export const DeviceVulnerabilityFragmentDoc = new TypedDocumentString(`
    fragment DeviceVulnerability on DeviceOtCveResponseType {
  __typename
  deviceId
  deviceName
  deviceType
  vendor
  deviceVersion
  firmwareDeviceName
  cveNumber
  nvdSeverity
  affectedVersion
  fixedVersion
  constraint
  productArticleNumber
  isVulnerable
  publishedDate
  cvssScore
}
    `, {"fragmentName":"DeviceVulnerability"});
export const OtCveRecordFieldsFragmentDoc = new TypedDocumentString(`
    fragment OtCveRecordFields on OtCveRecordType {
  __typename
  cveNumber
  cveTitle
  description
  nvdDescription
  cvssScore
  publishDate
  productArticleNumber
  productName
  affectedVersions
  fixedVersions
  advisoryLink
  nvdSeverity
  nvdUrl
}
    `, {"fragmentName":"OtCveRecordFields"});
export const WorkstationSetupCommandFragmentDoc = new TypedDocumentString(`
    fragment WorkstationSetupCommand on WorkstationSetupResponseType {
  __typename
  expiresAt
  osCommands {
    __typename
    configurationCommand
    installationCommand
    osName
    osType
  }
}
    `, {"fragmentName":"WorkstationSetupCommand"});
export const WorkstationMetadataFragmentDoc = new TypedDocumentString(`
    fragment WorkstationMetadata on WorkstationMetadataResponseType {
  __typename
  architecture
  isOutdated
  isOutdatedForMajor
  latestVersion
  latestVersionForMajor
  numCpu
  operatingSystem
  reportedAt
  version
}
    `, {"fragmentName":"WorkstationMetadata"});
export const WorkstationPublicIpFragmentDoc = new TypedDocumentString(`
    fragment WorkstationPublicIp on WorkstationPublicIpResponseType {
  __typename
  publicIp
  reportedAt
  publicIpLocation {
    __typename
    city
    country
    state
  }
}
    `, {"fragmentName":"WorkstationPublicIp"});
export const WorkstationFragmentDoc = new TypedDocumentString(`
    fragment Workstation on WorkstationResponseType {
  __typename
  name
  description
  workstationId
  groupId
  updateTimestamp
  creationTimestamp
  objectVersion
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  setupCommands {
    __typename
    ...WorkstationSetupCommand
  }
  metadata {
    __typename
    ...WorkstationMetadata
  }
  publicIp {
    __typename
    ...WorkstationPublicIp
  }
  state {
    __typename
    reportedAt
    state
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment WorkstationPublicIp on WorkstationPublicIpResponseType {
  __typename
  publicIp
  reportedAt
  publicIpLocation {
    __typename
    city
    country
    state
  }
}
fragment WorkstationMetadata on WorkstationMetadataResponseType {
  __typename
  architecture
  isOutdated
  isOutdatedForMajor
  latestVersion
  latestVersionForMajor
  numCpu
  operatingSystem
  reportedAt
  version
}
fragment WorkstationSetupCommand on WorkstationSetupResponseType {
  __typename
  expiresAt
  osCommands {
    __typename
    configurationCommand
    installationCommand
    osName
    osType
  }
}`, {"fragmentName":"Workstation"});
export const WorkstationDeviceConnectionFragmentDoc = new TypedDocumentString(`
    fragment WorkstationDeviceConnection on WorkstationDeviceConnectionV2Type {
  __typename
  connectionId
  connectionState
  deviceId
  gatewayId
  workstationId
}
    `, {"fragmentName":"WorkstationDeviceConnection"});
export const CreateDeviceDocument = new TypedDocumentString(`
    mutation CreateDevice($device: CreateDeviceInput!) {
  __typename
  createDevice(device: $device) {
    __typename
    deviceId
    groupId
    deviceId
  }
}
    `);
export const UpdateDeviceDocument = new TypedDocumentString(`
    mutation UpdateDevice($deviceId: String!, $device: UpdateDeviceInput!) {
  __typename
  updateDevice(deviceId: $deviceId, device: $device) {
    __typename
    groupId
    deviceId
  }
}
    `);
export const DeleteDeviceDocument = new TypedDocumentString(`
    mutation DeleteDevice($deviceId: String!) {
  __typename
  deleteDevice(deviceId: $deviceId) {
    __typename
    groupId
    deviceId
  }
}
    `);
export const ReadAllDevicesDocument = new TypedDocumentString(`
    query ReadAllDevices($filter: DeviceFilterInput, $pagination: PaginationInput) {
  __typename
  readAllDevices(filter: $filter, pagination: $pagination) {
    __typename
    items {
      __typename
      ...Device
    }
    itemCount
    pages
  }
}
    fragment Device on DeviceResponseType {
  __typename
  deviceId
  deviceType
  vendorId
  ideConfigId
  groupId
  name
  secretId
  ftpConfiguration {
    __typename
    secretId
    ipAddress
    port
    rootDirectory
    protocol
  }
  smbConfiguration {
    __typename
    secretId
    ipAddress
    port
    protocol
    rootDirectory
  }
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  creationTimestamp
  linkedProjects {
    __typename
    itemCount
    items {
      __typename
      ...LinkedProjectFromDevice
    }
  }
  connectionConfiguration {
    __typename
    gatewayIpAddress
    ipAddress
    port
    subnetMask
  }
  objectVersion
  description
  linkedGateways {
    __typename
    itemCount
    items {
      __typename
      ...GatewayLinkedToDevice
    }
  }
  linkedDocuments {
    __typename
    itemCount
  }
  metaData
}
fragment LinkedProjectFromDevice on ProjectResponseType {
  __typename
  ...Project
  linkMetaData {
    __typename
    ... on ProjectToDeviceLinkMetaDataType {
      __typename
      ...ProjectToDeviceLinkMetaData
    }
  }
}
fragment ProjectToDeviceLinkMetaData on ProjectToDeviceLinkMetaDataType {
  __typename
  targetProjectVersionId
  deviceName
  deviceIpAddress
  deviceSubnet
  deviceType
}
fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Gateway on GatewayResponseType {
  __typename
  name
  description
  gatewayId
  groupId
  updateTimestamp
  creationTimestamp
  objectVersion
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  setupCommands {
    __typename
    ...GatewaySetupCommand
  }
  linkedDevices {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
  metadata {
    __typename
    ...GatewayMetadata
  }
  publicIp {
    __typename
    ...GatewayPublicIp
  }
  state {
    __typename
    reportedAt
    state
  }
  location {
    __typename
    latitudeE6
    longitudeE6
    country
    state
    city
    horizontalAccuracy
    horizontalConfidenceLevelPercentage
  }
}
fragment GatewaySetupType on GatewaySetupType {
  __typename
  configurationCommand
  installationCommand
  osName
  osType
}
fragment GatewaySetupCommand on GatewaySetupResponseType {
  __typename
  expiresAt
  osCommands {
    __typename
    ...GatewaySetupType
  }
}
fragment GatewayMetadata on GatewayMetadataResponseType {
  __typename
  reportedAt
  version
  latestVersion
  latestVersionForMajor
  architecture
  operatingSystem
  operatingSystemAttrs {
    __typename
    ... on WindowsAttrsType {
      __typename
      productId
      productName
      compositionEditionId
      currentBuild
      currentVersion
      displayVersion
      editionId
      installationType
      registeredOrganization
      registeredOwner
      winreVersion
    }
    ... on LinuxAttrsType {
      __typename
      distro
      version
      kernel
      procVersion
    }
  }
  numCpu
  isOutdated
  isOutdatedForMajor
}
fragment GatewayPublicIp on GatewayPublicIpResponseType {
  __typename
  reportedAt
  publicIp
}
fragment GatewayLinkedToDevice on GatewayResponseType {
  __typename
  ...Gateway
  linkMetaData {
    __typename
    ... on DeviceToGatewayLinkMetaDataType {
      __typename
      primary
    }
  }
}
fragment Project on ProjectResponseType {
  __typename
  projectType
  vendorId
  name
  metaData
  attachedLicenses
  projectId
  groupId
  description
  ideConfigId
  creationTimestamp
  objectVersion
  updateTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  versions(
    filter: {source: {ne: "PROJECT_BACKUP"}}
    pagination: {page: 1, pageSize: 1}
  ) {
    __typename
    items {
      __typename
      ...ProjectVersion
    }
    itemCount
  }
  linkedDevices {
    __typename
    itemCount
    items {
      __typename
      deviceType
    }
  }
  secretId
  linkedSubProjects {
    __typename
    itemCount
  }
  linkedParentProjects {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
}
fragment DeviceInformation on DeviceInformationType {
  __typename
  name
  deviceType
  ethernetCommunication {
    __typename
    ipAddress
    subnetMask
  }
}
fragment ProjectVersion on ProjectVersionResponseType {
  __typename
  versionNumber
  projectId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  projectFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  source
  commitMessage
  deviceInformation {
    __typename
    ...DeviceInformation
  }
}`);
export const ReadDevicesByIdsDocument = new TypedDocumentString(`
    query ReadDevicesByIds($deviceIds: [String!]!) {
  __typename
  readDevicesByIds(deviceIds: $deviceIds) {
    __typename
    items {
      __typename
      ...Device
    }
    itemCount
  }
}
    fragment Device on DeviceResponseType {
  __typename
  deviceId
  deviceType
  vendorId
  ideConfigId
  groupId
  name
  secretId
  ftpConfiguration {
    __typename
    secretId
    ipAddress
    port
    rootDirectory
    protocol
  }
  smbConfiguration {
    __typename
    secretId
    ipAddress
    port
    protocol
    rootDirectory
  }
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  creationTimestamp
  linkedProjects {
    __typename
    itemCount
    items {
      __typename
      ...LinkedProjectFromDevice
    }
  }
  connectionConfiguration {
    __typename
    gatewayIpAddress
    ipAddress
    port
    subnetMask
  }
  objectVersion
  description
  linkedGateways {
    __typename
    itemCount
    items {
      __typename
      ...GatewayLinkedToDevice
    }
  }
  linkedDocuments {
    __typename
    itemCount
  }
  metaData
}
fragment LinkedProjectFromDevice on ProjectResponseType {
  __typename
  ...Project
  linkMetaData {
    __typename
    ... on ProjectToDeviceLinkMetaDataType {
      __typename
      ...ProjectToDeviceLinkMetaData
    }
  }
}
fragment ProjectToDeviceLinkMetaData on ProjectToDeviceLinkMetaDataType {
  __typename
  targetProjectVersionId
  deviceName
  deviceIpAddress
  deviceSubnet
  deviceType
}
fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Gateway on GatewayResponseType {
  __typename
  name
  description
  gatewayId
  groupId
  updateTimestamp
  creationTimestamp
  objectVersion
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  setupCommands {
    __typename
    ...GatewaySetupCommand
  }
  linkedDevices {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
  metadata {
    __typename
    ...GatewayMetadata
  }
  publicIp {
    __typename
    ...GatewayPublicIp
  }
  state {
    __typename
    reportedAt
    state
  }
  location {
    __typename
    latitudeE6
    longitudeE6
    country
    state
    city
    horizontalAccuracy
    horizontalConfidenceLevelPercentage
  }
}
fragment GatewaySetupType on GatewaySetupType {
  __typename
  configurationCommand
  installationCommand
  osName
  osType
}
fragment GatewaySetupCommand on GatewaySetupResponseType {
  __typename
  expiresAt
  osCommands {
    __typename
    ...GatewaySetupType
  }
}
fragment GatewayMetadata on GatewayMetadataResponseType {
  __typename
  reportedAt
  version
  latestVersion
  latestVersionForMajor
  architecture
  operatingSystem
  operatingSystemAttrs {
    __typename
    ... on WindowsAttrsType {
      __typename
      productId
      productName
      compositionEditionId
      currentBuild
      currentVersion
      displayVersion
      editionId
      installationType
      registeredOrganization
      registeredOwner
      winreVersion
    }
    ... on LinuxAttrsType {
      __typename
      distro
      version
      kernel
      procVersion
    }
  }
  numCpu
  isOutdated
  isOutdatedForMajor
}
fragment GatewayPublicIp on GatewayPublicIpResponseType {
  __typename
  reportedAt
  publicIp
}
fragment GatewayLinkedToDevice on GatewayResponseType {
  __typename
  ...Gateway
  linkMetaData {
    __typename
    ... on DeviceToGatewayLinkMetaDataType {
      __typename
      primary
    }
  }
}
fragment Project on ProjectResponseType {
  __typename
  projectType
  vendorId
  name
  metaData
  attachedLicenses
  projectId
  groupId
  description
  ideConfigId
  creationTimestamp
  objectVersion
  updateTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  versions(
    filter: {source: {ne: "PROJECT_BACKUP"}}
    pagination: {page: 1, pageSize: 1}
  ) {
    __typename
    items {
      __typename
      ...ProjectVersion
    }
    itemCount
  }
  linkedDevices {
    __typename
    itemCount
    items {
      __typename
      deviceType
    }
  }
  secretId
  linkedSubProjects {
    __typename
    itemCount
  }
  linkedParentProjects {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
}
fragment DeviceInformation on DeviceInformationType {
  __typename
  name
  deviceType
  ethernetCommunication {
    __typename
    ipAddress
    subnetMask
  }
}
fragment ProjectVersion on ProjectVersionResponseType {
  __typename
  versionNumber
  projectId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  projectFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  source
  commitMessage
  deviceInformation {
    __typename
    ...DeviceInformation
  }
}`);
export const ReadDeviceDocument = new TypedDocumentString(`
    query ReadDevice($deviceId: String!) {
  __typename
  readDevice(deviceId: $deviceId) {
    __typename
    ...Device
  }
}
    fragment Device on DeviceResponseType {
  __typename
  deviceId
  deviceType
  vendorId
  ideConfigId
  groupId
  name
  secretId
  ftpConfiguration {
    __typename
    secretId
    ipAddress
    port
    rootDirectory
    protocol
  }
  smbConfiguration {
    __typename
    secretId
    ipAddress
    port
    protocol
    rootDirectory
  }
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  creationTimestamp
  linkedProjects {
    __typename
    itemCount
    items {
      __typename
      ...LinkedProjectFromDevice
    }
  }
  connectionConfiguration {
    __typename
    gatewayIpAddress
    ipAddress
    port
    subnetMask
  }
  objectVersion
  description
  linkedGateways {
    __typename
    itemCount
    items {
      __typename
      ...GatewayLinkedToDevice
    }
  }
  linkedDocuments {
    __typename
    itemCount
  }
  metaData
}
fragment LinkedProjectFromDevice on ProjectResponseType {
  __typename
  ...Project
  linkMetaData {
    __typename
    ... on ProjectToDeviceLinkMetaDataType {
      __typename
      ...ProjectToDeviceLinkMetaData
    }
  }
}
fragment ProjectToDeviceLinkMetaData on ProjectToDeviceLinkMetaDataType {
  __typename
  targetProjectVersionId
  deviceName
  deviceIpAddress
  deviceSubnet
  deviceType
}
fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Gateway on GatewayResponseType {
  __typename
  name
  description
  gatewayId
  groupId
  updateTimestamp
  creationTimestamp
  objectVersion
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  setupCommands {
    __typename
    ...GatewaySetupCommand
  }
  linkedDevices {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
  metadata {
    __typename
    ...GatewayMetadata
  }
  publicIp {
    __typename
    ...GatewayPublicIp
  }
  state {
    __typename
    reportedAt
    state
  }
  location {
    __typename
    latitudeE6
    longitudeE6
    country
    state
    city
    horizontalAccuracy
    horizontalConfidenceLevelPercentage
  }
}
fragment GatewaySetupType on GatewaySetupType {
  __typename
  configurationCommand
  installationCommand
  osName
  osType
}
fragment GatewaySetupCommand on GatewaySetupResponseType {
  __typename
  expiresAt
  osCommands {
    __typename
    ...GatewaySetupType
  }
}
fragment GatewayMetadata on GatewayMetadataResponseType {
  __typename
  reportedAt
  version
  latestVersion
  latestVersionForMajor
  architecture
  operatingSystem
  operatingSystemAttrs {
    __typename
    ... on WindowsAttrsType {
      __typename
      productId
      productName
      compositionEditionId
      currentBuild
      currentVersion
      displayVersion
      editionId
      installationType
      registeredOrganization
      registeredOwner
      winreVersion
    }
    ... on LinuxAttrsType {
      __typename
      distro
      version
      kernel
      procVersion
    }
  }
  numCpu
  isOutdated
  isOutdatedForMajor
}
fragment GatewayPublicIp on GatewayPublicIpResponseType {
  __typename
  reportedAt
  publicIp
}
fragment GatewayLinkedToDevice on GatewayResponseType {
  __typename
  ...Gateway
  linkMetaData {
    __typename
    ... on DeviceToGatewayLinkMetaDataType {
      __typename
      primary
    }
  }
}
fragment Project on ProjectResponseType {
  __typename
  projectType
  vendorId
  name
  metaData
  attachedLicenses
  projectId
  groupId
  description
  ideConfigId
  creationTimestamp
  objectVersion
  updateTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  versions(
    filter: {source: {ne: "PROJECT_BACKUP"}}
    pagination: {page: 1, pageSize: 1}
  ) {
    __typename
    items {
      __typename
      ...ProjectVersion
    }
    itemCount
  }
  linkedDevices {
    __typename
    itemCount
    items {
      __typename
      deviceType
    }
  }
  secretId
  linkedSubProjects {
    __typename
    itemCount
  }
  linkedParentProjects {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
}
fragment DeviceInformation on DeviceInformationType {
  __typename
  name
  deviceType
  ethernetCommunication {
    __typename
    ipAddress
    subnetMask
  }
}
fragment ProjectVersion on ProjectVersionResponseType {
  __typename
  versionNumber
  projectId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  projectFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  source
  commitMessage
  deviceInformation {
    __typename
    ...DeviceInformation
  }
}`);
export const ReadLinkedProjectsForDeviceDocument = new TypedDocumentString(`
    query ReadLinkedProjectsForDevice($deviceId: String!, $pagination: PaginationInput) {
  __typename
  readLinkedProjectsForDevice(deviceId: $deviceId, pagination: $pagination) {
    __typename
    items {
      __typename
      ...LinkedProjectFromDevice
    }
    itemCount
    pages
  }
}
    fragment LinkedProjectFromDevice on ProjectResponseType {
  __typename
  ...Project
  linkMetaData {
    __typename
    ... on ProjectToDeviceLinkMetaDataType {
      __typename
      ...ProjectToDeviceLinkMetaData
    }
  }
}
fragment ProjectToDeviceLinkMetaData on ProjectToDeviceLinkMetaDataType {
  __typename
  targetProjectVersionId
  deviceName
  deviceIpAddress
  deviceSubnet
  deviceType
}
fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Project on ProjectResponseType {
  __typename
  projectType
  vendorId
  name
  metaData
  attachedLicenses
  projectId
  groupId
  description
  ideConfigId
  creationTimestamp
  objectVersion
  updateTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  versions(
    filter: {source: {ne: "PROJECT_BACKUP"}}
    pagination: {page: 1, pageSize: 1}
  ) {
    __typename
    items {
      __typename
      ...ProjectVersion
    }
    itemCount
  }
  linkedDevices {
    __typename
    itemCount
    items {
      __typename
      deviceType
    }
  }
  secretId
  linkedSubProjects {
    __typename
    itemCount
  }
  linkedParentProjects {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
}
fragment DeviceInformation on DeviceInformationType {
  __typename
  name
  deviceType
  ethernetCommunication {
    __typename
    ipAddress
    subnetMask
  }
}
fragment ProjectVersion on ProjectVersionResponseType {
  __typename
  versionNumber
  projectId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  projectFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  source
  commitMessage
  deviceInformation {
    __typename
    ...DeviceInformation
  }
}`);
export const ReadDeviceSyncStatusDocument = new TypedDocumentString(`
    query ReadDeviceSyncStatus($deviceId: String!) {
  __typename
  readDevice(deviceId: $deviceId) {
    __typename
    accumulatedSyncStatus {
      __typename
      ...AccumulatedDeviceSyncStatus
    }
  }
}
    fragment DeviceSyncStatus on DeviceSyncStatusResponseType {
  __typename
  previousSyncStatus
  syncErrorMessage
  syncTimestamp
  syncType
  targetSyncStatus
  syncJobId
}
fragment AccumulatedDeviceSyncStatus on AccumulatedDeviceSyncStatusResponseType {
  __typename
  syncTimestamp
  targetSyncStatus
  previousSyncStatus
  details {
    __typename
    ...DeviceSyncStatus
  }
}`);
export const ReadDeviceNamesForRoleRowDocument = new TypedDocumentString(`
    query ReadDeviceNamesForRoleRow($deviceIds: [String!]!) {
  __typename
  readDevicesByIds(deviceIds: $deviceIds) {
    __typename
    items {
      __typename
      name
      deviceId
    }
  }
}
    `);
export const ReadDeviceConnectivityStatusDocument = new TypedDocumentString(`
    query ReadDeviceConnectivityStatus($deviceId: String!) {
  __typename
  readDeviceConnectivityStatus(deviceId: $deviceId) {
    __typename
    deviceId
    primaryGateway {
      __typename
      ...DeviceConnectivityStatus
    }
    allGateways {
      __typename
      ...DeviceConnectivityStatus
    }
  }
}
    fragment DeviceConnectivityStatus on DeviceConnectivityStatusReportType {
  __typename
  gatewayId
  reportedAt
  deviceStatus
  devicePingStatus
  deviceNetcatStatus
  ftpStatus
  ftpPingStatus
  ftpNetcatStatus
  smbStatus
  smbPingStatus
  smbNetcatStatus
}`);
export const ReadDeviceFirmwareInformationDocument = new TypedDocumentString(`
    query ReadDeviceFirmwareInformation($deviceId: String!) {
  __typename
  readDevice(deviceId: $deviceId) {
    __typename
    firmwareInformation {
      __typename
      ...DeviceFirmwareInformation
    }
  }
}
    fragment DeviceFirmwareInformationDetail on DeviceFirmwareInformationDataType {
  __typename
  deviceName
  deviceType
  articleNumber
  firmwareVersion
  slot
  configuration
  serialNumber
  hardwareVersion
}
fragment DeviceFirmwareInformation on DeviceFirmwareInformationResponseType {
  __typename
  readTimestamp
  details {
    __typename
    ...DeviceFirmwareInformationDetail
  }
}`);
export const CompleteDocumentMultipartUploadDocument = new TypedDocumentString(`
    mutation CompleteDocumentMultipartUpload($documentId: String!, $uploadId: String!, $completeUploadInput: CompleteMultipartUploadInput!, $versionId: String!) {
  __typename
  completeDocumentVersionMultipartUpload(
    documentId: $documentId
    uploadId: $uploadId
    completeUploadInput: $completeUploadInput
    versionId: $versionId
  )
}
    `);
export const CreateDocumentDocument = new TypedDocumentString(`
    mutation CreateDocument($document: CreateDocumentInput!) {
  __typename
  createDocument(document: $document) {
    __typename
    documentId
    versionId
    uploadUrls {
      __typename
      partNumber
      uploadUrl
    }
    uploadId
  }
}
    `);
export const CreateDocumentVersionDocument = new TypedDocumentString(`
    mutation CreateDocumentVersion($documentId: String!, $documentVersion: CreateDocumentVersionInput!) {
  __typename
  createDocumentVersion(
    documentId: $documentId
    documentVersion: $documentVersion
  ) {
    __typename
    documentId
    versionId
    uploadUrls {
      __typename
      partNumber
      uploadUrl
    }
    uploadId
  }
}
    `);
export const DeleteDocumentDocument = new TypedDocumentString(`
    mutation DeleteDocument($documentId: String!) {
  __typename
  deleteDocument(documentId: $documentId) {
    __typename
    documentId
  }
}
    `);
export const UpdateDocumentDocument = new TypedDocumentString(`
    mutation UpdateDocument($documentId: String!, $document: UpdateDocumentInput!) {
  __typename
  updateDocument(documentId: $documentId, document: $document) {
    __typename
    ...Document
  }
}
    fragment Document on DocumentResponseType {
  __typename
  documentId
  name
  groupId
  documentType
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  creationTimestamp
  versions(pagination: {page: 1, pageSize: 1}) {
    __typename
    items {
      __typename
      ...DocumentVersion
    }
    itemCount
  }
  objectVersion
}
fragment DocumentVersion on DocumentVersionResponseType {
  __typename
  versionNumber
  documentId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  documentFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  commitMessage
}
fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const UpdateDocumentVersionDocument = new TypedDocumentString(`
    mutation UpdateDocumentVersion($documentId: String!, $versionId: String!, $documentVersion: UpdateDocumentVersionInput!) {
  __typename
  updateDocumentVersion(
    documentId: $documentId
    versionId: $versionId
    documentVersion: $documentVersion
  ) {
    __typename
    ...DocumentVersion
  }
}
    fragment DocumentVersion on DocumentVersionResponseType {
  __typename
  versionNumber
  documentId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  documentFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  commitMessage
}
fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const DownloadDocumentVersionDocument = new TypedDocumentString(`
    query DownloadDocumentVersion($documentId: String!, $versionId: String!) {
  __typename
  downloadDocumentVersion(documentId: $documentId, versionId: $versionId) {
    __typename
    downloadUrl
  }
}
    `);
export const ReadDocumentsByIdsDocument = new TypedDocumentString(`
    query ReadDocumentsByIds($documentIds: [String!]!) {
  __typename
  readDocumentsByIds(documentIds: $documentIds) {
    __typename
    items {
      __typename
      ...Document
    }
    itemCount
  }
}
    fragment Document on DocumentResponseType {
  __typename
  documentId
  name
  groupId
  documentType
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  creationTimestamp
  versions(pagination: {page: 1, pageSize: 1}) {
    __typename
    items {
      __typename
      ...DocumentVersion
    }
    itemCount
  }
  objectVersion
}
fragment DocumentVersion on DocumentVersionResponseType {
  __typename
  versionNumber
  documentId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  documentFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  commitMessage
}
fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const ReadDocumentDocument = new TypedDocumentString(`
    query ReadDocument($documentId: String!) {
  __typename
  readDocument(documentId: $documentId) {
    __typename
    ...Document
  }
}
    fragment Document on DocumentResponseType {
  __typename
  documentId
  name
  groupId
  documentType
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  creationTimestamp
  versions(pagination: {page: 1, pageSize: 1}) {
    __typename
    items {
      __typename
      ...DocumentVersion
    }
    itemCount
  }
  objectVersion
}
fragment DocumentVersion on DocumentVersionResponseType {
  __typename
  versionNumber
  documentId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  documentFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  commitMessage
}
fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const ReadAllDocumentsDocument = new TypedDocumentString(`
    query ReadAllDocuments($filter: DocumentFilterInput, $pagination: PaginationInput) {
  __typename
  readAllDocuments(filter: $filter, pagination: $pagination) {
    __typename
    items {
      __typename
      ...Document
    }
    pages
    itemCount
  }
}
    fragment Document on DocumentResponseType {
  __typename
  documentId
  name
  groupId
  documentType
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  creationTimestamp
  versions(pagination: {page: 1, pageSize: 1}) {
    __typename
    items {
      __typename
      ...DocumentVersion
    }
    itemCount
  }
  objectVersion
}
fragment DocumentVersion on DocumentVersionResponseType {
  __typename
  versionNumber
  documentId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  documentFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  commitMessage
}
fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const ReadLinkedDocumentsForAssetDocument = new TypedDocumentString(`
    query ReadLinkedDocumentsForAsset($assetId: String!, $assetType: AssetTypeEnum!, $pagination: PaginationInput) {
  __typename
  readLinkedDocumentsForAsset(
    assetId: $assetId
    assetType: $assetType
    pagination: $pagination
  ) {
    __typename
    pages
    itemCount
    items {
      __typename
      ...DocumentLinkedToAssetResponse
    }
  }
}
    fragment Document on DocumentResponseType {
  __typename
  documentId
  name
  groupId
  documentType
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  creationTimestamp
  versions(pagination: {page: 1, pageSize: 1}) {
    __typename
    items {
      __typename
      ...DocumentVersion
    }
    itemCount
  }
  objectVersion
}
fragment DocumentVersion on DocumentVersionResponseType {
  __typename
  versionNumber
  documentId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  documentFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  commitMessage
}
fragment DocumentLinkedToAssetResponse on DocumentResponseType {
  __typename
  ...Document
  linkMetaData {
    __typename
    ... on DocumentToAssetLinkMetaDataType {
      __typename
      assetVersionId
    }
  }
}
fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const ReadLinkedAssetsFromDocumentDocument = new TypedDocumentString(`
    query ReadLinkedAssetsFromDocument($documentId: String!, $pagination: PaginationInput, $filter: AssetLinkFilterInput) {
  __typename
  readAllAssetLinksFromAsset(
    sourceId: $documentId
    sourceType: DOCUMENT
    pagination: $pagination
    filter: $filter
  ) {
    __typename
    pages
    itemCount
    items {
      __typename
      ...LinkedAssetFromDocument
    }
  }
}
    fragment LinkedAssetFromDocument on AssetLinkResponseType {
  __typename
  destinationId
  destinationType
  metaData {
    __typename
    ... on DocumentToAssetLinkMetaDataType {
      __typename
      assetVersionId
    }
  }
}`);
export const ReadVersionsForDocumentDocument = new TypedDocumentString(`
    query ReadVersionsForDocument($documentId: String!, $filter: DocumentVersionFilterInput, $pagination: PaginationInput) {
  __typename
  readDocumentVersionsForDocument(
    documentId: $documentId
    filter: $filter
    pagination: $pagination
  ) {
    __typename
    pages
    itemCount
    items {
      __typename
      ...DocumentVersion
    }
  }
}
    fragment DocumentVersion on DocumentVersionResponseType {
  __typename
  versionNumber
  documentId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  documentFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  commitMessage
}
fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const ReadDocumentNamesForRoleRowDocument = new TypedDocumentString(`
    query ReadDocumentNamesForRoleRow($documentIds: [String!]!) {
  __typename
  readDocumentsByIds(documentIds: $documentIds) {
    __typename
    items {
      __typename
      name
      documentId
    }
  }
}
    `);
export const DeleteGatewayDocument = new TypedDocumentString(`
    mutation DeleteGateway($gatewayId: String!) {
  __typename
  deleteGateway(gatewayId: $gatewayId) {
    __typename
    groupId
    gatewayId
  }
}
    `);
export const CreateGatewayDocument = new TypedDocumentString(`
    mutation CreateGateway($gateway: CreateGatewayInput!) {
  __typename
  createGateway(gateway: $gateway) {
    __typename
    groupId
    gatewayId
  }
}
    `);
export const UpdateGatewayDocument = new TypedDocumentString(`
    mutation UpdateGateway($gatewayId: String!, $gateway: UpdateGatewayInput!) {
  __typename
  updateGateway(gatewayId: $gatewayId, gateway: $gateway) {
    __typename
    gatewayId
    groupId
  }
}
    `);
export const UpdateGatewayConfigDocument = new TypedDocumentString(`
    mutation UpdateGatewayConfig($gatewayId: String!, $config: GatewayConfigUpdateInput!) {
  __typename
  updateGatewayConfig(gatewayId: $gatewayId, config: $config) {
    __typename
    objectVersion
  }
}
    `);
export const RequestGatewayUpdateDocument = new TypedDocumentString(`
    mutation RequestGatewayUpdate($gatewayId: String!) {
  __typename
  requestGatewayUpdate(gatewayId: $gatewayId) {
    __typename
    requestedAt
    version
  }
}
    `);
export const ReadAllGatewaysDocument = new TypedDocumentString(`
    query ReadAllGateways($filter: GatewayFilterInput, $pagination: PaginationInput) {
  __typename
  readAllGateways(filter: $filter, pagination: $pagination) {
    __typename
    items {
      __typename
      ...Gateway
    }
    itemCount
    pages
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Gateway on GatewayResponseType {
  __typename
  name
  description
  gatewayId
  groupId
  updateTimestamp
  creationTimestamp
  objectVersion
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  setupCommands {
    __typename
    ...GatewaySetupCommand
  }
  linkedDevices {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
  metadata {
    __typename
    ...GatewayMetadata
  }
  publicIp {
    __typename
    ...GatewayPublicIp
  }
  state {
    __typename
    reportedAt
    state
  }
  location {
    __typename
    latitudeE6
    longitudeE6
    country
    state
    city
    horizontalAccuracy
    horizontalConfidenceLevelPercentage
  }
}
fragment GatewaySetupType on GatewaySetupType {
  __typename
  configurationCommand
  installationCommand
  osName
  osType
}
fragment GatewaySetupCommand on GatewaySetupResponseType {
  __typename
  expiresAt
  osCommands {
    __typename
    ...GatewaySetupType
  }
}
fragment GatewayMetadata on GatewayMetadataResponseType {
  __typename
  reportedAt
  version
  latestVersion
  latestVersionForMajor
  architecture
  operatingSystem
  operatingSystemAttrs {
    __typename
    ... on WindowsAttrsType {
      __typename
      productId
      productName
      compositionEditionId
      currentBuild
      currentVersion
      displayVersion
      editionId
      installationType
      registeredOrganization
      registeredOwner
      winreVersion
    }
    ... on LinuxAttrsType {
      __typename
      distro
      version
      kernel
      procVersion
    }
  }
  numCpu
  isOutdated
  isOutdatedForMajor
}
fragment GatewayPublicIp on GatewayPublicIpResponseType {
  __typename
  reportedAt
  publicIp
}`);
export const ReadLinkedDevicesForGatewayDocument = new TypedDocumentString(`
    query ReadLinkedDevicesForGateway($gatewayId: String!, $pagination: PaginationInput) {
  __typename
  readLinkedDevicesForGateway(gatewayId: $gatewayId, pagination: $pagination) {
    __typename
    pages
    itemCount
    items {
      __typename
      ...Device
    }
  }
}
    fragment Device on DeviceResponseType {
  __typename
  deviceId
  deviceType
  vendorId
  ideConfigId
  groupId
  name
  secretId
  ftpConfiguration {
    __typename
    secretId
    ipAddress
    port
    rootDirectory
    protocol
  }
  smbConfiguration {
    __typename
    secretId
    ipAddress
    port
    protocol
    rootDirectory
  }
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  creationTimestamp
  linkedProjects {
    __typename
    itemCount
    items {
      __typename
      ...LinkedProjectFromDevice
    }
  }
  connectionConfiguration {
    __typename
    gatewayIpAddress
    ipAddress
    port
    subnetMask
  }
  objectVersion
  description
  linkedGateways {
    __typename
    itemCount
    items {
      __typename
      ...GatewayLinkedToDevice
    }
  }
  linkedDocuments {
    __typename
    itemCount
  }
  metaData
}
fragment LinkedProjectFromDevice on ProjectResponseType {
  __typename
  ...Project
  linkMetaData {
    __typename
    ... on ProjectToDeviceLinkMetaDataType {
      __typename
      ...ProjectToDeviceLinkMetaData
    }
  }
}
fragment ProjectToDeviceLinkMetaData on ProjectToDeviceLinkMetaDataType {
  __typename
  targetProjectVersionId
  deviceName
  deviceIpAddress
  deviceSubnet
  deviceType
}
fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Gateway on GatewayResponseType {
  __typename
  name
  description
  gatewayId
  groupId
  updateTimestamp
  creationTimestamp
  objectVersion
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  setupCommands {
    __typename
    ...GatewaySetupCommand
  }
  linkedDevices {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
  metadata {
    __typename
    ...GatewayMetadata
  }
  publicIp {
    __typename
    ...GatewayPublicIp
  }
  state {
    __typename
    reportedAt
    state
  }
  location {
    __typename
    latitudeE6
    longitudeE6
    country
    state
    city
    horizontalAccuracy
    horizontalConfidenceLevelPercentage
  }
}
fragment GatewaySetupType on GatewaySetupType {
  __typename
  configurationCommand
  installationCommand
  osName
  osType
}
fragment GatewaySetupCommand on GatewaySetupResponseType {
  __typename
  expiresAt
  osCommands {
    __typename
    ...GatewaySetupType
  }
}
fragment GatewayMetadata on GatewayMetadataResponseType {
  __typename
  reportedAt
  version
  latestVersion
  latestVersionForMajor
  architecture
  operatingSystem
  operatingSystemAttrs {
    __typename
    ... on WindowsAttrsType {
      __typename
      productId
      productName
      compositionEditionId
      currentBuild
      currentVersion
      displayVersion
      editionId
      installationType
      registeredOrganization
      registeredOwner
      winreVersion
    }
    ... on LinuxAttrsType {
      __typename
      distro
      version
      kernel
      procVersion
    }
  }
  numCpu
  isOutdated
  isOutdatedForMajor
}
fragment GatewayPublicIp on GatewayPublicIpResponseType {
  __typename
  reportedAt
  publicIp
}
fragment GatewayLinkedToDevice on GatewayResponseType {
  __typename
  ...Gateway
  linkMetaData {
    __typename
    ... on DeviceToGatewayLinkMetaDataType {
      __typename
      primary
    }
  }
}
fragment Project on ProjectResponseType {
  __typename
  projectType
  vendorId
  name
  metaData
  attachedLicenses
  projectId
  groupId
  description
  ideConfigId
  creationTimestamp
  objectVersion
  updateTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  versions(
    filter: {source: {ne: "PROJECT_BACKUP"}}
    pagination: {page: 1, pageSize: 1}
  ) {
    __typename
    items {
      __typename
      ...ProjectVersion
    }
    itemCount
  }
  linkedDevices {
    __typename
    itemCount
    items {
      __typename
      deviceType
    }
  }
  secretId
  linkedSubProjects {
    __typename
    itemCount
  }
  linkedParentProjects {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
}
fragment DeviceInformation on DeviceInformationType {
  __typename
  name
  deviceType
  ethernetCommunication {
    __typename
    ipAddress
    subnetMask
  }
}
fragment ProjectVersion on ProjectVersionResponseType {
  __typename
  versionNumber
  projectId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  projectFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  source
  commitMessage
  deviceInformation {
    __typename
    ...DeviceInformation
  }
}`);
export const ReadGatewaysByIdsDocument = new TypedDocumentString(`
    query ReadGatewaysByIds($gatewayIds: [String!]!) {
  __typename
  readGatewaysByIds(gatewayIds: $gatewayIds) {
    __typename
    items {
      __typename
      ...Gateway
    }
    itemCount
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Gateway on GatewayResponseType {
  __typename
  name
  description
  gatewayId
  groupId
  updateTimestamp
  creationTimestamp
  objectVersion
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  setupCommands {
    __typename
    ...GatewaySetupCommand
  }
  linkedDevices {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
  metadata {
    __typename
    ...GatewayMetadata
  }
  publicIp {
    __typename
    ...GatewayPublicIp
  }
  state {
    __typename
    reportedAt
    state
  }
  location {
    __typename
    latitudeE6
    longitudeE6
    country
    state
    city
    horizontalAccuracy
    horizontalConfidenceLevelPercentage
  }
}
fragment GatewaySetupType on GatewaySetupType {
  __typename
  configurationCommand
  installationCommand
  osName
  osType
}
fragment GatewaySetupCommand on GatewaySetupResponseType {
  __typename
  expiresAt
  osCommands {
    __typename
    ...GatewaySetupType
  }
}
fragment GatewayMetadata on GatewayMetadataResponseType {
  __typename
  reportedAt
  version
  latestVersion
  latestVersionForMajor
  architecture
  operatingSystem
  operatingSystemAttrs {
    __typename
    ... on WindowsAttrsType {
      __typename
      productId
      productName
      compositionEditionId
      currentBuild
      currentVersion
      displayVersion
      editionId
      installationType
      registeredOrganization
      registeredOwner
      winreVersion
    }
    ... on LinuxAttrsType {
      __typename
      distro
      version
      kernel
      procVersion
    }
  }
  numCpu
  isOutdated
  isOutdatedForMajor
}
fragment GatewayPublicIp on GatewayPublicIpResponseType {
  __typename
  reportedAt
  publicIp
}`);
export const ReadGatewayDocument = new TypedDocumentString(`
    query ReadGateway($gatewayId: String!) {
  __typename
  readGateway(gatewayId: $gatewayId) {
    __typename
    ...Gateway
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Gateway on GatewayResponseType {
  __typename
  name
  description
  gatewayId
  groupId
  updateTimestamp
  creationTimestamp
  objectVersion
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  setupCommands {
    __typename
    ...GatewaySetupCommand
  }
  linkedDevices {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
  metadata {
    __typename
    ...GatewayMetadata
  }
  publicIp {
    __typename
    ...GatewayPublicIp
  }
  state {
    __typename
    reportedAt
    state
  }
  location {
    __typename
    latitudeE6
    longitudeE6
    country
    state
    city
    horizontalAccuracy
    horizontalConfidenceLevelPercentage
  }
}
fragment GatewaySetupType on GatewaySetupType {
  __typename
  configurationCommand
  installationCommand
  osName
  osType
}
fragment GatewaySetupCommand on GatewaySetupResponseType {
  __typename
  expiresAt
  osCommands {
    __typename
    ...GatewaySetupType
  }
}
fragment GatewayMetadata on GatewayMetadataResponseType {
  __typename
  reportedAt
  version
  latestVersion
  latestVersionForMajor
  architecture
  operatingSystem
  operatingSystemAttrs {
    __typename
    ... on WindowsAttrsType {
      __typename
      productId
      productName
      compositionEditionId
      currentBuild
      currentVersion
      displayVersion
      editionId
      installationType
      registeredOrganization
      registeredOwner
      winreVersion
    }
    ... on LinuxAttrsType {
      __typename
      distro
      version
      kernel
      procVersion
    }
  }
  numCpu
  isOutdated
  isOutdatedForMajor
}
fragment GatewayPublicIp on GatewayPublicIpResponseType {
  __typename
  reportedAt
  publicIp
}`);
export const ReadGatewayHealthStatusDocument = new TypedDocumentString(`
    query ReadGatewayHealthStatus($gatewayId: String!) {
  __typename
  readGatewayState(gatewayId: $gatewayId) {
    __typename
    reportedAt
    state
  }
}
    `);
export const ReadGatewaysHealthStatusDocument = new TypedDocumentString(`
    query ReadGatewaysHealthStatus($gatewayIds: [String!]!) {
  __typename
  readGatewaysByIds(gatewayIds: $gatewayIds) {
    __typename
    items {
      __typename
      gatewayId
      state {
        __typename
        reportedAt
        state
      }
    }
  }
}
    `);
export const ReadGatewayNamesForRoleRowDocument = new TypedDocumentString(`
    query ReadGatewayNamesForRoleRow($gatewayIds: [String!]!) {
  __typename
  readGatewaysByIds(gatewayIds: $gatewayIds) {
    __typename
    items {
      __typename
      name
      gatewayId
    }
  }
}
    `);
export const ReadGatewayConfigDocument = new TypedDocumentString(`
    query ReadGatewayConfig($gatewayId: String!) {
  __typename
  readGatewayConfigReported(gatewayId: $gatewayId) {
    __typename
    ...GatewayConfig
  }
  readGatewayConfigDesired(gatewayId: $gatewayId) {
    __typename
    ...GatewayConfig
  }
}
    fragment GatewayConfig on GatewayConfigResponseType {
  __typename
  objectVersion
  reportedAt
  requestedAt
  values {
    __typename
    metaVersion
    sslTunnel
    sslTunnelInsecure
    updateAuto
    updateUnstable
    webuiBase
    webuiEnabled
    webuiPort
  }
}`);
export const ReadGatewayUpdateStatusDocument = new TypedDocumentString(`
    query ReadGatewayUpdateStatus($gatewayId: String!) {
  __typename
  readGateway(gatewayId: $gatewayId) {
    __typename
    metadata {
      __typename
      reportedAt
      version
      latestVersion
      isOutdated
    }
    updateRequest {
      __typename
      requestedAt
      version
    }
  }
}
    `);
export const ReadGatewaySetupDocument = new TypedDocumentString(`
    query ReadGatewaySetup($gatewayId: String!) {
  __typename
  readGatewaySetup(gatewayId: $gatewayId) {
    __typename
    expiresAt
    byMajor {
      __typename
      major
      osCommands {
        __typename
        osType
        osName
        installationCommand
        configurationCommand
      }
    }
  }
}
    `);
export const ReadDevicesSyncStatusByGatewayDocument = new TypedDocumentString(`
    query ReadDevicesSyncStatusByGateway($gatewayId: String!, $pagination: PaginationInput) {
  __typename
  readLinkedDevicesForGateway(gatewayId: $gatewayId, pagination: $pagination) {
    __typename
    itemCount
    items {
      __typename
      ...SyncedDevice
    }
  }
}
    fragment DeviceSyncStatus on DeviceSyncStatusResponseType {
  __typename
  previousSyncStatus
  syncErrorMessage
  syncTimestamp
  syncType
  targetSyncStatus
  syncJobId
}
fragment AccumulatedDeviceSyncStatus on AccumulatedDeviceSyncStatusResponseType {
  __typename
  syncTimestamp
  targetSyncStatus
  previousSyncStatus
  details {
    __typename
    ...DeviceSyncStatus
  }
}
fragment SyncedDevice on DeviceResponseType {
  __typename
  deviceId
  deviceType
  name
  vendorId
  accumulatedSyncStatus {
    __typename
    ...AccumulatedDeviceSyncStatus
  }
}`);
export const DeleteResourceGroupDocument = new TypedDocumentString(`
    mutation DeleteResourceGroup($groupId: String!) {
  __typename
  deleteResourceGroup(groupId: $groupId) {
    __typename
    groupId
    parentGroupId
  }
}
    `);
export const CreateResourceGroupDocument = new TypedDocumentString(`
    mutation CreateResourceGroup($resourceGroup: CreateResourceGroupInput!) {
  __typename
  createResourceGroup(resourceGroup: $resourceGroup) {
    __typename
    groupId
    parentGroupId
  }
}
    `);
export const UpdateResourceGroupDocument = new TypedDocumentString(`
    mutation UpdateResourceGroup($groupId: String!, $resourceGroup: UpdateResourceGroupInput!) {
  __typename
  updateResourceGroup(groupId: $groupId, resourceGroup: $resourceGroup) {
    __typename
    groupId
    parentGroupId
  }
}
    `);
export const ReadResourceGroupByIdDocument = new TypedDocumentString(`
    query ReadResourceGroupById($groupId: String!) {
  __typename
  readResourceGroup(groupId: $groupId) {
    __typename
    ...ResourceGroup
  }
  readSubGroupsForResourceGroup(parentGroupId: $groupId) {
    __typename
    items {
      __typename
      ...ResourceGroup
    }
    pages
    itemCount
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment SubGroup on ResourceGroupResponseType {
  __typename
  name
  groupId
  creationTimestamp
  updateTimestamp
}
fragment ResourceGroup on ResourceGroupResponseType {
  __typename
  updateUser {
    __typename
    ...AssetUserInfo
  }
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  creationTimestamp
  name
  parentGroupId
  groupId
  objectVersion
  subGroups {
    __typename
    itemCount
    items {
      __typename
      ...SubGroup
    }
    pages
  }
  groupDevicesSyncStatus(
    filter: {deviceSyncStatus: {in_: ["ERROR", "NOT_SYNCED"]}}
  ) {
    __typename
    groupSyncStatus
    devicesSyncStatus {
      __typename
      deviceName
      deviceId
      syncStatus
      syncStatusTimestamp
      groupId
    }
  }
  fullPaths
}`);
export const ReadResourceGroupsToBuildTreeDocument = new TypedDocumentString(`
    query ReadResourceGroupsToBuildTree($filter: ResourceGroupFilterInput) {
  __typename
  readAllResourceGroups(filter: $filter) {
    __typename
    items {
      __typename
      ...GroupTreeItem
    }
    itemCount
  }
}
    fragment GroupTreeItem on ResourceGroupResponseType {
  __typename
  groupId
  name
  parentGroupId
  creationTimestamp
  updateTimestamp
  objectVersion
  groupDevicesSyncStatus(
    filter: {deviceSyncStatus: {in_: ["ERROR", "NOT_SYNCED"]}}
  ) {
    __typename
    groupSyncStatus
    devicesSyncStatus {
      __typename
      deviceName
      deviceId
      syncStatus
      syncStatusTimestamp
      groupId
    }
  }
}`);
export const ReadAllResourceGroupsDocument = new TypedDocumentString(`
    query ReadAllResourceGroups($filter: ResourceGroupFilterInput, $pagination: PaginationInput, $isRoot: Boolean) {
  __typename
  readAllResourceGroups(filter: $filter, pagination: $pagination, isRoot: $isRoot) {
    __typename
    items {
      __typename
      ...ResourceGroup
    }
    itemCount
    pages
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment SubGroup on ResourceGroupResponseType {
  __typename
  name
  groupId
  creationTimestamp
  updateTimestamp
}
fragment ResourceGroup on ResourceGroupResponseType {
  __typename
  updateUser {
    __typename
    ...AssetUserInfo
  }
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  creationTimestamp
  name
  parentGroupId
  groupId
  objectVersion
  subGroups {
    __typename
    itemCount
    items {
      __typename
      ...SubGroup
    }
    pages
  }
  groupDevicesSyncStatus(
    filter: {deviceSyncStatus: {in_: ["ERROR", "NOT_SYNCED"]}}
  ) {
    __typename
    groupSyncStatus
    devicesSyncStatus {
      __typename
      deviceName
      deviceId
      syncStatus
      syncStatusTimestamp
      groupId
    }
  }
  fullPaths
}`);
export const ReadSubGroupsForResourceGroupDocument = new TypedDocumentString(`
    query ReadSubGroupsForResourceGroup($groupId: String!, $pagination: PaginationInput) {
  __typename
  readSubGroupsForResourceGroup(parentGroupId: $groupId, pagination: $pagination) {
    __typename
    items {
      __typename
      ...ResourceGroup
    }
    pages
    itemCount
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment SubGroup on ResourceGroupResponseType {
  __typename
  name
  groupId
  creationTimestamp
  updateTimestamp
}
fragment ResourceGroup on ResourceGroupResponseType {
  __typename
  updateUser {
    __typename
    ...AssetUserInfo
  }
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  creationTimestamp
  name
  parentGroupId
  groupId
  objectVersion
  subGroups {
    __typename
    itemCount
    items {
      __typename
      ...SubGroup
    }
    pages
  }
  groupDevicesSyncStatus(
    filter: {deviceSyncStatus: {in_: ["ERROR", "NOT_SYNCED"]}}
  ) {
    __typename
    groupSyncStatus
    devicesSyncStatus {
      __typename
      deviceName
      deviceId
      syncStatus
      syncStatusTimestamp
      groupId
    }
  }
  fullPaths
}`);
export const ReadResourceGroupNamesForRoleRowDocument = new TypedDocumentString(`
    query ReadResourceGroupNamesForRoleRow($groupIds: [String!]!) {
  __typename
  readResourceGroupsByIds(groupIds: $groupIds) {
    __typename
    items {
      __typename
      name
      groupId
    }
  }
}
    `);
export const ReadResourceGroupNameByIdDocument = new TypedDocumentString(`
    query ReadResourceGroupNameById($groupId: String!) {
  __typename
  readResourceGroup(groupId: $groupId) {
    __typename
    name
    parentGroupId
    fullPaths
  }
}
    `);
export const ReadAllResourceGroupsWithoutPermissionChecksDocument = new TypedDocumentString(`
    query ReadAllResourceGroupsWithoutPermissionChecks {
  __typename
  readAllResourceGroupsForPermissions {
    __typename
    ...ResourceGroupParentChildPair
  }
}
    fragment ResourceGroupParentChildPair on ResourceGroupForPermissionResponseType {
  __typename
  groupId
  parentGroupId
}`);
export const ReadGroupedAssetsCountDocument = new TypedDocumentString(`
    query ReadGroupedAssetsCount($groupId: String!) {
  __typename
  readAllDevices(filter: {groupId: {contains: $groupId}}) {
    __typename
    itemCount
  }
  readAllProjects(filter: {groupId: {contains: $groupId}}) {
    __typename
    itemCount
  }
  readAllGateways(filter: {groupId: {contains: $groupId}}) {
    __typename
    itemCount
  }
  readAllDocuments(filter: {groupId: {contains: $groupId}}) {
    __typename
    itemCount
  }
  readAllVaults(filter: {groupId: {contains: $groupId}}) {
    __typename
    itemCount
  }
  readAllLicenses(filter: {groupId: {contains: $groupId}}) {
    __typename
    itemCount
  }
  readSubGroupsForResourceGroup(parentGroupId: $groupId) {
    __typename
    itemCount
  }
}
    `);
export const ReadUngroupedAssetsCountDocument = new TypedDocumentString(`
    query ReadUngroupedAssetsCount {
  __typename
  readAllDevices(filter: {groupId: {doNotIgnoreNullable: [eq]}}) {
    __typename
    itemCount
  }
  readAllProjects(filter: {groupId: {doNotIgnoreNullable: [eq]}}) {
    __typename
    itemCount
  }
  readAllGateways(filter: {groupId: {doNotIgnoreNullable: [eq]}}) {
    __typename
    itemCount
  }
  readAllDocuments(filter: {groupId: {doNotIgnoreNullable: [eq]}}) {
    __typename
    itemCount
  }
  readAllVaults(filter: {groupId: {doNotIgnoreNullable: [eq]}}) {
    __typename
    itemCount
  }
  readAllLicenses(filter: {groupId: {doNotIgnoreNullable: [eq]}}) {
    __typename
    itemCount
  }
}
    `);
export const CreateLicenseDocument = new TypedDocumentString(`
    mutation CreateLicense($license: CreateLicenseInput!) {
  __typename
  createLicense(license: $license) {
    __typename
    uploadUrls {
      __typename
      partNumber
      uploadUrl
    }
    uploadId
    licenseId
  }
}
    `);
export const CompleteLicenseMultipartUploadDocument = new TypedDocumentString(`
    mutation CompleteLicenseMultipartUpload($licenseId: String!, $uploadId: String!, $completeUploadInput: CompleteMultipartUploadInput!) {
  __typename
  completeLicenseMultipartUpload(
    licenseId: $licenseId
    uploadId: $uploadId
    completeUploadInput: $completeUploadInput
  )
}
    `);
export const DeleteLicenseDocument = new TypedDocumentString(`
    mutation DeleteLicense($licenseId: String!) {
  __typename
  deleteLicense(licenseId: $licenseId) {
    __typename
    licenseId
    groupId
  }
}
    `);
export const UpdateLicenseDocument = new TypedDocumentString(`
    mutation UpdateLicense($licenseId: String!, $license: UpdateLicenseInput!) {
  __typename
  updateLicense(licenseId: $licenseId, license: $license) {
    __typename
    licenseId
  }
}
    `);
export const ReadAllLicensesDocument = new TypedDocumentString(`
    query ReadAllLicenses($filter: LicenseFilterInput, $pagination: PaginationInput) {
  __typename
  readAllLicenses(filter: $filter, pagination: $pagination) {
    __typename
    itemCount
    pages
    items {
      __typename
      ...License
    }
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment License on LicenseResponseType {
  __typename
  name
  groupId
  licenseId
  objectVersion
  product
  productKey
  quantity
  serialId
  status
  type
  ideConfigId
  updateTimestamp
  updateUser {
    __typename
    ...AssetUserInfo
  }
  creationUser {
    __typename
    ...AssetUserInfo
  }
  creationTimestamp
  family
  vendorId
}`);
export const DownloadLicenseDocument = new TypedDocumentString(`
    query DownloadLicense($licenseId: String!) {
  __typename
  downloadLicense(licenseId: $licenseId) {
    __typename
    downloadUrl
  }
}
    `);
export const ReadLicenseNamesForRoleRowDocument = new TypedDocumentString(`
    query ReadLicenseNamesForRoleRow($licenseIds: [String!]!) {
  __typename
  readLicensesByIds(licenseIds: $licenseIds) {
    __typename
    items {
      __typename
      name
      licenseId
    }
  }
}
    `);
export const DeleteAssetLinkDocument = new TypedDocumentString(`
    mutation DeleteAssetLink($sourceId: String!, $sourceType: AssetTypeEnum!, $destinationId: String!, $destinationType: AssetTypeEnum!) {
  __typename
  deleteAssetLink(
    sourceId: $sourceId
    sourceType: $sourceType
    destinationId: $destinationId
    destinationType: $destinationType
  ) {
    __typename
    destinationId
    destinationType
    sourceId
    sourceType
  }
}
    `);
export const LinkDocumentToAssetDocument = new TypedDocumentString(`
    mutation LinkDocumentToAsset($documentId: String!, $assetType: AssetTypeEnum!, $assetId: String!, $assetVersionId: String) {
  __typename
  createAssetLink(
    sourceType: DOCUMENT
    sourceId: $documentId
    destinationType: $assetType
    destinationId: $assetId
    input: {metaData: {assetVersionId: $assetVersionId}}
  ) {
    __typename
    sourceId
    destinationId
    metaData {
      __typename
      ... on DocumentToAssetLinkMetaDataType {
        __typename
        assetVersionId
      }
    }
  }
}
    `);
export const LinkLibraryToProjectDocument = new TypedDocumentString(`
    mutation LinkLibraryToProject($projectId: String!, $libraryId: String!) {
  __typename
  createAssetLink(
    sourceId: $projectId
    destinationId: $libraryId
    sourceType: PROJECT
    destinationType: PROJECT
    input: {metaData: null}
  ) {
    __typename
    sourceId
    destinationId
  }
}
    `);
export const LinkDeviceToProjectDocument = new TypedDocumentString(`
    mutation LinkDeviceToProject($projectId: String!, $deviceId: String!, $metaData: AssetMetaDataCombinedInput) {
  __typename
  createAssetLink(
    sourceType: PROJECT
    sourceId: $projectId
    destinationType: DEVICE
    destinationId: $deviceId
    input: {metaData: $metaData}
  ) {
    __typename
    sourceId
    destinationId
    metaData {
      __typename
      ... on ProjectToDeviceLinkMetaDataType {
        __typename
        deviceIpAddress
        deviceName
        deviceSubnet
        deviceType
        targetProjectVersionId
      }
    }
  }
}
    `);
export const UpdateDeviceToProjectLinkDocument = new TypedDocumentString(`
    mutation UpdateDeviceToProjectLink($projectId: String!, $deviceId: String!, $input: UpdateAssetLinkInput!) {
  __typename
  updateAssetLink(
    sourceType: PROJECT
    sourceId: $projectId
    destinationType: DEVICE
    destinationId: $deviceId
    input: $input
  ) {
    __typename
    sourceId
    destinationId
    metaData {
      __typename
      ... on ProjectToDeviceLinkMetaDataType {
        __typename
        deviceIpAddress
        deviceName
        deviceSubnet
        deviceType
        targetProjectVersionId
      }
    }
  }
}
    `);
export const LinkDeviceToGatewayDocument = new TypedDocumentString(`
    mutation LinkDeviceToGateway($gatewayId: String!, $deviceId: String!, $primary: Boolean) {
  __typename
  createAssetLink(
    sourceType: DEVICE
    sourceId: $deviceId
    destinationType: GATEWAY
    destinationId: $gatewayId
    input: {metaData: {primary: $primary}}
  ) {
    __typename
    sourceId
    destinationId
    metaData {
      __typename
      ... on DeviceToGatewayLinkMetaDataType {
        __typename
        primary
      }
    }
  }
}
    `);
export const DefineGatewayLinksToDeviceDocument = new TypedDocumentString(`
    mutation DefineGatewayLinksToDevice($deviceId: String!, $input: [DefineAssetLinkFromAssetInput!]!) {
  __typename
  defineAssetLinksFromAsset(
    sourceType: DEVICE
    destinationType: GATEWAY
    sourceId: $deviceId
    input: $input
  ) {
    __typename
    items {
      __typename
      sourceId
      destinationId
      metaData {
        __typename
        ... on DeviceToGatewayLinkMetaDataType {
          __typename
          primary
        }
      }
    }
    itemCount
  }
}
    `);
export const ReadAssetLinkDocument = new TypedDocumentString(`
    query ReadAssetLink($destinationId: String!, $destinationType: AssetTypeEnum!, $sourceId: String!, $sourceType: AssetTypeEnum!) {
  __typename
  readAssetLink(
    destinationId: $destinationId
    destinationType: $destinationType
    sourceId: $sourceId
    sourceType: $sourceType
  ) {
    __typename
    objectVersion
  }
}
    `);
export const CreateLockDocument = new TypedDocumentString(`
    mutation CreateLock($lock: CreateLockInput!) {
  __typename
  createLock(lock: $lock) {
    __typename
    resourceId
    resourceType
  }
}
    `);
export const DeleteLockDocument = new TypedDocumentString(`
    mutation DeleteLock($assetId: String!, $assetType: String!) {
  __typename
  deleteLock(resourceId: $assetId, resourceType: $assetType) {
    __typename
    resourceId
    resourceType
  }
}
    `);
export const ReadLockDocument = new TypedDocumentString(`
    query ReadLock($assetId: String!, $assetType: String!) {
  __typename
  readLock(resourceId: $assetId, resourceType: $assetType) {
    __typename
    ...Lock
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Lock on LockResponseType {
  __typename
  creationUser {
    __typename
    ...AssetUserInfo
  }
  service
  creationTimestamp
  message
}`);
export const CreateProjectDocument = new TypedDocumentString(`
    mutation CreateProject($project: CreateProjectInput!) {
  __typename
  createProject(project: $project) {
    __typename
    projectId
    versionId
    uploadUrls {
      __typename
      partNumber
      uploadUrl
    }
    uploadId
    groupId
  }
}
    `);
export const CompleteProjectMultipartUploadDocument = new TypedDocumentString(`
    mutation CompleteProjectMultipartUpload($projectId: String!, $versionId: String!, $uploadId: String!, $completeUploadInput: CompleteMultipartUploadInput!) {
  __typename
  completeProjectVersionMultipartUpload(
    projectId: $projectId
    versionId: $versionId
    uploadId: $uploadId
    completeUploadInput: $completeUploadInput
  )
}
    `);
export const DeleteProjectDocument = new TypedDocumentString(`
    mutation DeleteProject($projectId: String!) {
  __typename
  deleteProject(projectId: $projectId) {
    __typename
    projectId
    groupId
  }
}
    `);
export const DeleteProjectVersionDocument = new TypedDocumentString(`
    mutation DeleteProjectVersion($projectId: String!, $versionId: String!) {
  __typename
  deleteProjectVersion(projectId: $projectId, versionId: $versionId) {
    __typename
    projectId
    versionId
    groupId
  }
}
    `);
export const UpdateProjectDocument = new TypedDocumentString(`
    mutation UpdateProject($projectId: String!, $project: UpdateProjectInput!) {
  __typename
  updateProject(projectId: $projectId, project: $project) {
    __typename
    projectId
    groupId
  }
}
    `);
export const CreateProjectVersionDocument = new TypedDocumentString(`
    mutation CreateProjectVersion($projectId: String!, $projectVersion: CreateProjectVersionInput!) {
  __typename
  createProjectVersion(projectId: $projectId, projectVersion: $projectVersion) {
    __typename
    projectId
    versionId
    uploadUrls {
      __typename
      partNumber
      uploadUrl
    }
    uploadId
  }
}
    `);
export const UpdateProjectVersionDocument = new TypedDocumentString(`
    mutation UpdateProjectVersion($projectId: String!, $versionId: String!, $projectVersion: UpdateProjectVersionInput!) {
  __typename
  updateProjectVersion(
    projectId: $projectId
    versionId: $versionId
    projectVersion: $projectVersion
  ) {
    __typename
    projectId
    versionId
  }
}
    `);
export const ReadAllProjectsDocument = new TypedDocumentString(`
    query ReadAllProjects($filter: ProjectFilterInput, $pagination: PaginationInput) {
  __typename
  readAllProjects(filter: $filter, pagination: $pagination) {
    __typename
    items {
      __typename
      ...Project
    }
    pages
    itemCount
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Project on ProjectResponseType {
  __typename
  projectType
  vendorId
  name
  metaData
  attachedLicenses
  projectId
  groupId
  description
  ideConfigId
  creationTimestamp
  objectVersion
  updateTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  versions(
    filter: {source: {ne: "PROJECT_BACKUP"}}
    pagination: {page: 1, pageSize: 1}
  ) {
    __typename
    items {
      __typename
      ...ProjectVersion
    }
    itemCount
  }
  linkedDevices {
    __typename
    itemCount
    items {
      __typename
      deviceType
    }
  }
  secretId
  linkedSubProjects {
    __typename
    itemCount
  }
  linkedParentProjects {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
}
fragment DeviceInformation on DeviceInformationType {
  __typename
  name
  deviceType
  ethernetCommunication {
    __typename
    ipAddress
    subnetMask
  }
}
fragment ProjectVersion on ProjectVersionResponseType {
  __typename
  versionNumber
  projectId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  projectFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  source
  commitMessage
  deviceInformation {
    __typename
    ...DeviceInformation
  }
}`);
export const DownloadProjectVersionDocument = new TypedDocumentString(`
    query DownloadProjectVersion($projectId: String!, $versionId: String!) {
  __typename
  downloadProjectVersion(projectId: $projectId, versionId: $versionId) {
    __typename
    downloadUrl
  }
}
    `);
export const ReadProjectDocument = new TypedDocumentString(`
    query ReadProject($projectId: String!) {
  __typename
  readProject(projectId: $projectId) {
    __typename
    ...Project
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Project on ProjectResponseType {
  __typename
  projectType
  vendorId
  name
  metaData
  attachedLicenses
  projectId
  groupId
  description
  ideConfigId
  creationTimestamp
  objectVersion
  updateTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  versions(
    filter: {source: {ne: "PROJECT_BACKUP"}}
    pagination: {page: 1, pageSize: 1}
  ) {
    __typename
    items {
      __typename
      ...ProjectVersion
    }
    itemCount
  }
  linkedDevices {
    __typename
    itemCount
    items {
      __typename
      deviceType
    }
  }
  secretId
  linkedSubProjects {
    __typename
    itemCount
  }
  linkedParentProjects {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
}
fragment DeviceInformation on DeviceInformationType {
  __typename
  name
  deviceType
  ethernetCommunication {
    __typename
    ipAddress
    subnetMask
  }
}
fragment ProjectVersion on ProjectVersionResponseType {
  __typename
  versionNumber
  projectId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  projectFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  source
  commitMessage
  deviceInformation {
    __typename
    ...DeviceInformation
  }
}`);
export const ReadVersionsForProjectDocument = new TypedDocumentString(`
    query ReadVersionsForProject($projectId: String!, $filter: ProjectVersionFilterInput, $pagination: PaginationInput) {
  __typename
  readProjectVersionsForProject(
    projectId: $projectId
    filter: $filter
    pagination: $pagination
  ) {
    __typename
    pages
    itemCount
    items {
      __typename
      ...ProjectVersion
    }
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment DeviceInformation on DeviceInformationType {
  __typename
  name
  deviceType
  ethernetCommunication {
    __typename
    ipAddress
    subnetMask
  }
}
fragment ProjectVersion on ProjectVersionResponseType {
  __typename
  versionNumber
  projectId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  projectFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  source
  commitMessage
  deviceInformation {
    __typename
    ...DeviceInformation
  }
}`);
export const ReadLinkedLibrariesForProjectDocument = new TypedDocumentString(`
    query ReadLinkedLibrariesForProject($projectId: String!, $pagination: PaginationInput) {
  __typename
  readLinkedSubProjectsForProject(projectId: $projectId, pagination: $pagination) {
    __typename
    pages
    itemCount
    items {
      __typename
      ...LinkedLibrary
    }
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Project on ProjectResponseType {
  __typename
  projectType
  vendorId
  name
  metaData
  attachedLicenses
  projectId
  groupId
  description
  ideConfigId
  creationTimestamp
  objectVersion
  updateTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  versions(
    filter: {source: {ne: "PROJECT_BACKUP"}}
    pagination: {page: 1, pageSize: 1}
  ) {
    __typename
    items {
      __typename
      ...ProjectVersion
    }
    itemCount
  }
  linkedDevices {
    __typename
    itemCount
    items {
      __typename
      deviceType
    }
  }
  secretId
  linkedSubProjects {
    __typename
    itemCount
  }
  linkedParentProjects {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
}
fragment LinkedLibrary on ProjectResponseType {
  __typename
  ...Project
  linkMetaData {
    __typename
    ... on ProjectToProjectLinkMetaDataType {
      __typename
      destinationVersionId
      sourceVersionId
    }
  }
  updateTimestamp
  objectVersion
  linkedSubProjects {
    __typename
    itemCount
  }
  linkedParentProjects {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
}
fragment DeviceInformation on DeviceInformationType {
  __typename
  name
  deviceType
  ethernetCommunication {
    __typename
    ipAddress
    subnetMask
  }
}
fragment ProjectVersion on ProjectVersionResponseType {
  __typename
  versionNumber
  projectId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  projectFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  source
  commitMessage
  deviceInformation {
    __typename
    ...DeviceInformation
  }
}`);
export const ReadLinkedDevicesForProjectDocument = new TypedDocumentString(`
    query ReadLinkedDevicesForProject($projectId: String!, $pagination: PaginationInput) {
  __typename
  readLinkedDevicesForProject(projectId: $projectId, pagination: $pagination) {
    __typename
    pages
    itemCount
    items {
      __typename
      ...Device
      linkMetaData {
        __typename
        ... on ProjectToDeviceLinkMetaDataType {
          __typename
          ...ProjectToDeviceLinkMetaData
        }
      }
    }
  }
}
    fragment Device on DeviceResponseType {
  __typename
  deviceId
  deviceType
  vendorId
  ideConfigId
  groupId
  name
  secretId
  ftpConfiguration {
    __typename
    secretId
    ipAddress
    port
    rootDirectory
    protocol
  }
  smbConfiguration {
    __typename
    secretId
    ipAddress
    port
    protocol
    rootDirectory
  }
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  creationTimestamp
  linkedProjects {
    __typename
    itemCount
    items {
      __typename
      ...LinkedProjectFromDevice
    }
  }
  connectionConfiguration {
    __typename
    gatewayIpAddress
    ipAddress
    port
    subnetMask
  }
  objectVersion
  description
  linkedGateways {
    __typename
    itemCount
    items {
      __typename
      ...GatewayLinkedToDevice
    }
  }
  linkedDocuments {
    __typename
    itemCount
  }
  metaData
}
fragment LinkedProjectFromDevice on ProjectResponseType {
  __typename
  ...Project
  linkMetaData {
    __typename
    ... on ProjectToDeviceLinkMetaDataType {
      __typename
      ...ProjectToDeviceLinkMetaData
    }
  }
}
fragment ProjectToDeviceLinkMetaData on ProjectToDeviceLinkMetaDataType {
  __typename
  targetProjectVersionId
  deviceName
  deviceIpAddress
  deviceSubnet
  deviceType
}
fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Gateway on GatewayResponseType {
  __typename
  name
  description
  gatewayId
  groupId
  updateTimestamp
  creationTimestamp
  objectVersion
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  setupCommands {
    __typename
    ...GatewaySetupCommand
  }
  linkedDevices {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
  metadata {
    __typename
    ...GatewayMetadata
  }
  publicIp {
    __typename
    ...GatewayPublicIp
  }
  state {
    __typename
    reportedAt
    state
  }
  location {
    __typename
    latitudeE6
    longitudeE6
    country
    state
    city
    horizontalAccuracy
    horizontalConfidenceLevelPercentage
  }
}
fragment GatewaySetupType on GatewaySetupType {
  __typename
  configurationCommand
  installationCommand
  osName
  osType
}
fragment GatewaySetupCommand on GatewaySetupResponseType {
  __typename
  expiresAt
  osCommands {
    __typename
    ...GatewaySetupType
  }
}
fragment GatewayMetadata on GatewayMetadataResponseType {
  __typename
  reportedAt
  version
  latestVersion
  latestVersionForMajor
  architecture
  operatingSystem
  operatingSystemAttrs {
    __typename
    ... on WindowsAttrsType {
      __typename
      productId
      productName
      compositionEditionId
      currentBuild
      currentVersion
      displayVersion
      editionId
      installationType
      registeredOrganization
      registeredOwner
      winreVersion
    }
    ... on LinuxAttrsType {
      __typename
      distro
      version
      kernel
      procVersion
    }
  }
  numCpu
  isOutdated
  isOutdatedForMajor
}
fragment GatewayPublicIp on GatewayPublicIpResponseType {
  __typename
  reportedAt
  publicIp
}
fragment GatewayLinkedToDevice on GatewayResponseType {
  __typename
  ...Gateway
  linkMetaData {
    __typename
    ... on DeviceToGatewayLinkMetaDataType {
      __typename
      primary
    }
  }
}
fragment Project on ProjectResponseType {
  __typename
  projectType
  vendorId
  name
  metaData
  attachedLicenses
  projectId
  groupId
  description
  ideConfigId
  creationTimestamp
  objectVersion
  updateTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  versions(
    filter: {source: {ne: "PROJECT_BACKUP"}}
    pagination: {page: 1, pageSize: 1}
  ) {
    __typename
    items {
      __typename
      ...ProjectVersion
    }
    itemCount
  }
  linkedDevices {
    __typename
    itemCount
    items {
      __typename
      deviceType
    }
  }
  secretId
  linkedSubProjects {
    __typename
    itemCount
  }
  linkedParentProjects {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
}
fragment DeviceInformation on DeviceInformationType {
  __typename
  name
  deviceType
  ethernetCommunication {
    __typename
    ipAddress
    subnetMask
  }
}
fragment ProjectVersion on ProjectVersionResponseType {
  __typename
  versionNumber
  projectId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  projectFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  source
  commitMessage
  deviceInformation {
    __typename
    ...DeviceInformation
  }
}`);
export const ReadProjectViewerProjectDocument = new TypedDocumentString(`
    query ReadProjectViewerProject($projectId: String!, $filter: ProjectVersionFilterInput) {
  __typename
  readProject(projectId: $projectId) {
    __typename
    name
    projectId
    vendorId
    ideConfigId
    projectType
    updateUser {
      __typename
      ...AssetUserInfo
    }
    creationUser {
      __typename
      ...AssetUserInfo
    }
    versions(filter: $filter) {
      __typename
      items {
        __typename
        versionId
        creationTimestamp
        updateTimestamp
        updateUser {
          __typename
          ...AssetUserInfo
        }
        creationUser {
          __typename
          ...AssetUserInfo
        }
      }
    }
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`);
export const ReadProjectsByIdsDocument = new TypedDocumentString(`
    query ReadProjectsByIds($projectIds: [String!]!) {
  __typename
  readProjectsByIds(projectIds: $projectIds) {
    __typename
    items {
      __typename
      ...Project
    }
    itemCount
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Project on ProjectResponseType {
  __typename
  projectType
  vendorId
  name
  metaData
  attachedLicenses
  projectId
  groupId
  description
  ideConfigId
  creationTimestamp
  objectVersion
  updateTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  versions(
    filter: {source: {ne: "PROJECT_BACKUP"}}
    pagination: {page: 1, pageSize: 1}
  ) {
    __typename
    items {
      __typename
      ...ProjectVersion
    }
    itemCount
  }
  linkedDevices {
    __typename
    itemCount
    items {
      __typename
      deviceType
    }
  }
  secretId
  linkedSubProjects {
    __typename
    itemCount
  }
  linkedParentProjects {
    __typename
    itemCount
  }
  linkedDocuments {
    __typename
    itemCount
  }
}
fragment DeviceInformation on DeviceInformationType {
  __typename
  name
  deviceType
  ethernetCommunication {
    __typename
    ipAddress
    subnetMask
  }
}
fragment ProjectVersion on ProjectVersionResponseType {
  __typename
  versionNumber
  projectId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  projectFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  source
  commitMessage
  deviceInformation {
    __typename
    ...DeviceInformation
  }
}`);
export const ReadProjectNamesForRoleRowDocument = new TypedDocumentString(`
    query ReadProjectNamesForRoleRow($projectIds: [String!]!) {
  __typename
  readProjectsByIds(projectIds: $projectIds) {
    __typename
    items {
      __typename
      name
      projectId
    }
  }
}
    `);
export const ReadLatestActiveVersionDocument = new TypedDocumentString(`
    query ReadLatestActiveVersion($projectId: String!) {
  __typename
  readProjectVersionsForProject(
    projectId: $projectId
    filter: {source: {ne: "PROJECT_BACKUP"}}
    pagination: {page: 1, pageSize: 1}
  ) {
    __typename
    items {
      __typename
      ...ProjectVersion
    }
    itemCount
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment DeviceInformation on DeviceInformationType {
  __typename
  name
  deviceType
  ethernetCommunication {
    __typename
    ipAddress
    subnetMask
  }
}
fragment ProjectVersion on ProjectVersionResponseType {
  __typename
  versionNumber
  projectId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  projectFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  source
  commitMessage
  deviceInformation {
    __typename
    ...DeviceInformation
  }
}`);
export const ReadLatestVersionDocument = new TypedDocumentString(`
    query ReadLatestVersion($projectId: String!) {
  __typename
  readProjectVersionsForProject(
    projectId: $projectId
    pagination: {page: 1, pageSize: 1}
  ) {
    __typename
    items {
      __typename
      ...ProjectVersion
    }
    itemCount
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment DeviceInformation on DeviceInformationType {
  __typename
  name
  deviceType
  ethernetCommunication {
    __typename
    ipAddress
    subnetMask
  }
}
fragment ProjectVersion on ProjectVersionResponseType {
  __typename
  versionNumber
  projectId
  versionId
  creationTimestamp
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  updateTimestamp
  projectFile {
    __typename
    fileName
    fileExtension
    fileSize
  }
  objectVersion
  source
  commitMessage
  deviceInformation {
    __typename
    ...DeviceInformation
  }
}`);
export const CreateTagDocument = new TypedDocumentString(`
    mutation CreateTag($tag: CreateTagInput!) {
  __typename
  createTag(tag: $tag) {
    __typename
    ...Tag
  }
}
    fragment Tag on TagResponseType {
  __typename
  name
}`);
export const DefineAssetTagsDocument = new TypedDocumentString(`
    mutation DefineAssetTags($assetId: String!, $assetType: AssetTypeEnum!, $input: [DefineAssetLinkToAssetInput!]!) {
  __typename
  defineAssetLinksToAsset(
    sourceType: TAG
    destinationType: $assetType
    destinationId: $assetId
    input: $input
  ) {
    __typename
    items {
      __typename
      sourceType
      sourceId
      destinationType
      destinationId
    }
    itemCount
  }
}
    `);
export const DeleteTagDocument = new TypedDocumentString(`
    mutation DeleteTag($name: String!) {
  __typename
  deleteTag(name: $name) {
    __typename
    ...Tag
  }
}
    fragment Tag on TagResponseType {
  __typename
  name
}`);
export const ReadAllTagsDocument = new TypedDocumentString(`
    query ReadAllTags($filter: TagFilterInput, $pagination: PaginationInput) {
  __typename
  readAllTags(filter: $filter, pagination: $pagination) {
    __typename
    items {
      __typename
      ...Tag
    }
    pages
  }
}
    fragment Tag on TagResponseType {
  __typename
  name
}`);
export const ReadAllFullTagsDocument = new TypedDocumentString(`
    query ReadAllFullTags($filter: TagFilterInput, $pagination: PaginationInput) {
  __typename
  readAllTags(filter: $filter, pagination: $pagination) {
    __typename
    items {
      __typename
      ...FullTag
    }
    pages
    itemCount
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Tag on TagResponseType {
  __typename
  name
}
fragment FullTag on TagResponseType {
  __typename
  ...Tag
  creationUser {
    __typename
    ...AssetUserInfo
  }
  creationTimestamp
  devices {
    __typename
    items {
      __typename
      name
      deviceId
    }
    itemCount
  }
  projects {
    __typename
    items {
      __typename
      name
      projectId
    }
    itemCount
  }
  documents {
    __typename
    items {
      __typename
      name
      documentId
    }
    itemCount
  }
  gateways {
    __typename
    items {
      __typename
      name
      gatewayId
    }
    itemCount
  }
}`);
export const ReadLinkedTagsForAssetDocument = new TypedDocumentString(`
    query ReadLinkedTagsForAsset($assetId: String!, $assetType: AssetTypeEnum!, $pagination: PaginationInput) {
  __typename
  readLinkedTagsForAsset(
    assetId: $assetId
    assetType: $assetType
    pagination: $pagination
  ) {
    __typename
    items {
      __typename
      ...Tag
    }
    itemCount
    pages
  }
}
    fragment Tag on TagResponseType {
  __typename
  name
}`);
export const CreateVaultDocument = new TypedDocumentString(`
    mutation CreateVault($vault: CreateVaultInput!) {
  __typename
  createVault(vault: $vault) {
    __typename
    vaultId
    name
    description
  }
}
    `);
export const DeleteVaultDocument = new TypedDocumentString(`
    mutation DeleteVault($vaultId: String!) {
  __typename
  deleteVault(vaultId: $vaultId) {
    __typename
    vaultId
  }
}
    `);
export const CreateSecretDocument = new TypedDocumentString(`
    mutation CreateSecret($secret: CreateSecretInput!) {
  __typename
  createSecret(secret: $secret) {
    __typename
    secretId
    secretType
    name
    vaultId
  }
}
    `);
export const DeleteSecretDocument = new TypedDocumentString(`
    mutation DeleteSecret($secretId: String!) {
  __typename
  deleteSecret(secretId: $secretId) {
    __typename
    secretId
    vaultId
  }
}
    `);
export const UpdateVaultDocument = new TypedDocumentString(`
    mutation UpdateVault($vaultId: String!, $vault: UpdateVaultInput!) {
  __typename
  updateVault(vaultId: $vaultId, vault: $vault) {
    __typename
    vaultId
  }
}
    `);
export const UpdateSecretDocument = new TypedDocumentString(`
    mutation UpdateSecret($secretId: String!, $secret: UpdateSecretInput!) {
  __typename
  updateSecret(secretId: $secretId, secret: $secret) {
    __typename
    secretId
    vaultId
  }
}
    `);
export const SyncWeakSecretFlagsDocument = new TypedDocumentString(`
    mutation SyncWeakSecretFlags {
  __typename
  syncWeakSecretFlags {
    __typename
    allSecretsSecure
  }
}
    `);
export const ReadAllVaultsDocument = new TypedDocumentString(`
    query ReadAllVaults($pagination: PaginationInput, $filter: VaultFilterInput) {
  __typename
  readAllVaults(pagination: $pagination, filter: $filter) {
    __typename
    items {
      __typename
      ...Vault
    }
    itemCount
    pages
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Vault on VaultResponseType {
  __typename
  vaultId
  groupId
  name
  objectVersion
  creationTimestamp
  updateTimestamp
  secrets {
    __typename
    items {
      __typename
      secretId
      secretType
      weakSecret
      linkedDevices {
        __typename
        itemCount
      }
      linkedProjects {
        __typename
        itemCount
      }
    }
    itemCount
  }
  creationUser {
    __typename
    ...AssetUserInfo
  }
  description
}`);
export const ReadVaultDocument = new TypedDocumentString(`
    query ReadVault($vaultId: String!) {
  __typename
  readVault(vaultId: $vaultId) {
    __typename
    ...Vault
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment Vault on VaultResponseType {
  __typename
  vaultId
  groupId
  name
  objectVersion
  creationTimestamp
  updateTimestamp
  secrets {
    __typename
    items {
      __typename
      secretId
      secretType
      weakSecret
      linkedDevices {
        __typename
        itemCount
      }
      linkedProjects {
        __typename
        itemCount
      }
    }
    itemCount
  }
  creationUser {
    __typename
    ...AssetUserInfo
  }
  description
}`);
export const ReadSecretsForVaultDocument = new TypedDocumentString(`
    query ReadSecretsForVault($vaultId: String!, $pagination: PaginationInput, $filter: SecretFilterInput) {
  __typename
  readSecretsForVault(vaultId: $vaultId, pagination: $pagination, filter: $filter) {
    __typename
    items {
      __typename
      ...Secret
    }
    itemCount
    pages
  }
}
    fragment Secret on SecretResponseType {
  __typename
  secretId
  vault {
    __typename
    name
    vaultId
  }
  secretType
  weakSecret
  name
  username
  secretValue
  objectVersion
  linkedDevices {
    __typename
    itemCount
    items {
      __typename
      name
      deviceId
    }
  }
  linkedProjects {
    __typename
    itemCount
    items {
      __typename
      name
      projectId
    }
  }
}`);
export const ReadSecretDocument = new TypedDocumentString(`
    query ReadSecret($secretId: String!) {
  __typename
  readSecret(secretId: $secretId) {
    __typename
    ...Secret
  }
}
    fragment Secret on SecretResponseType {
  __typename
  secretId
  vault {
    __typename
    name
    vaultId
  }
  secretType
  weakSecret
  name
  username
  secretValue
  objectVersion
  linkedDevices {
    __typename
    itemCount
    items {
      __typename
      name
      deviceId
    }
  }
  linkedProjects {
    __typename
    itemCount
    items {
      __typename
      name
      projectId
    }
  }
}`);
export const ReadSecretUnceiledDocument = new TypedDocumentString(`
    query ReadSecretUnceiled($secretId: String!) {
  __typename
  readSecretUnceiled(secretId: $secretId) {
    __typename
    ...SecretUnceiled
  }
}
    fragment SecretUnceiled on SecretUnceiledResponseType {
  __typename
  secretId
  secretValue
}`);
export const ReadAllVaultNamesForPolicyRowDocument = new TypedDocumentString(`
    query ReadAllVaultNamesForPolicyRow($pagination: PaginationInput, $filter: VaultFilterInput) {
  __typename
  readAllVaults(pagination: $pagination, filter: $filter) {
    __typename
    items {
      __typename
      name
      vaultId
    }
  }
}
    `);
export const ReadWeakSecretsSummaryDocument = new TypedDocumentString(`
    query ReadWeakSecretsSummary {
  __typename
  readAllVaults {
    __typename
    itemCount
    items {
      __typename
      ...WeakSecrets
    }
  }
}
    fragment WeakSecrets on VaultResponseType {
  __typename
  vaultId
  secrets {
    __typename
    itemCount
    items {
      __typename
      secretId
      weakSecret
    }
  }
}`);
export const ReadAllDeviceVulnerabilitiesDocument = new TypedDocumentString(`
    query ReadAllDeviceVulnerabilities($filter: DeviceVulnerabilityFilterInput, $pagination: PaginationInput) {
  __typename
  readAllDeviceVulnerabilities(filter: $filter, pagination: $pagination) {
    __typename
    itemCount
    pages
    items {
      __typename
      ...DeviceVulnerability
    }
  }
}
    fragment DeviceVulnerability on DeviceOtCveResponseType {
  __typename
  deviceId
  deviceName
  deviceType
  vendor
  deviceVersion
  firmwareDeviceName
  cveNumber
  nvdSeverity
  affectedVersion
  fixedVersion
  constraint
  productArticleNumber
  isVulnerable
  publishedDate
  cvssScore
}`);
export const ReadOtCveDocument = new TypedDocumentString(`
    query ReadOtCve($cveNumber: String!, $productArticleNumber: String!) {
  __typename
  readOtCve(cveNumber: $cveNumber, productArticleNumber: $productArticleNumber) {
    __typename
    otCveId
    vendor
    record {
      __typename
      ...OtCveRecordFields
    }
  }
}
    fragment OtCveRecordFields on OtCveRecordType {
  __typename
  cveNumber
  cveTitle
  description
  nvdDescription
  cvssScore
  publishDate
  productArticleNumber
  productName
  affectedVersions
  fixedVersions
  advisoryLink
  nvdSeverity
  nvdUrl
}`);
export const ReadDeviceVulnerabilitySummaryDocument = new TypedDocumentString(`
    query ReadDeviceVulnerabilitySummary {
  __typename
  readAllDeviceVulnerabilities {
    __typename
    itemCount
    items {
      __typename
      deviceId
    }
  }
}
    `);
export const CreateWorkstationDocument = new TypedDocumentString(`
    mutation CreateWorkstation($workstation: CreateWorkstationInput!) {
  __typename
  createWorkstation(workstation: $workstation) {
    __typename
    groupId
    workstationId
  }
}
    `);
export const UpdateWorkstationDocument = new TypedDocumentString(`
    mutation UpdateWorkstation($workstationId: String!, $workstation: UpdateWorkstationInput!) {
  __typename
  updateWorkstation(workstationId: $workstationId, workstation: $workstation) {
    __typename
    groupId
    workstationId
  }
}
    `);
export const DeleteWorkstationDocument = new TypedDocumentString(`
    mutation DeleteWorkstation($workstationId: String!) {
  __typename
  deleteWorkstation(workstationId: $workstationId) {
    __typename
    groupId
    workstationId
  }
}
    `);
export const CreateWorkstationConnectionDocument = new TypedDocumentString(`
    mutation CreateWorkstationConnection($deviceId: String!, $workstationId: String!) {
  __typename
  createWorkstationDeviceConnectionV2(
    deviceId: $deviceId
    workstationId: $workstationId
  ) {
    __typename
    ...WorkstationDeviceConnection
  }
}
    fragment WorkstationDeviceConnection on WorkstationDeviceConnectionV2Type {
  __typename
  connectionId
  connectionState
  deviceId
  gatewayId
  workstationId
}`);
export const DeleteWorkstationConnectionDocument = new TypedDocumentString(`
    mutation DeleteWorkstationConnection($deviceId: String!, $workstationId: String!) {
  __typename
  deleteWorkstationDeviceConnectionV2(
    deviceId: $deviceId
    workstationId: $workstationId
  ) {
    __typename
    workstationId
  }
}
    `);
export const ReadAllWorkstationsDocument = new TypedDocumentString(`
    query ReadAllWorkstations($filter: WorkstationFilterInput, $pagination: PaginationInput) {
  __typename
  readAllWorkstationsForUser(filter: $filter, pagination: $pagination) {
    __typename
    items {
      __typename
      ...Workstation
    }
    itemCount
    pages
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment WorkstationPublicIp on WorkstationPublicIpResponseType {
  __typename
  publicIp
  reportedAt
  publicIpLocation {
    __typename
    city
    country
    state
  }
}
fragment WorkstationMetadata on WorkstationMetadataResponseType {
  __typename
  architecture
  isOutdated
  isOutdatedForMajor
  latestVersion
  latestVersionForMajor
  numCpu
  operatingSystem
  reportedAt
  version
}
fragment WorkstationSetupCommand on WorkstationSetupResponseType {
  __typename
  expiresAt
  osCommands {
    __typename
    configurationCommand
    installationCommand
    osName
    osType
  }
}
fragment Workstation on WorkstationResponseType {
  __typename
  name
  description
  workstationId
  groupId
  updateTimestamp
  creationTimestamp
  objectVersion
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  setupCommands {
    __typename
    ...WorkstationSetupCommand
  }
  metadata {
    __typename
    ...WorkstationMetadata
  }
  publicIp {
    __typename
    ...WorkstationPublicIp
  }
  state {
    __typename
    reportedAt
    state
  }
}`);
export const ReadWorkstationHealthStatusDocument = new TypedDocumentString(`
    query ReadWorkstationHealthStatus($workstationId: String!) {
  __typename
  readWorkstationState(workstationId: $workstationId) {
    __typename
    reportedAt
    state
  }
}
    `);
export const ReadWorkstationDocument = new TypedDocumentString(`
    query ReadWorkstation($workstationId: String!) {
  __typename
  readWorkstation(workstationId: $workstationId) {
    __typename
    ...Workstation
  }
}
    fragment AssetUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment WorkstationPublicIp on WorkstationPublicIpResponseType {
  __typename
  publicIp
  reportedAt
  publicIpLocation {
    __typename
    city
    country
    state
  }
}
fragment WorkstationMetadata on WorkstationMetadataResponseType {
  __typename
  architecture
  isOutdated
  isOutdatedForMajor
  latestVersion
  latestVersionForMajor
  numCpu
  operatingSystem
  reportedAt
  version
}
fragment WorkstationSetupCommand on WorkstationSetupResponseType {
  __typename
  expiresAt
  osCommands {
    __typename
    configurationCommand
    installationCommand
    osName
    osType
  }
}
fragment Workstation on WorkstationResponseType {
  __typename
  name
  description
  workstationId
  groupId
  updateTimestamp
  creationTimestamp
  objectVersion
  creationUser {
    __typename
    ...AssetUserInfo
  }
  updateUser {
    __typename
    ...AssetUserInfo
  }
  setupCommands {
    __typename
    ...WorkstationSetupCommand
  }
  metadata {
    __typename
    ...WorkstationMetadata
  }
  publicIp {
    __typename
    ...WorkstationPublicIp
  }
  state {
    __typename
    reportedAt
    state
  }
}`);
export const ReadWorkstationConnectionsDocument = new TypedDocumentString(`
    query ReadWorkstationConnections($workstationId: String!) {
  __typename
  readWorkstationDeviceConnectionsV2(workstationId: $workstationId) {
    __typename
    itemCount
    items {
      __typename
      ...WorkstationDeviceConnection
    }
    pages
  }
}
    fragment WorkstationDeviceConnection on WorkstationDeviceConnectionV2Type {
  __typename
  connectionId
  connectionState
  deviceId
  gatewayId
  workstationId
}`);

const injectedRtkApi = baseAssetsApi.injectEndpoints({
  overrideExisting: isHotReloadEnabled && module.hot?.status() === "apply",
  endpoints: (build) => ({
    CreateDevice: build.mutation<Types.CreateDeviceMutation, Types.CreateDeviceMutationVariables>({
      query: (variables) => ({ document: CreateDeviceDocument as unknown as string, variables })
    }),
    UpdateDevice: build.mutation<Types.UpdateDeviceMutation, Types.UpdateDeviceMutationVariables>({
      query: (variables) => ({ document: UpdateDeviceDocument as unknown as string, variables })
    }),
    DeleteDevice: build.mutation<Types.DeleteDeviceMutation, Types.DeleteDeviceMutationVariables>({
      query: (variables) => ({ document: DeleteDeviceDocument as unknown as string, variables })
    }),
    ReadAllDevices: build.query<Types.ReadAllDevicesQuery, Types.ReadAllDevicesQueryVariables | void>({
      query: (variables) => ({ document: ReadAllDevicesDocument as unknown as string, variables })
    }),
    ReadDevicesByIds: build.query<Types.ReadDevicesByIdsQuery, Types.ReadDevicesByIdsQueryVariables>({
      query: (variables) => ({ document: ReadDevicesByIdsDocument as unknown as string, variables })
    }),
    ReadDevice: build.query<Types.ReadDeviceQuery, Types.ReadDeviceQueryVariables>({
      query: (variables) => ({ document: ReadDeviceDocument as unknown as string, variables })
    }),
    ReadLinkedProjectsForDevice: build.query<Types.ReadLinkedProjectsForDeviceQuery, Types.ReadLinkedProjectsForDeviceQueryVariables>({
      query: (variables) => ({ document: ReadLinkedProjectsForDeviceDocument as unknown as string, variables })
    }),
    ReadDeviceSyncStatus: build.query<Types.ReadDeviceSyncStatusQuery, Types.ReadDeviceSyncStatusQueryVariables>({
      query: (variables) => ({ document: ReadDeviceSyncStatusDocument as unknown as string, variables })
    }),
    ReadDeviceNamesForRoleRow: build.query<Types.ReadDeviceNamesForRoleRowQuery, Types.ReadDeviceNamesForRoleRowQueryVariables>({
      query: (variables) => ({ document: ReadDeviceNamesForRoleRowDocument as unknown as string, variables })
    }),
    ReadDeviceConnectivityStatus: build.query<Types.ReadDeviceConnectivityStatusQuery, Types.ReadDeviceConnectivityStatusQueryVariables>({
      query: (variables) => ({ document: ReadDeviceConnectivityStatusDocument as unknown as string, variables })
    }),
    ReadDeviceFirmwareInformation: build.query<Types.ReadDeviceFirmwareInformationQuery, Types.ReadDeviceFirmwareInformationQueryVariables>({
      query: (variables) => ({ document: ReadDeviceFirmwareInformationDocument as unknown as string, variables })
    }),
    CompleteDocumentMultipartUpload: build.mutation<Types.CompleteDocumentMultipartUploadMutation, Types.CompleteDocumentMultipartUploadMutationVariables>({
      query: (variables) => ({ document: CompleteDocumentMultipartUploadDocument as unknown as string, variables })
    }),
    CreateDocument: build.mutation<Types.CreateDocumentMutation, Types.CreateDocumentMutationVariables>({
      query: (variables) => ({ document: CreateDocumentDocument as unknown as string, variables })
    }),
    CreateDocumentVersion: build.mutation<Types.CreateDocumentVersionMutation, Types.CreateDocumentVersionMutationVariables>({
      query: (variables) => ({ document: CreateDocumentVersionDocument as unknown as string, variables })
    }),
    DeleteDocument: build.mutation<Types.DeleteDocumentMutation, Types.DeleteDocumentMutationVariables>({
      query: (variables) => ({ document: DeleteDocumentDocument as unknown as string, variables })
    }),
    UpdateDocument: build.mutation<Types.UpdateDocumentMutation, Types.UpdateDocumentMutationVariables>({
      query: (variables) => ({ document: UpdateDocumentDocument as unknown as string, variables })
    }),
    UpdateDocumentVersion: build.mutation<Types.UpdateDocumentVersionMutation, Types.UpdateDocumentVersionMutationVariables>({
      query: (variables) => ({ document: UpdateDocumentVersionDocument as unknown as string, variables })
    }),
    DownloadDocumentVersion: build.query<Types.DownloadDocumentVersionQuery, Types.DownloadDocumentVersionQueryVariables>({
      query: (variables) => ({ document: DownloadDocumentVersionDocument as unknown as string, variables })
    }),
    ReadDocumentsByIds: build.query<Types.ReadDocumentsByIdsQuery, Types.ReadDocumentsByIdsQueryVariables>({
      query: (variables) => ({ document: ReadDocumentsByIdsDocument as unknown as string, variables })
    }),
    ReadDocument: build.query<Types.ReadDocumentQuery, Types.ReadDocumentQueryVariables>({
      query: (variables) => ({ document: ReadDocumentDocument as unknown as string, variables })
    }),
    ReadAllDocuments: build.query<Types.ReadAllDocumentsQuery, Types.ReadAllDocumentsQueryVariables | void>({
      query: (variables) => ({ document: ReadAllDocumentsDocument as unknown as string, variables })
    }),
    ReadLinkedDocumentsForAsset: build.query<Types.ReadLinkedDocumentsForAssetQuery, Types.ReadLinkedDocumentsForAssetQueryVariables>({
      query: (variables) => ({ document: ReadLinkedDocumentsForAssetDocument as unknown as string, variables })
    }),
    ReadLinkedAssetsFromDocument: build.query<Types.ReadLinkedAssetsFromDocumentQuery, Types.ReadLinkedAssetsFromDocumentQueryVariables>({
      query: (variables) => ({ document: ReadLinkedAssetsFromDocumentDocument as unknown as string, variables })
    }),
    ReadVersionsForDocument: build.query<Types.ReadVersionsForDocumentQuery, Types.ReadVersionsForDocumentQueryVariables>({
      query: (variables) => ({ document: ReadVersionsForDocumentDocument as unknown as string, variables })
    }),
    ReadDocumentNamesForRoleRow: build.query<Types.ReadDocumentNamesForRoleRowQuery, Types.ReadDocumentNamesForRoleRowQueryVariables>({
      query: (variables) => ({ document: ReadDocumentNamesForRoleRowDocument as unknown as string, variables })
    }),
    DeleteGateway: build.mutation<Types.DeleteGatewayMutation, Types.DeleteGatewayMutationVariables>({
      query: (variables) => ({ document: DeleteGatewayDocument as unknown as string, variables })
    }),
    CreateGateway: build.mutation<Types.CreateGatewayMutation, Types.CreateGatewayMutationVariables>({
      query: (variables) => ({ document: CreateGatewayDocument as unknown as string, variables })
    }),
    UpdateGateway: build.mutation<Types.UpdateGatewayMutation, Types.UpdateGatewayMutationVariables>({
      query: (variables) => ({ document: UpdateGatewayDocument as unknown as string, variables })
    }),
    UpdateGatewayConfig: build.mutation<Types.UpdateGatewayConfigMutation, Types.UpdateGatewayConfigMutationVariables>({
      query: (variables) => ({ document: UpdateGatewayConfigDocument as unknown as string, variables })
    }),
    RequestGatewayUpdate: build.mutation<Types.RequestGatewayUpdateMutation, Types.RequestGatewayUpdateMutationVariables>({
      query: (variables) => ({ document: RequestGatewayUpdateDocument as unknown as string, variables })
    }),
    ReadAllGateways: build.query<Types.ReadAllGatewaysQuery, Types.ReadAllGatewaysQueryVariables | void>({
      query: (variables) => ({ document: ReadAllGatewaysDocument as unknown as string, variables })
    }),
    ReadLinkedDevicesForGateway: build.query<Types.ReadLinkedDevicesForGatewayQuery, Types.ReadLinkedDevicesForGatewayQueryVariables>({
      query: (variables) => ({ document: ReadLinkedDevicesForGatewayDocument as unknown as string, variables })
    }),
    ReadGatewaysByIds: build.query<Types.ReadGatewaysByIdsQuery, Types.ReadGatewaysByIdsQueryVariables>({
      query: (variables) => ({ document: ReadGatewaysByIdsDocument as unknown as string, variables })
    }),
    ReadGateway: build.query<Types.ReadGatewayQuery, Types.ReadGatewayQueryVariables>({
      query: (variables) => ({ document: ReadGatewayDocument as unknown as string, variables })
    }),
    ReadGatewayHealthStatus: build.query<Types.ReadGatewayHealthStatusQuery, Types.ReadGatewayHealthStatusQueryVariables>({
      query: (variables) => ({ document: ReadGatewayHealthStatusDocument as unknown as string, variables })
    }),
    ReadGatewaysHealthStatus: build.query<Types.ReadGatewaysHealthStatusQuery, Types.ReadGatewaysHealthStatusQueryVariables>({
      query: (variables) => ({ document: ReadGatewaysHealthStatusDocument as unknown as string, variables })
    }),
    ReadGatewayNamesForRoleRow: build.query<Types.ReadGatewayNamesForRoleRowQuery, Types.ReadGatewayNamesForRoleRowQueryVariables>({
      query: (variables) => ({ document: ReadGatewayNamesForRoleRowDocument as unknown as string, variables })
    }),
    ReadGatewayConfig: build.query<Types.ReadGatewayConfigQuery, Types.ReadGatewayConfigQueryVariables>({
      query: (variables) => ({ document: ReadGatewayConfigDocument as unknown as string, variables })
    }),
    ReadGatewayUpdateStatus: build.query<Types.ReadGatewayUpdateStatusQuery, Types.ReadGatewayUpdateStatusQueryVariables>({
      query: (variables) => ({ document: ReadGatewayUpdateStatusDocument as unknown as string, variables })
    }),
    ReadGatewaySetup: build.query<Types.ReadGatewaySetupQuery, Types.ReadGatewaySetupQueryVariables>({
      query: (variables) => ({ document: ReadGatewaySetupDocument as unknown as string, variables })
    }),
    ReadDevicesSyncStatusByGateway: build.query<Types.ReadDevicesSyncStatusByGatewayQuery, Types.ReadDevicesSyncStatusByGatewayQueryVariables>({
      query: (variables) => ({ document: ReadDevicesSyncStatusByGatewayDocument as unknown as string, variables })
    }),
    DeleteResourceGroup: build.mutation<Types.DeleteResourceGroupMutation, Types.DeleteResourceGroupMutationVariables>({
      query: (variables) => ({ document: DeleteResourceGroupDocument as unknown as string, variables })
    }),
    CreateResourceGroup: build.mutation<Types.CreateResourceGroupMutation, Types.CreateResourceGroupMutationVariables>({
      query: (variables) => ({ document: CreateResourceGroupDocument as unknown as string, variables })
    }),
    UpdateResourceGroup: build.mutation<Types.UpdateResourceGroupMutation, Types.UpdateResourceGroupMutationVariables>({
      query: (variables) => ({ document: UpdateResourceGroupDocument as unknown as string, variables })
    }),
    ReadResourceGroupById: build.query<Types.ReadResourceGroupByIdQuery, Types.ReadResourceGroupByIdQueryVariables>({
      query: (variables) => ({ document: ReadResourceGroupByIdDocument as unknown as string, variables })
    }),
    ReadResourceGroupsToBuildTree: build.query<Types.ReadResourceGroupsToBuildTreeQuery, Types.ReadResourceGroupsToBuildTreeQueryVariables | void>({
      query: (variables) => ({ document: ReadResourceGroupsToBuildTreeDocument as unknown as string, variables })
    }),
    ReadAllResourceGroups: build.query<Types.ReadAllResourceGroupsQuery, Types.ReadAllResourceGroupsQueryVariables | void>({
      query: (variables) => ({ document: ReadAllResourceGroupsDocument as unknown as string, variables })
    }),
    ReadSubGroupsForResourceGroup: build.query<Types.ReadSubGroupsForResourceGroupQuery, Types.ReadSubGroupsForResourceGroupQueryVariables>({
      query: (variables) => ({ document: ReadSubGroupsForResourceGroupDocument as unknown as string, variables })
    }),
    ReadResourceGroupNamesForRoleRow: build.query<Types.ReadResourceGroupNamesForRoleRowQuery, Types.ReadResourceGroupNamesForRoleRowQueryVariables>({
      query: (variables) => ({ document: ReadResourceGroupNamesForRoleRowDocument as unknown as string, variables })
    }),
    ReadResourceGroupNameById: build.query<Types.ReadResourceGroupNameByIdQuery, Types.ReadResourceGroupNameByIdQueryVariables>({
      query: (variables) => ({ document: ReadResourceGroupNameByIdDocument as unknown as string, variables })
    }),
    ReadAllResourceGroupsWithoutPermissionChecks: build.query<Types.ReadAllResourceGroupsWithoutPermissionChecksQuery, Types.ReadAllResourceGroupsWithoutPermissionChecksQueryVariables | void>({
      query: (variables) => ({ document: ReadAllResourceGroupsWithoutPermissionChecksDocument as unknown as string, variables })
    }),
    ReadGroupedAssetsCount: build.query<Types.ReadGroupedAssetsCountQuery, Types.ReadGroupedAssetsCountQueryVariables>({
      query: (variables) => ({ document: ReadGroupedAssetsCountDocument as unknown as string, variables })
    }),
    ReadUngroupedAssetsCount: build.query<Types.ReadUngroupedAssetsCountQuery, Types.ReadUngroupedAssetsCountQueryVariables | void>({
      query: (variables) => ({ document: ReadUngroupedAssetsCountDocument as unknown as string, variables })
    }),
    CreateLicense: build.mutation<Types.CreateLicenseMutation, Types.CreateLicenseMutationVariables>({
      query: (variables) => ({ document: CreateLicenseDocument as unknown as string, variables })
    }),
    CompleteLicenseMultipartUpload: build.mutation<Types.CompleteLicenseMultipartUploadMutation, Types.CompleteLicenseMultipartUploadMutationVariables>({
      query: (variables) => ({ document: CompleteLicenseMultipartUploadDocument as unknown as string, variables })
    }),
    DeleteLicense: build.mutation<Types.DeleteLicenseMutation, Types.DeleteLicenseMutationVariables>({
      query: (variables) => ({ document: DeleteLicenseDocument as unknown as string, variables })
    }),
    UpdateLicense: build.mutation<Types.UpdateLicenseMutation, Types.UpdateLicenseMutationVariables>({
      query: (variables) => ({ document: UpdateLicenseDocument as unknown as string, variables })
    }),
    ReadAllLicenses: build.query<Types.ReadAllLicensesQuery, Types.ReadAllLicensesQueryVariables | void>({
      query: (variables) => ({ document: ReadAllLicensesDocument as unknown as string, variables })
    }),
    DownloadLicense: build.query<Types.DownloadLicenseQuery, Types.DownloadLicenseQueryVariables>({
      query: (variables) => ({ document: DownloadLicenseDocument as unknown as string, variables })
    }),
    ReadLicenseNamesForRoleRow: build.query<Types.ReadLicenseNamesForRoleRowQuery, Types.ReadLicenseNamesForRoleRowQueryVariables>({
      query: (variables) => ({ document: ReadLicenseNamesForRoleRowDocument as unknown as string, variables })
    }),
    DeleteAssetLink: build.mutation<Types.DeleteAssetLinkMutation, Types.DeleteAssetLinkMutationVariables>({
      query: (variables) => ({ document: DeleteAssetLinkDocument as unknown as string, variables })
    }),
    LinkDocumentToAsset: build.mutation<Types.LinkDocumentToAssetMutation, Types.LinkDocumentToAssetMutationVariables>({
      query: (variables) => ({ document: LinkDocumentToAssetDocument as unknown as string, variables })
    }),
    LinkLibraryToProject: build.mutation<Types.LinkLibraryToProjectMutation, Types.LinkLibraryToProjectMutationVariables>({
      query: (variables) => ({ document: LinkLibraryToProjectDocument as unknown as string, variables })
    }),
    LinkDeviceToProject: build.mutation<Types.LinkDeviceToProjectMutation, Types.LinkDeviceToProjectMutationVariables>({
      query: (variables) => ({ document: LinkDeviceToProjectDocument as unknown as string, variables })
    }),
    UpdateDeviceToProjectLink: build.mutation<Types.UpdateDeviceToProjectLinkMutation, Types.UpdateDeviceToProjectLinkMutationVariables>({
      query: (variables) => ({ document: UpdateDeviceToProjectLinkDocument as unknown as string, variables })
    }),
    LinkDeviceToGateway: build.mutation<Types.LinkDeviceToGatewayMutation, Types.LinkDeviceToGatewayMutationVariables>({
      query: (variables) => ({ document: LinkDeviceToGatewayDocument as unknown as string, variables })
    }),
    DefineGatewayLinksToDevice: build.mutation<Types.DefineGatewayLinksToDeviceMutation, Types.DefineGatewayLinksToDeviceMutationVariables>({
      query: (variables) => ({ document: DefineGatewayLinksToDeviceDocument as unknown as string, variables })
    }),
    ReadAssetLink: build.query<Types.ReadAssetLinkQuery, Types.ReadAssetLinkQueryVariables>({
      query: (variables) => ({ document: ReadAssetLinkDocument as unknown as string, variables })
    }),
    CreateLock: build.mutation<Types.CreateLockMutation, Types.CreateLockMutationVariables>({
      query: (variables) => ({ document: CreateLockDocument as unknown as string, variables })
    }),
    DeleteLock: build.mutation<Types.DeleteLockMutation, Types.DeleteLockMutationVariables>({
      query: (variables) => ({ document: DeleteLockDocument as unknown as string, variables })
    }),
    ReadLock: build.query<Types.ReadLockQuery, Types.ReadLockQueryVariables>({
      query: (variables) => ({ document: ReadLockDocument as unknown as string, variables })
    }),
    CreateProject: build.mutation<Types.CreateProjectMutation, Types.CreateProjectMutationVariables>({
      query: (variables) => ({ document: CreateProjectDocument as unknown as string, variables })
    }),
    CompleteProjectMultipartUpload: build.mutation<Types.CompleteProjectMultipartUploadMutation, Types.CompleteProjectMultipartUploadMutationVariables>({
      query: (variables) => ({ document: CompleteProjectMultipartUploadDocument as unknown as string, variables })
    }),
    DeleteProject: build.mutation<Types.DeleteProjectMutation, Types.DeleteProjectMutationVariables>({
      query: (variables) => ({ document: DeleteProjectDocument as unknown as string, variables })
    }),
    DeleteProjectVersion: build.mutation<Types.DeleteProjectVersionMutation, Types.DeleteProjectVersionMutationVariables>({
      query: (variables) => ({ document: DeleteProjectVersionDocument as unknown as string, variables })
    }),
    UpdateProject: build.mutation<Types.UpdateProjectMutation, Types.UpdateProjectMutationVariables>({
      query: (variables) => ({ document: UpdateProjectDocument as unknown as string, variables })
    }),
    CreateProjectVersion: build.mutation<Types.CreateProjectVersionMutation, Types.CreateProjectVersionMutationVariables>({
      query: (variables) => ({ document: CreateProjectVersionDocument as unknown as string, variables })
    }),
    UpdateProjectVersion: build.mutation<Types.UpdateProjectVersionMutation, Types.UpdateProjectVersionMutationVariables>({
      query: (variables) => ({ document: UpdateProjectVersionDocument as unknown as string, variables })
    }),
    ReadAllProjects: build.query<Types.ReadAllProjectsQuery, Types.ReadAllProjectsQueryVariables | void>({
      query: (variables) => ({ document: ReadAllProjectsDocument as unknown as string, variables })
    }),
    DownloadProjectVersion: build.query<Types.DownloadProjectVersionQuery, Types.DownloadProjectVersionQueryVariables>({
      query: (variables) => ({ document: DownloadProjectVersionDocument as unknown as string, variables })
    }),
    ReadProject: build.query<Types.ReadProjectQuery, Types.ReadProjectQueryVariables>({
      query: (variables) => ({ document: ReadProjectDocument as unknown as string, variables })
    }),
    ReadVersionsForProject: build.query<Types.ReadVersionsForProjectQuery, Types.ReadVersionsForProjectQueryVariables>({
      query: (variables) => ({ document: ReadVersionsForProjectDocument as unknown as string, variables })
    }),
    ReadLinkedLibrariesForProject: build.query<Types.ReadLinkedLibrariesForProjectQuery, Types.ReadLinkedLibrariesForProjectQueryVariables>({
      query: (variables) => ({ document: ReadLinkedLibrariesForProjectDocument as unknown as string, variables })
    }),
    ReadLinkedDevicesForProject: build.query<Types.ReadLinkedDevicesForProjectQuery, Types.ReadLinkedDevicesForProjectQueryVariables>({
      query: (variables) => ({ document: ReadLinkedDevicesForProjectDocument as unknown as string, variables })
    }),
    ReadProjectViewerProject: build.query<Types.ReadProjectViewerProjectQuery, Types.ReadProjectViewerProjectQueryVariables>({
      query: (variables) => ({ document: ReadProjectViewerProjectDocument as unknown as string, variables })
    }),
    ReadProjectsByIds: build.query<Types.ReadProjectsByIdsQuery, Types.ReadProjectsByIdsQueryVariables>({
      query: (variables) => ({ document: ReadProjectsByIdsDocument as unknown as string, variables })
    }),
    ReadProjectNamesForRoleRow: build.query<Types.ReadProjectNamesForRoleRowQuery, Types.ReadProjectNamesForRoleRowQueryVariables>({
      query: (variables) => ({ document: ReadProjectNamesForRoleRowDocument as unknown as string, variables })
    }),
    ReadLatestActiveVersion: build.query<Types.ReadLatestActiveVersionQuery, Types.ReadLatestActiveVersionQueryVariables>({
      query: (variables) => ({ document: ReadLatestActiveVersionDocument as unknown as string, variables })
    }),
    ReadLatestVersion: build.query<Types.ReadLatestVersionQuery, Types.ReadLatestVersionQueryVariables>({
      query: (variables) => ({ document: ReadLatestVersionDocument as unknown as string, variables })
    }),
    CreateTag: build.mutation<Types.CreateTagMutation, Types.CreateTagMutationVariables>({
      query: (variables) => ({ document: CreateTagDocument as unknown as string, variables })
    }),
    DefineAssetTags: build.mutation<Types.DefineAssetTagsMutation, Types.DefineAssetTagsMutationVariables>({
      query: (variables) => ({ document: DefineAssetTagsDocument as unknown as string, variables })
    }),
    DeleteTag: build.mutation<Types.DeleteTagMutation, Types.DeleteTagMutationVariables>({
      query: (variables) => ({ document: DeleteTagDocument as unknown as string, variables })
    }),
    ReadAllTags: build.query<Types.ReadAllTagsQuery, Types.ReadAllTagsQueryVariables | void>({
      query: (variables) => ({ document: ReadAllTagsDocument as unknown as string, variables })
    }),
    ReadAllFullTags: build.query<Types.ReadAllFullTagsQuery, Types.ReadAllFullTagsQueryVariables | void>({
      query: (variables) => ({ document: ReadAllFullTagsDocument as unknown as string, variables })
    }),
    ReadLinkedTagsForAsset: build.query<Types.ReadLinkedTagsForAssetQuery, Types.ReadLinkedTagsForAssetQueryVariables>({
      query: (variables) => ({ document: ReadLinkedTagsForAssetDocument as unknown as string, variables })
    }),
    CreateVault: build.mutation<Types.CreateVaultMutation, Types.CreateVaultMutationVariables>({
      query: (variables) => ({ document: CreateVaultDocument as unknown as string, variables })
    }),
    DeleteVault: build.mutation<Types.DeleteVaultMutation, Types.DeleteVaultMutationVariables>({
      query: (variables) => ({ document: DeleteVaultDocument as unknown as string, variables })
    }),
    CreateSecret: build.mutation<Types.CreateSecretMutation, Types.CreateSecretMutationVariables>({
      query: (variables) => ({ document: CreateSecretDocument as unknown as string, variables })
    }),
    DeleteSecret: build.mutation<Types.DeleteSecretMutation, Types.DeleteSecretMutationVariables>({
      query: (variables) => ({ document: DeleteSecretDocument as unknown as string, variables })
    }),
    UpdateVault: build.mutation<Types.UpdateVaultMutation, Types.UpdateVaultMutationVariables>({
      query: (variables) => ({ document: UpdateVaultDocument as unknown as string, variables })
    }),
    UpdateSecret: build.mutation<Types.UpdateSecretMutation, Types.UpdateSecretMutationVariables>({
      query: (variables) => ({ document: UpdateSecretDocument as unknown as string, variables })
    }),
    SyncWeakSecretFlags: build.mutation<Types.SyncWeakSecretFlagsMutation, Types.SyncWeakSecretFlagsMutationVariables | void>({
      query: (variables) => ({ document: SyncWeakSecretFlagsDocument as unknown as string, variables })
    }),
    ReadAllVaults: build.query<Types.ReadAllVaultsQuery, Types.ReadAllVaultsQueryVariables | void>({
      query: (variables) => ({ document: ReadAllVaultsDocument as unknown as string, variables })
    }),
    ReadVault: build.query<Types.ReadVaultQuery, Types.ReadVaultQueryVariables>({
      query: (variables) => ({ document: ReadVaultDocument as unknown as string, variables })
    }),
    ReadSecretsForVault: build.query<Types.ReadSecretsForVaultQuery, Types.ReadSecretsForVaultQueryVariables>({
      query: (variables) => ({ document: ReadSecretsForVaultDocument as unknown as string, variables })
    }),
    ReadSecret: build.query<Types.ReadSecretQuery, Types.ReadSecretQueryVariables>({
      query: (variables) => ({ document: ReadSecretDocument as unknown as string, variables })
    }),
    ReadSecretUnceiled: build.query<Types.ReadSecretUnceiledQuery, Types.ReadSecretUnceiledQueryVariables>({
      query: (variables) => ({ document: ReadSecretUnceiledDocument as unknown as string, variables })
    }),
    ReadAllVaultNamesForPolicyRow: build.query<Types.ReadAllVaultNamesForPolicyRowQuery, Types.ReadAllVaultNamesForPolicyRowQueryVariables | void>({
      query: (variables) => ({ document: ReadAllVaultNamesForPolicyRowDocument as unknown as string, variables })
    }),
    ReadWeakSecretsSummary: build.query<Types.ReadWeakSecretsSummaryQuery, Types.ReadWeakSecretsSummaryQueryVariables | void>({
      query: (variables) => ({ document: ReadWeakSecretsSummaryDocument as unknown as string, variables })
    }),
    ReadAllDeviceVulnerabilities: build.query<Types.ReadAllDeviceVulnerabilitiesQuery, Types.ReadAllDeviceVulnerabilitiesQueryVariables | void>({
      query: (variables) => ({ document: ReadAllDeviceVulnerabilitiesDocument as unknown as string, variables })
    }),
    ReadOtCve: build.query<Types.ReadOtCveQuery, Types.ReadOtCveQueryVariables>({
      query: (variables) => ({ document: ReadOtCveDocument as unknown as string, variables })
    }),
    ReadDeviceVulnerabilitySummary: build.query<Types.ReadDeviceVulnerabilitySummaryQuery, Types.ReadDeviceVulnerabilitySummaryQueryVariables | void>({
      query: (variables) => ({ document: ReadDeviceVulnerabilitySummaryDocument as unknown as string, variables })
    }),
    CreateWorkstation: build.mutation<Types.CreateWorkstationMutation, Types.CreateWorkstationMutationVariables>({
      query: (variables) => ({ document: CreateWorkstationDocument as unknown as string, variables })
    }),
    UpdateWorkstation: build.mutation<Types.UpdateWorkstationMutation, Types.UpdateWorkstationMutationVariables>({
      query: (variables) => ({ document: UpdateWorkstationDocument as unknown as string, variables })
    }),
    DeleteWorkstation: build.mutation<Types.DeleteWorkstationMutation, Types.DeleteWorkstationMutationVariables>({
      query: (variables) => ({ document: DeleteWorkstationDocument as unknown as string, variables })
    }),
    CreateWorkstationConnection: build.mutation<Types.CreateWorkstationConnectionMutation, Types.CreateWorkstationConnectionMutationVariables>({
      query: (variables) => ({ document: CreateWorkstationConnectionDocument as unknown as string, variables })
    }),
    DeleteWorkstationConnection: build.mutation<Types.DeleteWorkstationConnectionMutation, Types.DeleteWorkstationConnectionMutationVariables>({
      query: (variables) => ({ document: DeleteWorkstationConnectionDocument as unknown as string, variables })
    }),
    ReadAllWorkstations: build.query<Types.ReadAllWorkstationsQuery, Types.ReadAllWorkstationsQueryVariables | void>({
      query: (variables) => ({ document: ReadAllWorkstationsDocument as unknown as string, variables })
    }),
    ReadWorkstationHealthStatus: build.query<Types.ReadWorkstationHealthStatusQuery, Types.ReadWorkstationHealthStatusQueryVariables>({
      query: (variables) => ({ document: ReadWorkstationHealthStatusDocument as unknown as string, variables })
    }),
    ReadWorkstation: build.query<Types.ReadWorkstationQuery, Types.ReadWorkstationQueryVariables>({
      query: (variables) => ({ document: ReadWorkstationDocument as unknown as string, variables })
    }),
    ReadWorkstationConnections: build.query<Types.ReadWorkstationConnectionsQuery, Types.ReadWorkstationConnectionsQueryVariables>({
      query: (variables) => ({ document: ReadWorkstationConnectionsDocument as unknown as string, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useCreateDeviceMutation, useUpdateDeviceMutation, useDeleteDeviceMutation, useReadAllDevicesQuery, useLazyReadAllDevicesQuery, useReadDevicesByIdsQuery, useLazyReadDevicesByIdsQuery, useReadDeviceQuery, useLazyReadDeviceQuery, useReadLinkedProjectsForDeviceQuery, useLazyReadLinkedProjectsForDeviceQuery, useReadDeviceSyncStatusQuery, useLazyReadDeviceSyncStatusQuery, useReadDeviceNamesForRoleRowQuery, useLazyReadDeviceNamesForRoleRowQuery, useReadDeviceConnectivityStatusQuery, useLazyReadDeviceConnectivityStatusQuery, useReadDeviceFirmwareInformationQuery, useLazyReadDeviceFirmwareInformationQuery, useCompleteDocumentMultipartUploadMutation, useCreateDocumentMutation, useCreateDocumentVersionMutation, useDeleteDocumentMutation, useUpdateDocumentMutation, useUpdateDocumentVersionMutation, useDownloadDocumentVersionQuery, useLazyDownloadDocumentVersionQuery, useReadDocumentsByIdsQuery, useLazyReadDocumentsByIdsQuery, useReadDocumentQuery, useLazyReadDocumentQuery, useReadAllDocumentsQuery, useLazyReadAllDocumentsQuery, useReadLinkedDocumentsForAssetQuery, useLazyReadLinkedDocumentsForAssetQuery, useReadLinkedAssetsFromDocumentQuery, useLazyReadLinkedAssetsFromDocumentQuery, useReadVersionsForDocumentQuery, useLazyReadVersionsForDocumentQuery, useReadDocumentNamesForRoleRowQuery, useLazyReadDocumentNamesForRoleRowQuery, useDeleteGatewayMutation, useCreateGatewayMutation, useUpdateGatewayMutation, useUpdateGatewayConfigMutation, useRequestGatewayUpdateMutation, useReadAllGatewaysQuery, useLazyReadAllGatewaysQuery, useReadLinkedDevicesForGatewayQuery, useLazyReadLinkedDevicesForGatewayQuery, useReadGatewaysByIdsQuery, useLazyReadGatewaysByIdsQuery, useReadGatewayQuery, useLazyReadGatewayQuery, useReadGatewayHealthStatusQuery, useLazyReadGatewayHealthStatusQuery, useReadGatewaysHealthStatusQuery, useLazyReadGatewaysHealthStatusQuery, useReadGatewayNamesForRoleRowQuery, useLazyReadGatewayNamesForRoleRowQuery, useReadGatewayConfigQuery, useLazyReadGatewayConfigQuery, useReadGatewayUpdateStatusQuery, useLazyReadGatewayUpdateStatusQuery, useReadGatewaySetupQuery, useLazyReadGatewaySetupQuery, useReadDevicesSyncStatusByGatewayQuery, useLazyReadDevicesSyncStatusByGatewayQuery, useDeleteResourceGroupMutation, useCreateResourceGroupMutation, useUpdateResourceGroupMutation, useReadResourceGroupByIdQuery, useLazyReadResourceGroupByIdQuery, useReadResourceGroupsToBuildTreeQuery, useLazyReadResourceGroupsToBuildTreeQuery, useReadAllResourceGroupsQuery, useLazyReadAllResourceGroupsQuery, useReadSubGroupsForResourceGroupQuery, useLazyReadSubGroupsForResourceGroupQuery, useReadResourceGroupNamesForRoleRowQuery, useLazyReadResourceGroupNamesForRoleRowQuery, useReadResourceGroupNameByIdQuery, useLazyReadResourceGroupNameByIdQuery, useReadAllResourceGroupsWithoutPermissionChecksQuery, useLazyReadAllResourceGroupsWithoutPermissionChecksQuery, useReadGroupedAssetsCountQuery, useLazyReadGroupedAssetsCountQuery, useReadUngroupedAssetsCountQuery, useLazyReadUngroupedAssetsCountQuery, useCreateLicenseMutation, useCompleteLicenseMultipartUploadMutation, useDeleteLicenseMutation, useUpdateLicenseMutation, useReadAllLicensesQuery, useLazyReadAllLicensesQuery, useDownloadLicenseQuery, useLazyDownloadLicenseQuery, useReadLicenseNamesForRoleRowQuery, useLazyReadLicenseNamesForRoleRowQuery, useDeleteAssetLinkMutation, useLinkDocumentToAssetMutation, useLinkLibraryToProjectMutation, useLinkDeviceToProjectMutation, useUpdateDeviceToProjectLinkMutation, useLinkDeviceToGatewayMutation, useDefineGatewayLinksToDeviceMutation, useReadAssetLinkQuery, useLazyReadAssetLinkQuery, useCreateLockMutation, useDeleteLockMutation, useReadLockQuery, useLazyReadLockQuery, useCreateProjectMutation, useCompleteProjectMultipartUploadMutation, useDeleteProjectMutation, useDeleteProjectVersionMutation, useUpdateProjectMutation, useCreateProjectVersionMutation, useUpdateProjectVersionMutation, useReadAllProjectsQuery, useLazyReadAllProjectsQuery, useDownloadProjectVersionQuery, useLazyDownloadProjectVersionQuery, useReadProjectQuery, useLazyReadProjectQuery, useReadVersionsForProjectQuery, useLazyReadVersionsForProjectQuery, useReadLinkedLibrariesForProjectQuery, useLazyReadLinkedLibrariesForProjectQuery, useReadLinkedDevicesForProjectQuery, useLazyReadLinkedDevicesForProjectQuery, useReadProjectViewerProjectQuery, useLazyReadProjectViewerProjectQuery, useReadProjectsByIdsQuery, useLazyReadProjectsByIdsQuery, useReadProjectNamesForRoleRowQuery, useLazyReadProjectNamesForRoleRowQuery, useReadLatestActiveVersionQuery, useLazyReadLatestActiveVersionQuery, useReadLatestVersionQuery, useLazyReadLatestVersionQuery, useCreateTagMutation, useDefineAssetTagsMutation, useDeleteTagMutation, useReadAllTagsQuery, useLazyReadAllTagsQuery, useReadAllFullTagsQuery, useLazyReadAllFullTagsQuery, useReadLinkedTagsForAssetQuery, useLazyReadLinkedTagsForAssetQuery, useCreateVaultMutation, useDeleteVaultMutation, useCreateSecretMutation, useDeleteSecretMutation, useUpdateVaultMutation, useUpdateSecretMutation, useSyncWeakSecretFlagsMutation, useReadAllVaultsQuery, useLazyReadAllVaultsQuery, useReadVaultQuery, useLazyReadVaultQuery, useReadSecretsForVaultQuery, useLazyReadSecretsForVaultQuery, useReadSecretQuery, useLazyReadSecretQuery, useReadSecretUnceiledQuery, useLazyReadSecretUnceiledQuery, useReadAllVaultNamesForPolicyRowQuery, useLazyReadAllVaultNamesForPolicyRowQuery, useReadWeakSecretsSummaryQuery, useLazyReadWeakSecretsSummaryQuery, useReadAllDeviceVulnerabilitiesQuery, useLazyReadAllDeviceVulnerabilitiesQuery, useReadOtCveQuery, useLazyReadOtCveQuery, useReadDeviceVulnerabilitySummaryQuery, useLazyReadDeviceVulnerabilitySummaryQuery, useCreateWorkstationMutation, useUpdateWorkstationMutation, useDeleteWorkstationMutation, useCreateWorkstationConnectionMutation, useDeleteWorkstationConnectionMutation, useReadAllWorkstationsQuery, useLazyReadAllWorkstationsQuery, useReadWorkstationHealthStatusQuery, useLazyReadWorkstationHealthStatusQuery, useReadWorkstationQuery, useLazyReadWorkstationQuery, useReadWorkstationConnectionsQuery, useLazyReadWorkstationConnectionsQuery } = injectedRtkApi;

